import { PESTANAS_OP, entregaDeOP, pestanaDeOP } from "../core/entregaOP.js";
import { botonBitacora } from "./auditoria.js";
import { enSerie } from "../core/enSerie.js";
import { conservarDetalleLineas } from "../core/ocpDetalle.js";
import { aplicarPrecarga, deshacerPrecarga, esPlazoAutogenerado } from "../core/precargaCliente.js";
import { comprimirImagen } from "../core/storage.js";
import { deleteData, fechaCierreVigente, fechaEstaCerrada, saveData, siguienteNumeroDoc, siguienteNumeroRaw } from "../core/cloudSync.js";
import { formatMiles, genId, parsePct, siguienteCodigoProducto } from "../core/utils.js";
import { exportInformeFinalOP, exportPDF } from "../export/pdf.js";
import { showRevalidacionModal } from "./configuracion.js";
import { getSaldoFactura, showVerFactura } from "./facturas.js";
import { renderMaestroFormModal } from "./maestros.js";
import { showConfirmDelete } from "../ui/modals.js";

import { ajustarInventario, anticipoDisponible, apartadosAjenos, calcularRetencionesVenta, comprometidosDe, generarAsientoCobroFactura, generarAsientoNotaCredito, generarAsientoVenta, getComprometidoPorEntregar, getStockDisponible, getStockProducto , registrarCostoEntrega, getCostoPromedio} from "../core/accounting.js";
import { avisoProrrateo, desgloseIVA, renglonesIVA, etiquetaRegimen, hayNoGravados, productoDeArticulo, regimenDeLinea, regimenDeProducto } from "../core/iva.js";
import { componentesDeArticulo, componentesDeLinea, costosDeRemision, descripcionKit, egresosDeRemision, stockDisponibleKit } from "../core/kit.js";
import { costoBaseProducto, descripcionKitCatalogo, esProductoKit, partesCompradasDeKit } from "../core/kitCatalogo.js";
import { sellarAutor } from "../core/autoria.js";
import { registrarPendiente } from "../ui/pendientes.js";
import { editorRicoHTML } from "../ui/editorRico.js";
import { htmlParaMostrar } from "../core/textoRico.js";
import { textoTiempoEntrega } from "../core/tiempoEntrega.js";
import { calcPrecioCatalogoItem, calcPrecioManualItem, costoLineaHTML, costoUnitarioItem, itemConCostosLinea, margenEfectivoLinea, margenFijadoEscala, margenFijadoLinea } from "../ui/actions.js";
import { getParametrosFiscales } from "../core/cloudSync.js";
import { C, DEFAULT_PARAMETROS_FISCALES, DOC_INFO, EMPRESA, ESTADOS, ESTADO_COLOR, ESTADO_PAGO, MEDIOS_DESC_FIN, TECNICAS_IMPRESION } from "../core/config.js";
import { SIN_CONTACTO, contactoImprimible, contactosDe } from "../core/contactos.js";
import { clienteDeDoc, esClienteLibre, nombreClienteDoc } from "../core/terceros.js";
import { lineasValoradasRemision, valorRemision } from "../core/remisionValor.js";
import { aprenderVia, pedirDestinoCostos, sincronizarCxpDirectasOP, terceroDeCosto, viaSugerida } from "./cuentasPagar.js";
import { state } from "../core/state.js";
import { persistirImagenProducto, srcImagenProducto } from "../core/imagenProducto.js";
import { btnStyle, escapeHTML, fmtCOP, fmtDate, inputStyle, normalize, parseNumber, searchBox, thSortable, today, todayCO } from "../core/utils.js";
import { render } from "../ui/app.js";
import { zonaImagenHTML } from "../ui/imagenPegable.js";
import { ocpTotalmenteIngresada } from "./cxp.js";
import { calcularFechaPorDias, calcularMargenTotal } from "./reportes.js";

// La puerta de los impuestos de una causación vive en core (src/core/impuestos.js):
// la usan las facturas de proveedor Y las CxP directas de los costos de una OP,
// y core no puede importar de modules sin cerrar un ciclo. Se re-exporta para
// que quien ya la pedía aquí la siga encontrando.
export { calcularImpuestosCausacion } from "../core/impuestos.js";

export function impuestosResumenRowsHTML(calc) {
  const notaChip = (txt) => `<div style="grid-column:1/3;font-size:9px;color:#b45309;background:#fffbeb;border:1px solid #fde68a;border-radius:5px;padding:2px 6px;margin:-2px 0 2px;">⚠️ ${escapeHTML(txt)}</div>`;
  let rows = `
    <span style="color:#065f46;">Subtotal</span><span style="font-weight:700;text-align:right;">${fmtCOP(calc.sub)}</span>
    <span style="color:${calc.esResponsableIVA?"#065f46":"#94a3b8"};">IVA ${calc.ivaPct}%${calc.esResponsableIVA?"":" — no aplica"}</span>
    <span style="font-weight:700;text-align:right;color:${calc.esResponsableIVA?"#0f172a":"#94a3b8"};">${fmtCOP(calc.iva)}</span>`;
  if (!calc.esResponsableIVA) rows += notaChip(calc.motivoIVANoAplica);
  // Si parte de la compra no causa IVA, hay que DECIRLO: sin esto, el IVA no
  // cuadra con el 19% del subtotal y parece un error de cuenta. Es la compra
  // típica de Mathiz —la matera lleva IVA, la mata viva no— y también lo que
  // permite revisar que el proveedor esté facturando bien.
  if (calc.esResponsableIVA && calc.baseNoGravada > 0) {
    rows += `<span style="color:#92400e;">de los cuales sin IVA</span>` +
      `<span style="text-align:right;color:#92400e;font-weight:700;">${fmtCOP(calc.baseNoGravada)}</span>`;
    rows += notaChip("Parte de esta compra no causa IVA (bienes excluidos o exentos). " +
      "El IVA no es el " + calc.ivaPct + "% del subtotal, y el IVA de un bien excluido tampoco sería descontable.");
  }

  if (calc.rfPct > 0) {
    if (calc.montoRF > 0) {
      rows += `<span style="color:#dc2626;">− ReteFuente ${calc.rfPct}%</span><span style="color:#dc2626;font-weight:700;text-align:right;">${fmtCOP(calc.montoRF)}</span>`;
    } else {
      rows += `<span style="color:#94a3b8;text-decoration:line-through;">ReteFuente ${calc.rfPct}%</span><span style="color:#94a3b8;text-align:right;">$0</span>`;
      rows += notaChip(calc.motivoRFNoAplica);
    }
  }
  if (calc.ricaPct > 0) {
    if (calc.montoRICA > 0) {
      rows += `<span style="color:#dc2626;">− ReteICA ${calc.ricaPct}%</span><span style="color:#dc2626;font-weight:700;text-align:right;">${fmtCOP(calc.montoRICA)}</span>`;
    } else {
      rows += `<span style="color:#94a3b8;text-decoration:line-through;">ReteICA ${calc.ricaPct}%</span><span style="color:#94a3b8;text-align:right;">$0</span>`;
      rows += notaChip(calc.motivoRICANoAplica);
    }
  }
  if (calc.montoRIVA > 0) {
    rows += `<span style="color:#dc2626;">− ReteIVA ${calc.rivaPct}%</span><span style="color:#dc2626;font-weight:700;text-align:right;">${fmtCOP(calc.montoRIVA)}</span>`;
  }
  rows += `
    <span style="font-weight:800;color:#0E7490;font-size:12px;padding-top:5px;border-top:1px solid #6ee7b7;">Neto proveedor</span>
    <span style="font-weight:800;color:#0E7490;font-size:12px;text-align:right;padding-top:5px;border-top:1px solid #6ee7b7;">${fmtCOP(calc.neto)}</span>`;
  return rows;
}

export function getLiquidacionOP(opId) {
  const op = state.data.pedidos.find(p => p.id === opId);
  if (!op) return null;

  // Todas las OCPs de la OP, MENOS las nacidas de un concepto de costo
  // (_fromCosto): el valor de esas ya está contado en otrosCostosTotal, así que
  // sumarlas aquí repetía el mismo costo dos veces y hundía el margen final.
  // Tampoco se listan: en el modal de liquidación ese costo ya aparece como
  // concepto, y mostrarlo además como OCP era el mismo doble por pantalla.
  const ocps = state.data.ocp.filter(o => o._origen && o._origen.id === opId && !o._fromCosto);

  let costoPagado = 0, costoPorPagar = 0;
  ocps.forEach(o => {
    const pagado = getMontoPagadoOCP(o);
    const saldo = getSaldoOCP(o);
    costoPagado += pagado;
    costoPorPagar += saldo;
  });

  const costoOcpTotal = costoPagado + costoPorPagar;

  // Otros costos asociados a la OP (conceptos adicionales: transporte, maquila, etc.)
  const conceptosCosto = op._conceptosCosto || [];
  const otrosCostosTotal = conceptosCosto.reduce((s,c) => s + (parseNumber(c.cantidad)||0) * (parseNumber(c.valor_tercero)||0), 0);

  const costoTotal = costoOcpTotal + otrosCostosTotal;
  const ventaTotal = parseNumber(op.total);
  const utilidad = ventaTotal - costoTotal;
  const margen = ventaTotal > 0 ? (utilidad / ventaTotal) * 100 : 0;

  // Margen inicial: el estimado al cotizar/crear la OP, según el costo de los productos en maestros
  const margenInicialCalc = calcularMargenTotal(op.items);
  const margenInicial = margenInicialCalc ? margenInicialCalc.pct : null;

  return {
    op, ocps, conceptosCosto,
    costoPagado, costoPorPagar, costoOcpTotal, otrosCostosTotal, costoTotal,
    ventaTotal, utilidad, margen, margenInicial
  };
}

export function getPagosOCP(ocp) {
  if (Array.isArray(ocp._pagos)) return ocp._pagos;
  if (ocp._pago) return [{ ...ocp._pago, monto: parseNumber(ocp.total) }];
  return [];
}

export function getMontoPagadoOCP(ocp) {
  return getPagosOCP(ocp).reduce((s,p) => s + parseNumber(p.monto), 0);
}

export function getRetencionesOCP(ocpId) {
  let total = 0;
  (state.data.asientos||[]).forEach(a => {
    if (a.origen && a.origen.tipo === "OCP" && a.origen.id === ocpId) {
      (a.movimientos||[]).forEach(m => {
        if (["2365","2367","2368"].includes(m.cuenta)) total += m.credito;
      });
    }
  });
  return total;
}

export function getMontoExtinguidoOCP(ocp) {
  return getPagosOCP(ocp).reduce((s,p) => s + parseNumber(p.monto) + (parseNumber(p.descuento)||0), 0);
}

export function labelMedioDescFin(medio) {
  const m = MEDIOS_DESC_FIN.find(x => x.value === medio);
  return m ? m.label : (medio||"—");
}

export function getDescuentosFinancieros(prov) {
  if (!prov) return [];
  if (Array.isArray(prov.descuentos_financieros) && prov.descuentos_financieros.length > 0)
    return prov.descuentos_financieros
      .filter(d => parseNumber(d.pct) > 0)
      .map(d => ({ medio:d.medio||"transferencia", label:labelMedioDescFin(d.medio||"transferencia"), pct:parseNumber(d.pct)||0, dias:parseNumber(d.dias)||0 }));
  // backward compat
  return [
    { medio:"transferencia", label:"🏦 Transferencia", pct:parseNumber(prov.desc_fin_transferencia)||0, dias:parseNumber(prov.dias_pago)||0 },
    { medio:"tarjeta",       label:"💳 Tarjeta",       pct:parseNumber(prov.desc_fin_tarjeta)||0,       dias:parseNumber(prov.dias_pago)||0 }
  ].filter(d=>d.pct>0);
}

export function getSaldoOCP(ocp) {
  return Math.max(0, parseNumber(ocp.total) - getRetencionesOCP(ocp.id) - getMontoExtinguidoOCP(ocp));
}

export function getCantidadRemisionadaOP(opId, articulo, excludeRcId) {
  return (state.data.remisiones||[])
    .filter(rc => rc._origen && rc._origen.tipo === "OP" && rc._origen.id === opId && rc.estado !== "cancelada" && rc.id !== excludeRcId)
    .reduce((sum, rc) => sum + (rc.items||[])
      .filter(it => it.articulo === articulo)
      .reduce((s,it) => s + (parseNumber(it.cantidad)||0), 0), 0);
}

// ─── Qué queda por facturar de una OP ────────────────────────────────────────
// Una OP puede facturarse de cuatro maneras: entrega por entrega, todas las
// entregas juntas, o por anticipado (parcial o total) sin haber entregado. Para
// que ninguna cantidad se facture dos veces, todo se mide contra la OP: da igual
// por dónde se haya facturado.
const _mismoArticulo = (a, b) => String(a || "").trim().toLowerCase() === String(b || "").trim().toLowerCase();

// ¿Esta factura cubre cantidades de esta OP? Puede venir de la OP directamente
// (facturación anticipada), de una de sus remisiones, o de varias.
export function facturaCubreOP(f, opId) {
  if (!f || f.estado === "anulada") return false;
  const origenes = [f._origen, ...(Array.isArray(f._origenes) ? f._origenes : [])].filter(Boolean);
  return origenes.some(o => {
    if (o.tipo === "OP") return o.id === opId;
    if (o.tipo === "RC") {
      const rc = (state.data.remisiones || []).find(r => r.id === o.id);
      return !!(rc && rc._origen && rc._origen.tipo === "OP" && rc._origen.id === opId);
    }
    return false;
  });
}

export function getCantidadFacturadaOP(opId, articulo, excluirFactId) {
  return (state.data.facturas || [])
    .filter(f => f.id !== excluirFactId && facturaCubreOP(f, opId))
    .reduce((sum, f) => sum + (f.items || [])
      .filter(it => _mismoArticulo(it.articulo, articulo))
      .reduce((s, it) => s + (parseNumber(it.cantidad) || 0), 0), 0);
}

// Remisiones vivas de una OP, con la marca de si ya están facturadas.
export function remisionesDeOP(opId) {
  return (state.data.remisiones || [])
    .filter(rc => rc._origen && rc._origen.tipo === "OP" && rc._origen.id === opId && rc.estado !== "cancelada")
    .map(rc => ({
      rc,
      facturada: rc.estado === "facturada" ||
        (state.data.facturas || []).some(f => f.estado !== "anulada" &&
          [f._origen, ...(Array.isArray(f._origenes) ? f._origenes : [])]
            .filter(Boolean).some(o => o.tipo === "RC" && o.id === rc.id))
    }));
}

// Línea por línea: qué pidió la OP, qué se entregó, qué se facturó y qué queda.
export function balanceFacturacionOP(op) {
  if (!op) return [];
  return (op.items || []).map(it => {
    const pedido = parseNumber(it.cantidad) || 0;
    const remisionado = getCantidadRemisionadaOP(op.id, it.articulo || "", null);
    const facturado = getCantidadFacturadaOP(op.id, it.articulo || "", null);
    return {
      articulo: it.articulo || "",
      descripcion: it.descripcion || "",
      precio_unitario: parseNumber(it.precio_unitario) || 0,
      pedido, remisionado, facturado,
      porFacturar: Math.max(0, pedido - facturado),
      stock: getStockProducto(it.articulo || ""),
      // Lo que otras facturas ya vendieron y todavía no ha salido de bodega: hay
      // en el kardex, pero tiene dueño. Lo comprometido por esta misma orden no
      // cuenta, que para eso se facturó.
      comprometido: getComprometidoPorEntregar(it.articulo || "", op.id),
      disponible: getStockDisponible(it.articulo || "", op.id)
    };
  });
}

export function getConvertedToList(d) {
  if (Array.isArray(d._convertedTo)) return d._convertedTo;
  if (d._convertedTo && d._convertedTo.id) return [d._convertedTo];
  return [];
}

export function getTotalCxP() {
  return state.data.ocp
    .filter(o => o.estado !== "cancelada")
    .reduce((s, o) => s + getSaldoOCP(o), 0);
}

export function getTotalPagado() {
  return state.data.ocp
    .reduce((s, o) => s + getMontoPagadoOCP(o), 0);
}

// ─── El hilo de un costo asociado ───────────────────────────────────────────
// Qué documento nació de este costo: la orden de compra al proveedor, o la
// cuenta por pagar directa y —si ya se legalizó— su cuenta de cobro.
export function docsDeCosto(c) {
  const ocp = c._ocpId ? (state.data.ocp || []).find(o => o.id === c._ocpId) || null : null;
  const cxp = c._cxpId ? (state.data.cuentas_pagar || []).find(x => x.id === c._cxpId) || null : null;
  const cc = cxp && cxp._cuentaCobroId
    ? (state.data.cuentas_cobro || []).find(k => k.id === cxp._cuentaCobroId) || null : null;
  return { ocp, cxp, cc };
}

export function documentoDeCosto(c) {
  const { ocp, cxp, cc } = docsDeCosto(c);
  if (ocp) {
    return `<span data-action="ir-a-documento" data-tipo="OCP" data-id="${ocp.id}"
      style="color:#0F766E;font-weight:700;cursor:pointer;text-decoration:underline;">🛒 ${escapeHTML(ocp.numero || "")}</span>`;
  }
  if (cxp) {
    return `<span style="color:#0F766E;font-weight:700;">🧾 ${escapeHTML(cxp.numero || "")}</span>`
      + (cc ? `<div style="font-size:9.5px;color:${C.muted};">${escapeHTML(cc.numero || "")}</div>`
            : `<div style="font-size:9.5px;color:#b45309;">pendiente de cuenta de cobro</div>`);
  }
  return `<span style="color:${C.muted};">—</span>`;
}

export function renderDetalleOP(opId) {
  const op = state.data.pedidos.find(o => o.id === opId);
  if (!op) return "<div>OP no encontrada</div>";
  
  const cliente = state.data.clientes.find(c => c.id === op.cliente_id) || {};
  const cotizacion = (state.data.cotizaciones || []).find(ct => ct.id === op._origen?.id);
  const remisiones = (state.data.remisiones || []).filter(rc => rc._origen && rc._origen.id === op.id);
  
  // Calcular costos (nuevo esquema: lista de conceptos; fallback al esquema anterior si existe)
  const conceptosCosto = op._conceptosCosto || [];
  const totalConceptos = conceptosCosto.reduce((s,c) => s + (parseNumber(c.cantidad)||0) * (parseNumber(c.valor_tercero)||0), 0);
  const legacyTotal = (parseNumber(op._costoMateriales)||0) + (parseNumber(op._costoManoObra)||0) + (parseNumber(op._costoOtros)||0);
  const costosOP = {
    conceptos: conceptosCosto,
    total: conceptosCosto.length > 0 ? totalConceptos : legacyTotal
  };
  
  const header = `
    <div style="margin-bottom:10px;">
      <button data-action="volver-reportes" style="background:#4C5FA8;border:none;color:white;padding:8px 16px;border-radius:6px;margin-bottom:12px;cursor:pointer;font-weight:700;">← Volver a Reportes</button>
      <h2 style="margin:0 0 6px;font-size:16px;color:${C.text};font-weight:700;">🔗 Trazabilidad Completa: ${escapeHTML(op.numero)}</h2>
      <p style="margin:0;color:${C.muted};font-size:11.5px;">Detalles de documentos vinculados, líneas y costos</p>
    </div>
  `;

  // Información de OP con hipervínculo a Cotización
  const infoOP = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:10px;">
      <h3 style="margin:0 0 12px;font-size:12px;color:${C.text};font-weight:700;">📋 ORDEN DE PRODUCCIÓN</h3>
      
      <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:9px;margin-bottom:10px;">
        <div>
          <div style="font-size:10.5px;color:${C.muted};font-weight:700;margin-bottom:4px;">NÚMERO</div>
          <div style="font-size:14px;font-weight:700;color:#4C5FA8;">${escapeHTML(op.numero)}</div>
        </div>
        <div>
          <div style="font-size:10.5px;color:${C.muted};font-weight:700;margin-bottom:4px;">FECHA</div>
          <div style="font-size:14px;font-weight:700;color:${C.text};">${escapeHTML(fmtDate(op.fecha))}</div>
        </div>
        <div>
          <div style="font-size:10.5px;color:${C.muted};font-weight:700;margin-bottom:4px;">CLIENTE</div>
          <div style="font-size:14px;font-weight:700;color:${C.text};">${escapeHTML(cliente.nombre || "—")}</div>
        </div>
        <div>
          <div style="font-size:10.5px;color:${C.muted};font-weight:700;margin-bottom:4px;">ESTADO</div>
          <div style="font-size:14px;">
            <span style="background:${ESTADO_COLOR[op.estado]}20;color:${ESTADO_COLOR[op.estado]};padding:3px 9px;border-radius:6px;font-size:10.5px;font-weight:700;display:inline-block;">
              ${(ESTADOS.OP && ESTADOS.OP[op.estado]) || op.estado}
            </span>
          </div>
        </div>
      </div>

      ${cotizacion ? `
        <div style="padding:9px;background:#f8fafc;border-left:3px solid #2B4A82;border-radius:4px;margin-bottom:12px;">
          <div style="font-size:10.5px;color:${C.muted};font-weight:700;margin-bottom:4px;">📄 COTIZACIÓN ORIGEN</div>
          <button data-action="ver-documento-detalle" data-tipo="CT" data-id="${cotizacion.id}" 
                  style="background:none;border:none;color:#2B4A82;font-weight:700;cursor:pointer;text-decoration:underline;font-size:12px;">
            ${escapeHTML(cotizacion.numero)} - ${escapeHTML(fmtDate(cotizacion.fecha))} [Ver documento]
          </button>
        </div>
      ` : ''}

      <div style="padding:9px;background:#f8fafc;border-left:3px solid #10b981;border-radius:4px;">
        <div style="font-size:10.5px;color:${C.muted};font-weight:700;margin-bottom:8px;">💰 COSTOS ASOCIADOS</div>
        ${costosOP.conceptos.length > 0 ? `
          <table style="width:100%;border-collapse:collapse;font-size:11.5px;margin-bottom:8px;">
            <thead><tr style="background:#ecfdf5;">
              <th style="padding:4px 6px;text-align:left;font-size:10px;color:${C.muted};">Concepto</th>
              <th style="padding:4px 6px;text-align:left;font-size:10px;color:${C.muted};">Tercero</th>
              <th style="padding:4px 6px;text-align:right;font-size:10px;color:${C.muted};">Cant.</th>
              <th style="padding:4px 6px;text-align:right;font-size:10px;color:${C.muted};">Valor Tercero</th>
              <th style="padding:4px 6px;text-align:right;font-size:10px;color:${C.muted};">Total</th>
              ${/* El hilo del costo: una vez que la orden generó documentos
                    queda bloqueada para edición, así que el número de la orden
                    de compra o de la cuenta por pagar que nació de cada costo
                    solo se podía ver entrando al otro módulo a buscarlo. */ ""}
              <th style="padding:4px 6px;text-align:left;font-size:10px;color:${C.muted};">Generó</th>
            </tr></thead>
            <tbody>
              ${costosOP.conceptos.map(c => `
                <tr style="border-top:1px solid ${C.border};">
                  <td style="padding:4px 6px;">${escapeHTML(c.concepto||"—")}</td>
                  <td style="padding:4px 6px;">${escapeHTML(c.proveedor_nombre||"—")}</td>
                  <td style="padding:4px 6px;text-align:right;">${c.cantidad||0}</td>
                  <td style="padding:4px 6px;text-align:right;">${fmtCOP(c.valor_tercero)}</td>
                  <td style="padding:4px 6px;text-align:right;font-weight:700;">${fmtCOP((parseNumber(c.cantidad)||0)*(parseNumber(c.valor_tercero)||0))}</td>
                  <td style="padding:4px 6px;font-size:10.5px;">${documentoDeCosto(c)}</td>
                </tr>
              `).join("")}
            </tbody>
          </table>
        ` : `<div style="font-size:11.5px;color:${C.muted};margin-bottom:8px;">Sin conceptos de costo registrados.</div>`}
        <div style="border-top:2px solid #10b981;padding-top:8px;text-align:right;">
          <span style="color:${C.muted};font-size:10px;">TOTAL COSTOS&nbsp;</span>
          <span style="font-weight:700;color:#10b981;font-size:12px;">${fmtCOP(costosOP.total)}</span>
        </div>
      </div>
    </div>
  `;

  // Detalles de líneas de OP
  const lineasOP = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:10px;">
      <h3 style="margin:0 0 12px;font-size:12px;color:${C.text};font-weight:700;">📦 LÍNEAS DE LA OP (${(op.items || []).length} líneas)</h3>
      
      <div style="overflow-x:auto;">
        <table style="width:100%;border-collapse:collapse;font-size:11.5px;">
          <thead>
            <tr style="background:#f1f5f9;">
              <th style="padding:8px;text-align:left;font-size:10px;font-weight:700;color:${C.text};">Artículo</th>
              <th style="padding:8px;text-align:left;font-size:10px;font-weight:700;color:${C.text};">Descripción</th>
              <th style="padding:8px;text-align:right;font-size:10px;font-weight:700;color:${C.text};">Cantidad OP</th>
              <th style="padding:8px;text-align:right;font-size:10px;font-weight:700;color:${C.text};">Remisonada</th>
              <th style="padding:8px;text-align:right;font-size:10px;font-weight:700;color:${C.text};">Facturada</th>
              <th style="padding:8px;text-align:right;font-size:10px;font-weight:700;color:${C.text};">Pendiente</th>
            </tr>
          </thead>
          <tbody>
            ${(op.items || []).map(item => {
              const cantOP = parseNumber(item.cantidad) || 0;
              const cantRemisonada = remisiones.reduce((sum, rc) => {
                const it = (rc.items || []).find(ri => 
                  normalize(ri.articulo || ri.descripcion) === normalize(item.articulo || item.descripcion)
                );
                return sum + (it ? parseNumber(it.cantidad) : 0);
              }, 0);
              const cantFacturada = parseNumber(item._cantidadFacturada) || 0;
              const cantPendiente = cantOP - cantRemisonada;
              
              return `
                <tr style="border-top:1px solid ${C.border};">
                  <td style="padding:8px;"><strong>${escapeHTML(item.articulo || "—")}</strong></td>
                  <td style="padding:8px;">${escapeHTML(item.descripcion || "—")}</td>
                  <td style="padding:8px;text-align:right;"><strong>${cantOP}</strong></td>
                  <td style="padding:8px;text-align:right;color:#10b981;"><strong>${cantRemisonada}</strong></td>
                  <td style="padding:8px;text-align:right;color:#4C5FA8;"><strong>${cantFacturada}</strong></td>
                  <td style="padding:8px;text-align:right;color:${cantPendiente > 0 ? '#f59e0b' : '#10b981'};"><strong>${cantPendiente}</strong></td>
                </tr>
              `;
            }).join('')}
          </tbody>
        </table>
      </div>
    </div>
  `;

  // Remisiones asociadas con hipervínculos
  const remisionesSection = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:10px;">
      <h3 style="margin:0 0 12px;font-size:12px;color:${C.text};font-weight:700;">📮 REMISIONES ASOCIADAS (${remisiones.length})</h3>
      
      ${remisiones.length === 0 ? `
        <div style="padding:11px;text-align:center;color:${C.muted};background:#f8fafc;border-radius:6px;">
          <div style="font-size:17px;margin-bottom:8px;">📮</div>
          Sin remisiones aún
        </div>
      ` : `
        <div style="display:flex;flex-direction:column;gap:9px;">
          ${remisiones.map((rc, idx) => `
            <div style="border:1px solid ${C.border};border-radius:6px;padding:9px;background:#f8fafc;">
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;">
                <div>
                  <button data-action="ver-documento-detalle" data-tipo="RC" data-id="${rc.id}"
                          style="background:none;border:none;color:#0E7490;font-weight:700;cursor:pointer;text-decoration:underline;font-size:11.5px;">
                    ${escapeHTML(rc.numero)} [Ver documento]
                  </button>
                  <div style="font-size:10.5px;color:${C.muted};margin-top:2px;">${escapeHTML(fmtDate(rc.fecha))}</div>
                </div>
                <div style="text-align:right;">
                  ${rc._factura ? `
                    <button data-action="ver-documento-detalle" data-tipo="FACT" data-numero="${escapeHTML(rc._factura.numero)}"
                            style="background:#d1fae5;border:none;color:#065f46;padding:3px 9px;border-radius:6px;font-size:10px;font-weight:700;cursor:pointer;">
                      ✅ ${escapeHTML(rc._factura.numero)}
                    </button>
                  ` : `
                    <div style="background:#fef3c7;color:#92400e;padding:3px 9px;border-radius:6px;font-size:10px;font-weight:700;">
                      ⏳ Pendiente
                    </div>
                  `}
                </div>
              </div>
              
              <div style="font-size:10.5px;color:${C.muted};margin-bottom:8px;padding-top:8px;border-top:1px solid ${C.border};">
                <strong>Líneas remisionadas (${(rc.items || []).length} líneas):</strong>
              </div>
              
              <table style="width:100%;font-size:10.5px;border-collapse:collapse;">
                <tr style="background:#f1f5f9;">
                  <th style="padding:6px;text-align:left;border:1px solid ${C.border};font-size:10px;">Artículo</th>
                  <th style="padding:6px;text-align:right;border:1px solid ${C.border};font-size:10px;">Cantidad</th>
                  <th style="padding:6px;text-align:left;border:1px solid ${C.border};font-size:10px;">Observaciones</th>
                </tr>
                ${(rc.items || []).map(it => `
                  <tr>
                    <td style="padding:6px;border:1px solid ${C.border};">${escapeHTML(it.articulo || it.descripcion)}</td>
                    <td style="padding:6px;border:1px solid ${C.border};text-align:right;"><strong>${parseNumber(it.cantidad)}</strong></td>
                    <td style="padding:6px;border:1px solid ${C.border};">${escapeHTML(it.observaciones || "—")}</td>
                  </tr>
                `).join('')}
              </table>
            </div>
          `).join('')}
        </div>
      `}
    </div>
  `;

  // Documentos adjuntos
  const documentosSection = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:10px;">
      <h3 style="margin:0 0 12px;font-size:12px;color:${C.text};font-weight:700;">📎 DOCUMENTOS ADJUNTOS</h3>
      
      ${!op._documentos || op._documentos.length === 0 ? `
        <div style="padding:11px;text-align:center;color:${C.muted};background:#f8fafc;border-radius:6px;">
          <div style="font-size:17px;margin-bottom:8px;">📄</div>
          Sin documentos cargados
        </div>
      ` : `
        <div style="display:grid;gap:8px;">
          ${(op._documentos || []).map(doc => `
            <div style="display:flex;justify-content:space-between;align-items:center;padding:8px;background:#f8fafc;border-radius:6px;border:1px solid ${C.border};">
              <div>
                <div style="font-size:11.5px;font-weight:700;color:${C.text};">
                  ${doc.tipo === 'pdf' ? '📄' : '🖼️'} ${escapeHTML(doc.nombre)}
                </div>
                <div style="font-size:10.5px;color:${C.muted};margin-top:2px;">${escapeHTML(doc.tipo.toUpperCase())} • ${escapeHTML(fmtDate(doc.fechaCarga))}</div>
              </div>
              <div style="text-align:right;">
                <button style="background:#e5e7eb;border:none;color:#374151;padding:4px 12px;border-radius:4px;font-size:10.5px;font-weight:700;cursor:pointer;">
                  👁️ Ver
                </button>
              </div>
            </div>
          `).join('')}
        </div>
      `}
    </div>
  `;

  return header + infoOP + lineasOP + remisionesSection + documentosSection;
}

// El valor por facturar de una remisión vive en core (core/remisionValor.js),
// porque el informe de remisiones sin facturar necesita la MISMA cifra: cuando
// cada módulo la calculaba a su manera, discreparon — el panel devolvía el
// total de la orden entera para cada entrega parcial.
export { lineasValoradasRemision, valorRemision };

// Días transcurridos desde la fecha de la remisión (en horario Colombia).
function diasRemision(rc) {
  const base = new Date((rc.fecha || todayCO()) + "T12:00:00");
  const hoy = new Date(todayCO() + "T12:00:00");
  return Math.max(0, Math.floor((hoy - base) / (1000 * 60 * 60 * 24)));
}

// Semáforo de antigüedad: una remisión no debería pasar de 8 días sin
// facturarse. 0-4 verde, 5-8 amarillo (por vencer), >8 rojo (crítica).
function criticidadRemision(dias) {
  return dias > 8 ? { k: "critica", color: "#dc2626", label: "Crítica" }
    : dias >= 5 ? { k: "porvencer", color: "#d97706", label: "Por vencer" }
    : { k: "reciente", color: "#16a34a", label: "Reciente" };
}

// Aviso breve tipo "toast" abajo al centro. Se autodescarta a los 4s.
function avisoFugaz(msg) {
  try {
    let el = document.getElementById("__aviso_fugaz");
    if (!el) {
      el = document.createElement("div");
      el.id = "__aviso_fugaz";
      el.style.cssText = "position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:#0f172a;color:white;font-size:12px;font-weight:600;padding:10px 16px;border-radius:22px;box-shadow:0 8px 24px rgba(0,0,0,.25);z-index:2000;max-width:90vw;text-align:center;";
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.style.transition = "";
    el.style.opacity = "1";
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.style.transition = "opacity .4s"; el.style.opacity = "0"; }, 4000);
  } catch { /* sin DOM */ }
}

// Abre la carpeta de OneDrive con las remisiones escaneadas y copia al
// portapapeles el nombre esperado del archivo (número + tercero) para pegarlo
// en el buscador de la carpeta. No se puede enlazar al archivo puntual porque
// el enlace público de OneDrive apunta a la carpeta compartida, no a rutas
// internas; el usuario mantiene la organización asesor/fecha convenida.
export function abrirRSEscaneada(rc) {
  const url = (EMPRESA.rsEscaneadasUrl || "").trim();
  if (!url) {
    alert("Aún no has configurado la carpeta de RS escaneadas.\n\nVe a Configuración → “RS escaneadas (OneDrive)” y pega el enlace público de la carpeta.");
    return;
  }
  const cli = (state.data.clientes || []).find(c => c.id === rc.cliente_id) || {};
  const nombreArchivo = `${rc.numero || ""} ${cli.nombre || ""}`.trim();
  try { if (navigator.clipboard && nombreArchivo) navigator.clipboard.writeText(nombreArchivo); } catch { /* portapapeles no disponible */ }
  try { window.open(url, "_blank", "noopener"); } catch { /* bloqueo de popups */ }
  avisoFugaz(nombreArchivo
    ? `📎 Abriendo OneDrive. Copié «${nombreArchivo}» — pégalo en el buscador de la carpeta.`
    : "📎 Abriendo la carpeta de RS escaneadas en OneDrive.");
}

// Panel de control: remisiones ENTREGADAS que aún NO se han facturado.
// Se ubica arriba de la lista de Remisiones. Agrupa por asesor, con semáforo
// de antigüedad, valor por facturar y acceso directo a facturar.
export function panelRemisionesSinFacturar() {
  const pendientes = (state.data.remisiones || [])
    .filter(r => ["entregada", "completada"].includes(r.estado))
    .map(r => {
      const cli = (state.data.clientes || []).find(c => c.id === r.cliente_id) || {};
      const origen = r._origen && r._origen.tipo ? (state.data[DOC_INFO[r._origen.tipo].key] || []).find(d => d.id === r._origen.id) : null;
      const asesor = r.asesor_comercial || (origen && origen.asesor_comercial) || "Sin asesor asignado";
      const dias = diasRemision(r);
      return { rc: r, cliente: cli.nombre || "—", asesor, dias, crit: criticidadRemision(dias), valor: valorRemision(r) };
    });

  const valorTotal = pendientes.reduce((s, p) => s + p.valor, 0);
  const criticas = pendientes.filter(p => p.crit.k === "critica").length;

  // La selección para facturar juntas. Se descarta lo que ya no esté pendiente
  // (facturado desde otra pantalla), para no arrastrar una entrega ya cobrada.
  if (!state._rsFactSel) state._rsFactSel = {};
  const sel = state._rsFactSel;
  const vivas = new Set(pendientes.map(p => p.rc.id));
  Object.keys(sel).forEach(id => { if (!vivas.has(id)) delete sel[id]; });

  if (pendientes.length === 0) {
    return `
      <div style="background:#ecfdf5;border:1px solid #86efac;border-radius:8px;padding:12px 14px;margin-bottom:10px;">
        <div style="font-weight:800;color:#065f46;font-size:12.5px;">✅ Todo al día: no hay remisiones sin facturar</div>
        <div style="font-size:11px;color:#047857;margin-top:2px;">Cada remisión entregada ya fue facturada. Aquí aparecerán las que queden pendientes.</div>
      </div>`;
  }

  // Agrupar por asesor
  const porAsesor = new Map();
  pendientes.forEach(p => { if (!porAsesor.has(p.asesor)) porAsesor.set(p.asesor, []); porAsesor.get(p.asesor).push(p); });

  const abierto = state._panelRSFacturarAbierto !== false; // abierto por defecto

  const grupos = [...porAsesor.entries()].map(([asesor, lista]) => {
    lista.sort((a, b) => b.dias - a.dias);
    const subtotal = lista.reduce((s, p) => s + p.valor, 0);
    const critG = lista.filter(p => p.crit.k === "critica").length;
    const filas = lista.map(p => `
      <tr style="border-top:1px solid ${C.border};${sel[p.rc.id] ? "background:rgba(16,185,129,.10);" : ""}">
        ${/* Varias entregas de la misma orden se pueden facturar JUNTAS, en una
              sola factura: se marcan aquí y el botón de abajo las agrupa. */ ""}
        <td style="padding:5px 4px 5px 9px;">
          <input type="checkbox" data-action="rs-panel-toggle" data-id="${p.rc.id}" ${sel[p.rc.id] ? "checked" : ""}
            title="Marcar para facturar junto con otras entregas del mismo cliente"
            style="width:15px;height:15px;cursor:pointer;"/>
        </td>
        <td style="padding:5px 9px;"><span title="${p.dias} día${p.dias === 1 ? "" : "s"} · ${p.crit.label}" style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${p.crit.color};"></span></td>
        <td style="padding:5px 9px;font-weight:600;color:${C.text};">${escapeHTML(p.cliente)}</td>
        <td style="padding:5px 9px;color:#0E7490;font-weight:700;">${escapeHTML(p.rc.numero)}</td>
        <td style="padding:5px 9px;color:${C.muted};">${escapeHTML(fmtDate(p.rc.fecha))}</td>
        <td style="padding:5px 9px;text-align:center;font-weight:700;color:${p.crit.color};">${p.dias}d</td>
        <td style="padding:5px 9px;text-align:right;font-weight:700;color:${C.text};">${fmtCOP(p.valor)}</td>
        <td style="padding:5px 9px;text-align:right;white-space:nowrap;">
          <button data-action="ver-rs-escaneada" data-id="${p.rc.id}" style="${btnStyle(null,"ghost",true)}" title="Abrir la RS escaneada en OneDrive">📎</button>
          <button data-action="ir-a-documento" data-tipo="RC" data-id="${p.rc.id}" style="${btnStyle(null,"ghost",true)}" title="Ver remisión">👁</button>
          <button data-action="facturar-rc" data-id="${p.rc.id}" style="${btnStyle("#10b981",null,true)}" title="Facturar con Dataico">💰 Facturar</button>
        </td>
      </tr>`).join("");
    return `
      <div style="margin-top:8px;border:1px solid ${C.border};border-radius:8px;overflow:hidden;">
        <div style="display:flex;justify-content:space-between;align-items:center;background:#f8fafc;padding:7px 11px;">
          <div style="font-size:11.5px;font-weight:800;color:${C.text};">🧑‍💼 ${escapeHTML(asesor)} <span style="font-weight:500;color:${C.muted};">· ${lista.length} remisi${lista.length === 1 ? "ón" : "ones"}</span>${critG ? ` <span style="color:#dc2626;font-weight:700;">· 🔴 ${critG} crítica${critG === 1 ? "" : "s"}</span>` : ""}</div>
          <div style="font-size:12px;font-weight:800;color:#0E7490;">${fmtCOP(subtotal)}</div>
        </div>
        <table style="width:100%;border-collapse:collapse;font-size:11px;">
          <tbody>${filas}</tbody>
        </table>
      </div>`;
  }).join("");

  // ─── Facturar varias entregas en UNA factura ─────────────────────────────
  // Es lo natural cuando una orden se entrega en varios viajes: el cliente
  // quiere una sola factura. Una factura es de UN cliente, así que mezclar
  // clientes se bloquea aquí y se explica (planDesdeRemisiones lo reafirma).
  const marcadas = pendientes.filter(p => sel[p.rc.id]);
  const clientesSel = [...new Set(marcadas.map(p => p.rc.cliente_id || ""))];
  const totalSel = marcadas.reduce((s, p) => s + p.valor, 0);
  const mezcla = clientesSel.length > 1;
  const barraSeleccion = !marcadas.length ? `
    <div style="margin-top:9px;font-size:10.5px;color:${C.muted};">
      💡 Marca dos o más entregas del mismo cliente para facturarlas en una sola factura.
    </div>` : `
    <div style="margin-top:9px;display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap;
                background:${mezcla ? "#fef2f2" : "rgba(16,185,129,.10)"};border:1px solid ${mezcla ? "#fca5a5" : "#86efac"};
                border-radius:8px;padding:8px 11px;">
      <div style="font-size:11.5px;color:${C.text};">
        <strong>${marcadas.length} entrega${marcadas.length === 1 ? "" : "s"}</strong>
        · ${escapeHTML(marcadas.map(p => p.rc.numero).join(" + "))}
        · <strong>${fmtCOP(totalSel)}</strong>
        ${mezcla ? `<div style="font-size:10.5px;color:#991b1b;font-weight:700;margin-top:2px;">
            ⛔ Son de clientes distintos (${escapeHTML(marcadas.map(p => p.cliente).filter((v, i, a) => a.indexOf(v) === i).join(", "))}). Una factura es de un solo cliente.
          </div>` : ""}
      </div>
      <div style="display:flex;gap:7px;">
        <button data-action="rs-panel-limpiar" style="${btnStyle(null, "secondary", true)}">Quitar selección</button>
        <button data-action="rs-panel-facturar" ${mezcla ? "disabled" : ""}
          style="${btnStyle(mezcla ? null : "#10b981", mezcla ? "secondary" : null, true)}${mezcla ? "opacity:.55;cursor:not-allowed;" : ""}">
          💰 Facturar ${marcadas.length === 1 ? "esta entrega" : "las " + marcadas.length + " juntas"}
        </button>
      </div>
    </div>`;

  const kpi = (icono, valor, label, color) => `
    <div style="flex:1;min-width:120px;background:white;border:1px solid ${C.border};border-radius:8px;padding:9px 11px;">
      <div style="font-size:10px;color:${C.muted};font-weight:700;">${icono} ${label}</div>
      <div style="font-size:16px;font-weight:800;color:${color};margin-top:2px;">${valor}</div>
    </div>`;

  return `
    <div id="panel-rs-facturar" style="background:linear-gradient(135deg,#0E749010,#ffffff);border:1px solid #0E749040;border-radius:10px;padding:12px;margin-bottom:12px;">
      <div data-action="toggle-panel-rs-facturar" style="display:flex;justify-content:space-between;align-items:center;cursor:pointer;">
        <h3 style="margin:0;font-size:13.5px;font-weight:800;color:#0E7490;">📮 Control de remisiones sin facturar</h3>
        <span style="font-size:11px;color:${C.muted};">${abierto ? "▲ ocultar" : "▼ mostrar"}</span>
      </div>
      ${abierto ? `
        <div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:10px;">
          ${kpi("💰", fmtCOP(valorTotal), "Valor por facturar", "#0E7490")}
          ${kpi("📮", pendientes.length, "Remisiones pendientes", C.text)}
          ${kpi("🔴", criticas, "Críticas (más de 8 días)", criticas ? "#dc2626" : "#16a34a")}
        </div>
        <div style="font-size:10px;color:${C.muted};margin-top:8px;">🟢 menos de 5 días · 🟡 5 a 8 días · 🔴 más de 8 días. Una remisión no debería pasar de 8 días sin facturarse.</div>
        ${grupos}
        ${barraSeleccion}
      ` : ""}
    </div>`;
}

export function renderDocModule(tipo) {
  const info = DOC_INFO[tipo];
  const allDocs = state.data[info.key] || [];

  // Filtros avanzados
  if (!state.docFilters) state.docFilters = {};
  if (!state.docFilters[tipo]) state.docFilters[tipo] = { estado:"", desde:"", hasta:"", tercero:"" };
  const filtros = state.docFilters[tipo];
  if (!state.docFiltersOpen) state.docFiltersOpen = {};

  // Filtrar por búsqueda
  const query = (state.searches.docs && state.searches.docs[tipo]) || "";
  const docs = allDocs.filter(d => {
    const target = tipo === "OCP"
      ? state.data.proveedores.find(p => p.id === d.proveedor_id)
      : clienteDeDoc(d);

    if (query.trim()) {
      const q = normalize(query);
      const matches = normalize(d.numero).includes(q)
          || normalize(target ? target.nombre : "").includes(q)
          || normalize(target ? target.nit : "").includes(q)
          || normalize(d.fecha).includes(q)
          || normalize(d.estado).includes(q);
      if (!matches) return false;
    }

    if (filtros.estado && (d.estado||"borrador") !== filtros.estado) return false;
    if (filtros.desde && d.fecha < filtros.desde) return false;
    if (filtros.hasta && d.fecha > filtros.hasta) return false;
    if (filtros.tercero) {
      const terceroId = tipo === "OCP" ? d.proveedor_id : d.cliente_id;
      if (terceroId !== filtros.tercero) return false;
    }
    return true;
  });

  // ─── Orden de la lista (por defecto: más nuevo primero) ─────────────────
  if (!state.docSort) state.docSort = {};
  if (!state.docSort[tipo]) state.docSort[tipo] = { field:"fecha", dir:"desc" };
  const sortCfg = state.docSort[tipo];

  const getTerceroNombre = (d) => {
    if (tipo !== "OCP") return nombreClienteDoc(d, "");
    const t = state.data.proveedores.find(p => p.id === d.proveedor_id);
    return t ? t.nombre : "";
  };

  docs.sort((a,b) => {
    let va, vb;
    switch (sortCfg.field) {
      case "numero": va = a.numero||""; vb = b.numero||""; break;
      case "tercero": va = normalize(getTerceroNombre(a)); vb = normalize(getTerceroNombre(b)); break;
      case "estado": va = (ESTADOS[tipo]||{})[a.estado||"borrador"] || a.estado||""; vb = (ESTADOS[tipo]||{})[b.estado||"borrador"] || b.estado||""; break;
      case "total": va = parseNumber(a.total)||0; vb = parseNumber(b.total)||0; break;
      case "fecha": default: va = a.fecha||""; vb = b.fecha||""; break;
    }
    let cmp = (typeof va === "number") ? (va - vb) : String(va).localeCompare(String(vb));
    // Desempate estable por número de documento (más reciente primero por defecto)
    if (cmp === 0 && sortCfg.field !== "numero") cmp = String(a.numero||"").localeCompare(String(b.numero||""));
    return sortCfg.dir === "asc" ? cmp : -cmp;
  });

  // ─── Órdenes de producción: pestañas por lo que ya se entregó ───────────
  // «En proceso» = vigente y con algo por entregar (también la parcial);
  // «Remisionadas» = todo lo pedido ya salió en remisiones. Se decide con
  // entregaDeOP (core/entregaOP.js): el estado de la OP no sirve, todas las
  // vigentes están «completada». Los conteos respetan la búsqueda y los filtros.
  const entregas = tipo === "OP" ? new Map(docs.map(d => [d.id, entregaDeOP(d, state.data.remisiones)])) : null;
  let pestanasUI = "";
  const pestanaOP = tipo === "OP" ? (state.opPestana || "todas") : "todas";
  if (tipo === "OP") {
    const cuenta = { todas: docs.length, en_proceso: 0, remisionadas: 0 };
    docs.forEach(d => { const k = pestanaDeOP(d, entregas.get(d.id)); if (k) cuenta[k]++; });
    if (pestanaOP !== "todas") {
      const quedan = docs.filter(d => pestanaDeOP(d, entregas.get(d.id)) === pestanaOP);
      docs.length = 0; docs.push(...quedan);
    }
    pestanasUI = `
      <div data-op-pestanas style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:12px;">
        ${PESTANAS_OP.map(t => {
          const activa = t.id === pestanaOP;
          return `<button data-action="op-pestana" data-pestana="${t.id}" data-op-pestana="${t.id}"
            style="padding:7px 14px;border-radius:20px;font-size:12px;font-weight:700;cursor:pointer;
              border:1px solid ${activa ? info.color : C.border};background:${activa ? info.color : "white"};color:${activa ? "white" : C.text};">
            ${t.icon} ${t.label} <span style="opacity:.8;font-weight:600;">(${cuenta[t.id]})</span></button>`;
        }).join("")}
      </div>
      ${pestanaOP === "en_proceso" ? `<div style="font-size:10.5px;color:${C.muted};margin:-6px 0 10px;">Órdenes vigentes con mercancía por entregar, también las entregadas a medias. Los borradores y las canceladas solo están en «Todas».</div>` : ""}
      ${pestanaOP === "remisionadas" ? `<div style="font-size:10.5px;color:${C.muted};margin:-6px 0 10px;">Órdenes cuya mercancía ya salió completa en remisiones (sin contar remisiones en borrador ni canceladas).</div>` : ""}`;
  }

  const header = `
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:9px;padding-bottom:10px;border-bottom:3px solid ${info.color};">
      <div style="display:flex;gap:10px;align-items:center;">
        <img src="${window.LOGO}" alt="Aura" style="height:42px;object-fit:contain;"/>
        <div>
          <h2 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">${info.plural}</h2>
          <p style="margin:3px 0 0;color:${C.muted};font-size:11.5px;">${info.code}</p>
        </div>
      </div>
      <button data-action="new-doc" data-tipo="${tipo}" style="${btnStyle(info.color)}">+ Nueva ${info.label}</button>
    </div>
  `;

  // Búsqueda + filtros avanzados (solo si hay docs)
  const tieneFiltrosActivos = filtros.estado || filtros.desde || filtros.hasta || filtros.tercero;
  const terceros = tipo === "OCP" ? (state.data.proveedores||[]) : (state.data.clientes||[]);
  const filtersPanel = state.docFiltersOpen[tipo] ? `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:10px;margin-bottom:12px;display:flex;gap:10px;flex-wrap:wrap;align-items:flex-end;">
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Estado</label>
        <select style="${inputStyle}width:160px;cursor:pointer;" onchange="state.docFilters['${tipo}'].estado=this.value;render();">
          <option value="">Todos</option>
          ${Object.entries(ESTADOS[tipo]||{}).map(([k,v])=>`<option value="${k}" ${filtros.estado===k?"selected":""}>${v}</option>`).join("")}
        </select>
      </div>
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Desde</label>
        <input type="date" value="${filtros.desde}" style="${inputStyle}width:140px;" onchange="state.docFilters['${tipo}'].desde=this.value;render();"/>
      </div>
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Hasta</label>
        <input type="date" value="${filtros.hasta}" style="${inputStyle}width:140px;" onchange="state.docFilters['${tipo}'].hasta=this.value;render();"/>
      </div>
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">${tipo==="OCP"?"Proveedor":"Cliente"}</label>
        <select style="${inputStyle}width:200px;cursor:pointer;" onchange="state.docFilters['${tipo}'].tercero=this.value;render();">
          <option value="">Todos</option>
          ${terceros.map(t=>`<option value="${t.id}" ${filtros.tercero===t.id?"selected":""}>${escapeHTML(t.nombre)}</option>`).join("")}
        </select>
      </div>
      ${tieneFiltrosActivos ? `<button data-action="limpiar-doc-filtros" data-tipo="${tipo}" style="${btnStyle(null,"secondary")}">✕ Limpiar filtros</button>` : ""}
    </div>
  ` : "";

  const searchUI = allDocs.length > 0 ? `
    <div style="display:flex;gap:8px;align-items:flex-start;">
      <div style="flex:1;">${searchBox("search-docs-" + tipo, query, "Buscar por número, " + (tipo === "OCP" ? "proveedor" : "cliente") + ", fecha o estado...", info.color)}</div>
      <button data-action="toggle-doc-filters" data-tipo="${tipo}" style="${btnStyle(state.docFiltersOpen[tipo]||tieneFiltrosActivos?info.color:null,state.docFiltersOpen[tipo]||tieneFiltrosActivos?null:"secondary")}">🔍 Filtros avanzados${tieneFiltrosActivos?" •":""}</button>
    </div>
    ${filtersPanel}
    ${(query || tieneFiltrosActivos) ? `<div style="font-size:10.5px;color:${C.muted};margin-top:-8px;margin-bottom:12px;">Mostrando ${docs.length} de ${allDocs.length}</div>` : ""}
  ` : "";

  let body;
  if (allDocs.length === 0) {
    body = `
      <div style="padding:60px;text-align:center;background:white;border:2px dashed ${C.border};border-radius:6px;color:${C.muted};">
        <div style="font-size:48px;margin-bottom:12px;">${info.icon}</div>
        <div style="font-size:16px;font-weight:600;color:${C.text};margin-bottom:6px;">Sin ${info.plural.toLowerCase()}</div>
        <div style="font-size:12px;">Haz clic en "+ Nueva ${info.label}" para comenzar</div>
      </div>
    `;
  } else if (docs.length === 0) {
    body = `
      <div style="padding:22px;text-align:center;background:white;border:2px dashed ${C.border};border-radius:6px;">
        <div style="font-size:30px;margin-bottom:8px;">🔍</div>
        <div style="color:${C.text};font-size:14px;font-weight:600;margin-bottom:4px;">${query ? `Sin resultados para "${escapeHTML(query)}"` : pestanaOP === "en_proceso" ? "No hay órdenes en proceso" : pestanaOP === "remisionadas" ? "Ninguna orden se ha remisionado completa" : "Sin resultados con los filtros aplicados"}</div>
        <div style="color:${C.muted};font-size:11.5px;">Prueba con otros términos o limpia los filtros</div>
      </div>
    `;
  } else {
    const rows = docs.map(d => {
      const target = tipo === "OCP"
        ? state.data.proveedores.find(p => p.id === d.proveedor_id)
        : clienteDeDoc(d);

      // Estado con badge de color
      const estado = d.estado || "borrador";
      const estadoLabel = (ESTADOS[tipo] && ESTADOS[tipo][estado]) || estado;
      const estadoColor = ESTADO_COLOR[estado] || C.muted;

      // Trazabilidad: de dónde viene y qué salió de aquí. Va en un desplegable
      // porque una OP puede generar varias OCP (más la RS y su factura) y
      // listarlas sueltas bajo el número estiraba la fila sin dejarlas leer.
      const trazaArriba = ancestrosDoc(d);
      const trazaAbajo  = descendientesDoc(tipo, d);
      const trazaTotal  = trazaArriba.length + trazaAbajo.length;
      const trazaAbierta = state.trazaAbierta === `${tipo}:${d.id}`;
      const trazaBtn = trazaTotal === 0 ? "" : `
        <div style="margin-top:3px;">
          <button data-action="toggle-traza" data-tipo="${tipo}" data-id="${d.id}"
            title="Ver de dónde viene y qué documentos salieron de aquí"
            style="display:inline-flex;align-items:center;gap:4px;font-size:9.5px;font-weight:700;
                   color:${trazaAbierta ? info.color : C.muted};background:${trazaAbierta ? info.color + "14" : "transparent"};
                   border:1px solid ${trazaAbierta ? info.color + "55" : C.border};border-radius:11px;
                   padding:1px 8px;cursor:pointer;font-family:inherit;">
            🔗 Trazabilidad · ${trazaTotal} ${trazaAbierta ? "▴" : "▾"}
          </button>
        </div>`;

      // Botones de conversión según el tipo
      let convertBtns = "";
      if (tipo === "CT") {
        if (info.convertsTo.length > 0 && !["convertida","cancelada","rechazada"].includes(estado)) {
          convertBtns = info.convertsTo.map(toTipo => {
            const toInfo = DOC_INFO[toTipo];
            return `<button data-action="convert-doc" data-from="${tipo}" data-to="${toTipo}" data-id="${d.id}" style="${btnStyle(toInfo.color,null,true)}" title="Convertir a ${toInfo.label}">→ ${toInfo.prefix}</button>`;
          }).join(" ");
        }
      } else if (tipo === "OP") {
        if (estado !== "cancelada") {
          // Solo cuentan las OCPs de productos (no las de costos asociados _fromCosto)
          const tieneOCPProductos = state.data.ocp.some(o => o._origen && o._origen.tipo === "OP" && o._origen.id === d.id && !o._fromCosto);
          let btns = [];
          if (!tieneOCPProductos) {
            btns.push(`<button data-action="convert-op-multi-ocp" data-id="${d.id}" style="${btnStyle(DOC_INFO.OCP.color,null,true)}" title="Convertir a una o varias Órdenes de Compra">→ OCP</button>`);
          }
          // El botón → RS se muestra mientras quede algo por remisionar. Antes
          // se escondía cuando el inventario no alcanzaba, y eso dejaba a la
          // vista una OP sin salida aparente: nadie sabía si faltaba stock, si
          // ya se había remisionado todo o si el botón simplemente no existía.
          // Ahora aparece siempre y, si el stock no alcanza, al pulsarlo se
          // explica qué falta (ver faltantesStockOP).
          const _pendienteRS = (d.items||[]).some(it =>
            Math.max(0, parseNumber(it.cantidad) - getCantidadRemisionadaOP(d.id, it.articulo||"", null)) > 0);
          if (_pendienteRS) {
            const _falta = faltantesStockOP(d).length > 0;
            btns.push(`<button data-action="convert-doc" data-from="OP" data-to="RC" data-id="${d.id}" style="${btnStyle(_falta ? C.muted : DOC_INFO.RC.color,null,true)}" title="${_falta ? "Convertir a Remisión — falta inventario, se explicará al pulsar" : "Convertir a Remisión"}">→ RS${_falta ? " ⚠️" : ""}</button>`);
          }
          // Facturar la orden: entregas ya hechas (una, varias o todas) o
          // cantidades por anticipado. Sale mientras quede algo por facturar.
          const _porFacturar = balanceFacturacionOP(d).some(b => b.porFacturar > 0);
          const _hayEntregas = remisionesDeOP(d.id).some(x => !x.facturada);
          if (_porFacturar || _hayEntregas) {
            btns.push(`<button data-action="facturar-op" data-id="${d.id}" style="${btnStyle("#10b981",null,true)}" title="Facturar entregas o cantidades de esta orden">💵 Facturar</button>`);
          }
          convertBtns = btns.join(" ");
        }
      } else if (tipo === "RC" && info.convertsTo.includes("FACT")) {
        const _btnFact = (estado !== "facturada" && estado !== "cancelada")
          ? `<button data-action="facturar-rc" data-id="${d.id}" style="${btnStyle("#10b981",null,true)}" title="Facturar con Dataico">💰 Facturar</button>`
          : "";
        const _btnFirmado = (estado === "completada" || estado === "facturada")
          ? `<button data-action="cargar-firmado-rc" data-id="${d.id}" style="${btnStyle(d._docFirmado?'#12264D':'#94a3b8',null,true)}" title="${d._docFirmado?'Ver/reemplazar remisión firmada':'Cargar remisión firmada'}">${d._docFirmado?'✅ Firmado':'📋 Firmado'}</button>`
          : "";
        convertBtns = _btnFact + (_btnFirmado ? " " + _btnFirmado : "");
      }

      // Botón pagar para OCP — eliminado del listado (se accede desde CxP)
      let payBtn = "";

      // Botón de liquidación para OP
      let liqBtn = "";
      if (tipo === "OP") {
        // Pendiente es tener saldo VIVO: `_cruzado` solo dice "ya no queda nada",
        // así que un anticipo aplicado a medias se contaba como pendiente entero.
        const _antPend = (d._anticipos||[]).filter(a=>anticipoDisponible(a) > 0.01).length;
        liqBtn = `<button data-action="ver-liquidacion" data-id="${d.id}" style="${btnStyle(C.purple,null,true)}" title="Ver liquidación de costos">📊</button>
                  <button data-action="ver-anticipos-op" data-id="${d.id}" style="${btnStyle('#059669',null,true)}" title="Anticipos del cliente${_antPend>0?' — '+_antPend+' pendiente'+(+_antPend!==1?'s':''):''}">💵${_antPend>0?' '+_antPend:''}</button>
                  <button data-action="informe-final-op" data-id="${d.id}" style="${btnStyle('#2B4A82',null,true)}" title="Informe final de la OP (resumen, trazabilidad y margen)">📄</button>`;
      }

      // Columna extra: procesamiento (ingreso/factura) para OCP
      const procesamientoCol = tipo === "OCP" ? (() => {
        const proc = d._procesado || {};
        const totalmente = !!(proc.ingreso && proc.factura);
        // El sello verde se puede pulsar: es la única cosa que queda en la fila
        // cuando la OCP está completa, y antes no llevaba a ninguna parte. Quien
        // no encuentra la mercancía en bodega necesita saber, justo aquí, qué se
        // recibió y qué documento se la llevó.
        // Una orden INFORMATIVA no se ingresa ni se causa: lo único que se hace
        // con ella es cerrarla cuando el proveedor cumple.
        if (d._informativa) {
          return `<td style="padding:6px 10px;white-space:nowrap;">
            <div style="background:#eef2ff;color:#3730a3;border:1px solid #c7d2fe;padding:3px 8px;border-radius:6px;font-size:10px;font-weight:700;text-align:center;margin-bottom:4px;"
                 title="Es el compromiso que se le mandó al proveedor: no entra a la bodega ni a la contabilidad.">📋 Informativa — no se ingresa</div>
            ${d._cerrada
              ? `<div style="background:#d1fae5;color:#047857;border:1px solid #6ee7b7;padding:3px 8px;border-radius:6px;font-size:10px;font-weight:700;text-align:center;"
                      title="El proveedor cumplió el ${escapeHTML(d._cerrada.fecha || "")}">🔒 Cerrada ${fmtDate(d._cerrada.fecha)}</div>`
              : `<button data-action="cerrar-ocp-informativa" data-id="${d.id}"
                   style="background:#f1f5f9;color:#334155;border:1px solid #cbd5e1;padding:3px 8px;border-radius:6px;font-size:10px;font-weight:700;cursor:pointer;display:block;width:100%;"
                   title="Ciérrala cuando el proveedor haya cumplido">🔒 Cerrar</button>`}
          </td>`;
        }
        if (totalmente) {
          return `<td style="padding:6px 10px;">
            <button data-action="ver-ingreso-ocp" data-id="${d.id}"
              style="background:#d1fae5;color:#047857;border:1px solid #6ee7b7;padding:3px 9px;border-radius:6px;font-size:10.5px;font-weight:700;display:inline-block;cursor:pointer;"
              title="Ver qué se recibió y dónde está esa mercancía">✅ Totalmente procesada</button>
          </td>`;
        }
        // Estado de ingreso para el botón
        const _totIng = ocpTotalmenteIngresada(d);
        const _parcIng = !_totIng && (d._recepciones||[]).length > 0;
        const _ingBg  = _totIng ? "#d1fae5" : _parcIng ? "#fef3c7" : "#f1f5f9";
        const _ingCol = _totIng ? "#047857" : _parcIng ? "#92400e" : "#6b7280";
        const _ingBor = _totIng ? "#6ee7b7" : _parcIng ? "#fde68a" : "#e5e7eb";
        const _ingIco = _totIng ? "✅" : _parcIng ? "📦" : "⬜";
        const _ingLbl = "Ingreso" + (_parcIng ? " (parcial)" : "");
        return `<td style="padding:6px 10px;white-space:nowrap;">
          ${_totIng
            ? `<button data-action="ver-ingreso-ocp" data-id="${d.id}"
                style="background:#d1fae5;color:#047857;border:1px solid #6ee7b7;
                       padding:3px 8px;border-radius:6px;font-size:10px;font-weight:700;
                       cursor:pointer;display:block;width:100%;text-align:center;margin-bottom:4px;"
                title="Ver qué se recibió y dónde está esa mercancía">
                ✅ Ingreso completo</button>`
            : `<button data-action="abrir-ingreso-ocp" data-id="${d.id}"
                style="background:${_ingBg};color:${_ingCol};border:1px solid ${_ingBor};
                       padding:3px 8px;border-radius:6px;font-size:10px;font-weight:700;
                       cursor:pointer;margin-bottom:4px;display:block;width:100%;"
                title="Gestionar ingreso de mercancía">
                ${_ingIco} ${_ingLbl}
              </button>`}
          ${proc.factura
            ? `<span style="background:#d1fae5;color:#047857;border:1px solid #6ee7b7;padding:3px 8px;border-radius:6px;font-size:10px;font-weight:700;display:block;width:100%;text-align:center;">✅ En Contabilidad</span>`
            : `<span style="background:#f1f5f9;color:#94a3b8;border:1px solid #e2e8f0;padding:3px 8px;border-radius:6px;font-size:10px;font-weight:700;display:block;width:100%;text-align:center;" title="Causación en Contabilidad → Facturas Proveedor">⏳ Pendiente causación</span>`}
        </td>`;
      })() : "";

      // Celda extra: estado de pago para OCP
      const payCol = tipo === "OCP" ? (() => {
        // Una informativa no se paga por aquí —lo que se paga es la cuenta de
        // cobro—, así que anunciar "Por pagar" sería prometer un pasivo que no
        // existe: en el listado de CxP no está, y nadie va a pagarla desde ahí.
        if (d._informativa) {
          return `<td style="padding:6px 10px;">
            <span style="background:#f1f5f9;color:#94a3b8;border:1px solid #e2e8f0;padding:2px 7px;border-radius:6px;font-size:10px;font-weight:700;white-space:nowrap;"
                  title="El pago va por la cuenta de cobro del tercero, no por esta orden.">— no se paga aquí</span>
          </td>`;
        }
        const pago = d.estado_pago || "por_pagar";
        const pinfo = ESTADO_PAGO[pago] || ESTADO_PAGO.por_pagar;
        let extra = "";
        if (pago === "parcial") {
          const abonado = getMontoPagadoOCP(d);
          const saldo = getSaldoOCP(d);
          extra = `<div style="font-size:10px;color:${C.muted};margin-top:3px;">Abonado: <strong style="color:#10b981;">${fmtCOP(abonado)}</strong> · Saldo: <strong style="color:#d97706;">${fmtCOP(saldo)}</strong></div>`;
        } else if (pago === "pagada" && d._pago) {
          extra = `<div style="font-size:10px;color:${C.muted};margin-top:3px;">${escapeHTML(fmtDate(d._pago.fecha))}</div>`;
        }
        return `<td style="padding:6px 10px;">
          <span style="background:${pinfo.bg};color:${pinfo.color};padding:3px 9px;border-radius:6px;font-size:10.5px;font-weight:700;display:inline-block;">${pinfo.label}</span>
          ${extra}
        </td>`;
      })() : "";

      // Margen de utilidad total para Remisiones facturadas (factura), usando precios del documento origen
      let margenRCHTML = "";
      if (tipo === "RC" && estado === "facturada" && d._origen) {
        const origenInfo2 = DOC_INFO[d._origen.tipo];
        const origenDoc = origenInfo2 ? (state.data[origenInfo2.key]||[]).find(o => o.id === d._origen.id) : null;
        if (origenDoc) {
          const itemsConPrecio = (d.items||[]).map(it => {
            const match = (origenDoc.items||[]).find(oi => oi.articulo === it.articulo);
            return { articulo: it.articulo, cantidad: it.cantidad, precio_unitario: match ? match.precio_unitario : 0 };
          });
          const margenInfoRC = calcularMargenTotal(itemsConPrecio);
          if (margenInfoRC) {
            const colorRC = margenInfoRC.pct < 20 ? C.red : margenInfoRC.pct < 40 ? C.amber : "#10b981";
            margenRCHTML = `<div style="font-size:10px;color:${colorRC};font-weight:700;margin-top:2px;">Margen: ${margenInfoRC.pct.toFixed(1)}%</div>`;
          }
        }
      }

      // Columna "Origen OP" para OCP — link siempre activo a la OP de origen
      const origenOCPCol = tipo === "OCP" ? (
        (d._origen && d._origen.tipo === "OP")
          ? `<td style="padding:6px 10px;"><span data-action="ir-a-documento" data-tipo="OP" data-id="${d._origen.id}" style="color:${DOC_INFO.OP.color};font-weight:700;cursor:pointer;text-decoration:underline;">${escapeHTML(d._origen.numero)}</span></td>`
          : `<td style="padding:6px 10px;color:${C.muted};font-size:11.5px;">—</td>`
      ) : "";

      return `
        <tr style="border-top:1px solid ${C.border};background:${state.selectedDocs[tipo] && state.selectedDocs[tipo][d.id] ? info.color + '08' : ''};">
          <td style="padding:6px 10px;text-align:center;">
            <input type="checkbox" data-action="toggle-doc-checkbox" data-tipo="${tipo}" data-id="${d.id}" ${state.selectedDocs[tipo] && state.selectedDocs[tipo][d.id] ? 'checked' : ''} style="cursor:pointer;width:18px;height:18px;"/>
          </td>
          ${origenOCPCol}
          <td style="padding:6px 10px;">
            <div data-action="view-doc" data-tipo="${tipo}" data-id="${d.id}" style="font-weight:800;color:${info.color};cursor:pointer;text-decoration:underline;display:inline-block;" title="Ver documento">${escapeHTML(d.numero)}</div>
            ${trazaBtn}
          </td>
          <td style="padding:6px 10px;color:${C.muted};">${escapeHTML(fmtDate(d.fecha))}</td>
          <td style="padding:6px 10px;">${escapeHTML((target && target.nombre) || "—")}${target && target._libre ? ` <span title="Tercero no registrado en Maestros" style="font-size:9px;font-weight:800;color:#92400e;background:#fffbeb;border:1px solid #fcd34d;border-radius:4px;padding:1px 4px;">no registrado</span>` : ""}</td>
          ${(tipo === "CT" || tipo === "OP") ? `<td style="padding:6px 10px;">
            ${d.asesor_comercial ? `<span style="background:${C.amber}15;color:${C.amber};padding:2px 8px;border-radius:6px;font-size:10.5px;font-weight:600;">🧑‍💼 ${escapeHTML(d.asesor_comercial)}</span>` : `<span style="color:${C.muted};font-size:10.5px;">—</span>`}
          </td>` : ""}
          <td style="padding:6px 10px;">
            <span style="background:${estadoColor}20;color:${estadoColor};padding:3px 9px;border-radius:6px;font-size:10.5px;font-weight:700;display:inline-block;cursor:pointer;transition:all 0.2s;" data-action="quick-change-state" data-tipo="${tipo}" data-id="${d.id}" title="Click para cambiar estado">${estadoLabel}</span>
            ${entregas && d.estado !== "cancelada" && d.estado !== "borrador" ? (() => {
              const en = entregas.get(d.id);
              const fmt = (n) => formatMiles(n);
              return en.estado === "entregada"
                ? `<div data-op-entrega="entregada" style="font-size:9.5px;font-weight:700;color:#047857;margin-top:3px;">📮 Remisionada completa</div>`
                : en.estado === "parcial"
                ? `<div data-op-entrega="parcial" style="font-size:9.5px;font-weight:700;color:#b45309;margin-top:3px;" title="Unidades entregadas en remisiones de lo pedido">📮 ${fmt(en.entregadoUds)} de ${fmt(en.pedidoUds)} entregadas (${en.pct}%)</div>`
                : `<div data-op-entrega="sin_entregar" style="font-size:9.5px;color:${C.muted};margin-top:3px;">📮 Sin entregar</div>`;
            })() : ""}
          </td>
          ${procesamientoCol}
          ${payCol}
          <td style="padding:6px 10px;font-weight:700;">${
            // Cotización por cantidad: no tiene un total sumado, así que "$ 0"
            // se leería como una cotización vacía.
            (d.items || []).some(tieneEscalas) && !parseNumber(d.total)
              ? `<span style="font-weight:700;font-size:10.5px;color:${C.blue};" title="Cotizada con precios por cantidad: el total se define con la cantidad que confirme el cliente">📊 Por cantidad</span>`
              : fmtCOP(d.total)}${margenRCHTML}</td>
          <td style="padding:6px 10px;text-align:right;white-space:nowrap;">
            ${liqBtn}
            ${payBtn}
            ${convertBtns}
            ${tipo === "CT" ? `<button data-action="duplicate-doc" data-tipo="${tipo}" data-id="${d.id}" style="${btnStyle(C.purple,null,true)}" title="Duplicar cotización">📑 Duplicar</button>` : ""}
            <button data-action="print-doc" data-tipo="${tipo}" data-id="${d.id}" style="${btnStyle(null,"ghost",true)}" title="Ver el documento y descargar el PDF">📄</button>
            <button data-action="view-doc" data-tipo="${tipo}" data-id="${d.id}" style="${btnStyle(null,"ghost",true)}" title="Ver / Editar">✏️</button>
            <button data-action="delete-doc" data-tipo="${tipo}" data-id="${d.id}" style="${btnStyle(null,"ghost",true)}" title="Eliminar">🗑</button>
          </td>
        </tr>
        ${trazaAbierta ? `<tr style="background:${info.color}06;">
          <td colspan="20" style="padding:0 10px 4px 40px;">${panelTrazabilidad(tipo, d, trazaArriba, trazaAbajo)}</td>
        </tr>` : ""}
      `;
    }).join("");

    // Encabezado: agregar columna "Pago" si es OCP
    const payHeader = tipo === "OCP"
      ? `<th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Pago</th>`
      : "";

    // Encabezado: agregar columna "Procesamiento" si es OCP
    const procesamientoHeader = tipo === "OCP"
      ? `<th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Procesamiento</th>`
      : "";

    // Encabezado: agregar columna "Origen OP" si es OCP
    const origenOCPHeader = tipo === "OCP"
      ? `<th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Origen OP</th>`
      : "";

    // Contar seleccionados
    const selectedCount = Object.keys(state.selectedDocs[tipo] || {}).length;
    const esAdminBulk = !state.usuarioRol || state.usuarioRol === "admin";
    const bulkDeleteBtn = (tipo === "CT" && esAdminBulk)
      ? `<button data-action="bulk-delete-doc" data-tipo="${tipo}" style="${btnStyle(C.red)}">🗑 Eliminar</button>`
      : "";
    const bulkActionsUI = selectedCount > 0 ? `
      <div style="margin-bottom:9px;padding:14px 16px;background:#f8fafc;border:1px solid #2B4A82;border-radius:6px;display:flex;gap:10px;align-items:center;justify-content:space-between;">
        <div style="display:flex;align-items:center;gap:10px;">
          <span style="font-size:17px;">✓</span>
          <div>
            <div style="font-size:14px;font-weight:700;color:#0E7490;">${selectedCount} documento${selectedCount !== 1 ? 's' : ''} seleccionado${selectedCount !== 1 ? 's' : ''}</div>
            <div style="font-size:10.5px;color:#0E7490;">Haz clic en un botón para aplicar acción</div>
          </div>
        </div>
        <div style="display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;">
          <button data-action="bulk-change-state" data-tipo="${tipo}" style="${btnStyle('#2B4A82')}">🔄 Cambiar estado</button>
          ${bulkDeleteBtn}
          <button data-action="deselect-all" data-tipo="${tipo}" style="${btnStyle(null,'secondary')}">Deseleccionar</button>
        </div>
      </div>
    ` : "";

    body = `
      ${bulkActionsUI}
      <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;">
        <table style="width:100%;border-collapse:collapse;font-size:12px;">
          <thead>
            <tr style="background:#f1f5f9;">
              <th style="padding:6px 10px;text-align:center;font-size:10.5px;font-weight:700;color:${C.text};">
                <input type="checkbox" data-action="toggle-all-checkboxes" data-tipo="${tipo}" ${selectedCount === docs.length && docs.length > 0 ? 'checked' : ''} style="cursor:pointer;width:18px;height:18px;"/>
              </th>
              ${origenOCPHeader}
              ${thSortable(tipo, "numero", "Número")}
              ${thSortable(tipo, "fecha", "Fecha")}
              ${thSortable(tipo, "tercero", tipo === "OCP" ? "Proveedor" : "Cliente")}
              ${(tipo === "CT" || tipo === "OP") ? `<th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Asesor</th>` : ""}
              ${thSortable(tipo, "estado", "Estado")}
              ${procesamientoHeader}
              ${payHeader}
              ${thSortable(tipo, "total", "Total")}
              <th style="padding:6px 10px;"></th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
      </div>
    `;
  }

  const panelPorFacturar = tipo === "RC" ? panelRemisionesSinFacturar() : "";
  return header + panelPorFacturar + pestanasUI + searchUI + body;
}

// ─── Trazabilidad de un documento ───────────────────────────────────────────
// De dónde viene y qué salió de él. Antes esto se escribía como dos líneas
// sueltas debajo del número ("⬅ desde CT-5335", "➡ Ver OCP-0293"), que con
// varias OCP por OP hacían crecer la fila y aun así no contaban toda la
// historia. Ahora se calcula la cadena completa —hacia arriba sin límite y
// hacia abajo con los nietos— y se muestra bajo demanda en un desplegable.
const TIPOS_DOC = ["CT", "OP", "OCP", "RC", "FACT", "NC"];

function docPorRef(tipo, id) {
  const info = DOC_INFO[tipo];
  return info ? (state.data[info.key] || []).find(x => x.id === id) : null;
}

function nodoTraza(tipo, d, nivel = 0) {
  const tercero = tipo === "OCP"
    ? ((state.data.proveedores || []).find(p => p.id === d.proveedor_id) || {}).nombre
    : nombreClienteDoc(d, "");
  return {
    tipo, nivel, id: d.id, numero: d.numero || "(sin número)", fecha: d.fecha,
    estado: (ESTADOS[tipo] && ESTADOS[tipo][d.estado || "borrador"]) || d.estado || "",
    estadoClave: d.estado || "borrador", total: d.total, tercero: tercero || "",
    // Las OCP de costos asociados (fletes, troqueles) también nacen de la OP,
    // pero no son la compra de la mercancía: conviene distinguirlas.
    nota: d._fromCosto ? "costos asociados" : ""
  };
}

// Hacia arriba: la OP viene de una CT, y esa CT podría venir de otra cosa.
export function ancestrosDoc(doc) {
  const salida = [];
  let actual = doc;
  const vistos = new Set([doc && doc.id]);
  while (actual && actual._origen && actual._origen.tipo && !vistos.has(actual._origen.id)) {
    vistos.add(actual._origen.id);
    const padre = docPorRef(actual._origen.tipo, actual._origen.id);
    if (!padre) {
      // El documento de origen ya no existe (se borró): se deja constancia.
      salida.unshift({ tipo: actual._origen.tipo, id: actual._origen.id,
        numero: actual._origen.numero || "?", nivel: 0, perdido: true });
      break;
    }
    salida.unshift(nodoTraza(actual._origen.tipo, padre));
    actual = padre;
  }
  return salida;
}

// Hacia abajo: todas las OCP y RS de la OP, y lo que salga de cada una
// (la factura de una remisión, por ejemplo).
export function descendientesDoc(tipo, doc, nivel = 0, vistos = new Set()) {
  const salida = [];
  if (!doc) return salida;
  TIPOS_DOC.forEach(t => {
    (state.data[DOC_INFO[t].key] || []).forEach(x => {
      if (!x._origen || x._origen.tipo !== tipo || x._origen.id !== doc.id) return;
      if (vistos.has(t + x.id)) return;
      vistos.add(t + x.id);
      salida.push(nodoTraza(t, x, nivel));
      salida.push(...descendientesDoc(t, x, nivel + 1, vistos));
    });
  });
  // Documentos viejos: se convirtieron antes de que se guardara el origen, así
  // que solo quedan anotados en el documento padre.
  getConvertedToList(doc).forEach(l => {
    if (!l || !l.tipo || vistos.has(l.tipo + l.id)) return;
    vistos.add(l.tipo + l.id);
    const hijo = docPorRef(l.tipo, l.id);
    salida.push(hijo ? nodoTraza(l.tipo, hijo, nivel)
      : { tipo: l.tipo, id: l.id, numero: l.numero || "?", nivel, perdido: true });
  });
  return salida;
}

function filaTrazaHTML(n, flecha) {
  const info = DOC_INFO[n.tipo] || {};
  const sangria = 13 * (n.nivel || 0);
  if (n.perdido) {
    return `<div style="padding:5px 9px 5px ${9 + sangria}px;font-size:11px;color:${C.muted};">
      ${flecha} ${escapeHTML(n.numero)} <span style="font-style:italic;">— ya no existe</span></div>`;
  }
  return `
    <div style="display:flex;align-items:center;gap:9px;padding:5px 9px 5px ${9 + sangria}px;border-top:1px solid ${C.border};">
      <span style="font-size:11px;color:${C.muted};width:12px;flex:0 0 auto;">${flecha}</span>
      <span data-action="ir-a-documento" data-tipo="${n.tipo}" data-id="${n.id}"
        style="font-weight:800;font-size:11.5px;color:${info.color || C.text};cursor:pointer;text-decoration:underline;white-space:nowrap;"
        title="Abrir ${escapeHTML(n.numero)}">${info.icon || ""} ${escapeHTML(n.numero)}</span>
      ${n.nota ? `<span style="font-size:9px;font-weight:700;color:#92400e;background:#fffbeb;border:1px solid #fcd34d;border-radius:4px;padding:1px 5px;white-space:nowrap;">${escapeHTML(n.nota)}</span>` : ""}
      <span style="font-size:11px;color:${C.muted};flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${escapeHTML(n.tercero || "")}</span>
      <span style="font-size:10.5px;color:${C.muted};white-space:nowrap;">${escapeHTML(fmtDate(n.fecha))}</span>
      <span style="font-size:10px;font-weight:700;color:${ESTADO_COLOR[n.estadoClave] || C.muted};white-space:nowrap;">${escapeHTML(n.estado)}</span>
      <span style="font-size:11px;font-weight:700;color:${C.text};min-width:88px;text-align:right;white-space:nowrap;">${fmtCOP(n.total)}</span>
    </div>`;
}

function panelTrazabilidad(tipo, d, arriba, abajo) {
  const info = DOC_INFO[tipo];
  const bloque = (titulo, nodos, flecha) => nodos.length === 0 ? "" : `
    <div style="font-size:10px;font-weight:800;color:${C.muted};text-transform:uppercase;letter-spacing:.5px;padding:7px 9px 3px;">${titulo}</div>
    ${nodos.map(n => filaTrazaHTML(n, flecha)).join("")}`;
  return `
    <div style="border:1px solid ${C.border};border-radius:8px;background:white;overflow:hidden;margin:2px 0 6px;">
      ${bloque("Viene de", arriba, "⬆")}
      <div style="display:flex;align-items:center;gap:9px;padding:6px 9px;border-top:1px solid ${C.border};background:${info.color}0d;">
        <span style="font-size:11px;color:${C.muted};width:12px;flex:0 0 auto;">▪</span>
        <span style="font-weight:800;font-size:11.5px;color:${info.color};white-space:nowrap;">${info.icon} ${escapeHTML(d.numero)}</span>
        <span style="font-size:10px;color:${C.muted};">este documento</span>
      </div>
      ${bloque("Generó", abajo, "⬇")}
    </div>`;
}

export function docTieneHijos(tipo, doc) {
  if (!doc) return false;
  // 1. Campo _convertedTo registrado al momento de la conversión
  if (getConvertedToList(doc).length > 0) return true;
  // 2. Búsqueda dinámica: cualquier doc que tenga este como _origen
  const allKeys = ["cotizaciones","pedidos","ocp","remisiones","facturas","notas_credito"];
  return allKeys.some(k => (state.data[k]||[]).some(
    x => x._origen && x._origen.tipo === tipo && x._origen.id === doc.id
  ));
}

export function renderDocViewModal(tipo, doc) {
  const info   = DOC_INFO[tipo];
  const isOCP  = tipo === "OCP";
  const tercero = isOCP
    ? (state.data.proveedores||[]).find(p => p.id === doc.proveedor_id)
    : clienteDeDoc(doc);
  const estadoLabel = (ESTADOS[tipo] && ESTADOS[tipo][doc.estado||"borrador"]) || doc.estado || "Borrador";
  const estadoColor = ESTADO_COLOR[doc.estado||"borrador"] || C.muted;
  const tieneHijos  = docTieneHijos(tipo, doc);
  const bloqueado   = doc._locked || tieneHijos;
  const hijos       = getConvertedToList(doc);

  // ── Items table ──
  const items = doc.items || [];
  const itemsHTML = items.length === 0
    ? `<div style="text-align:center;padding:11px;color:${C.muted};font-size:12px;">Sin productos</div>`
    : `<table style="width:100%;border-collapse:collapse;font-size:11.5px;">
        <thead>
          <tr style="background:${info.color}12;">
            <th style="padding:7px 10px;text-align:left;font-weight:700;color:${C.muted};border-bottom:1px solid ${C.border};">Producto</th>
            <th style="padding:7px 10px;text-align:right;font-weight:700;color:${C.muted};border-bottom:1px solid ${C.border};">Cant.</th>
            <th style="padding:7px 10px;text-align:right;font-weight:700;color:${C.muted};border-bottom:1px solid ${C.border};">${isOCP?"Costo":"Precio"}</th>
            ${!isOCP ? `<th style="padding:7px 10px;text-align:right;font-weight:700;color:${C.muted};border-bottom:1px solid ${C.border};">Desc.</th>` : ""}
            <th style="padding:7px 10px;text-align:right;font-weight:700;color:${C.muted};border-bottom:1px solid ${C.border};">Subtotal</th>
          </tr>
        </thead>
        <tbody>
          ${items.map(it => {
            const qty  = parseNumber(it.cantidad)||0;
            const prc  = parseNumber(isOCP ? (it.costo||it.precio_unitario) : (it.precio_unitario||it.precio))||0;
            const dsc  = parseNumber(it.descuento)||0;
            const sub  = qty * prc * (1 - dsc/100);
            // Ítem cotizado a varias cantidades: se ve igual que en el PDF —
            // el nombre una sola vez y al frente una línea por cantidad.
            const esc = escalasDeItem(it);
            const nombreCell = `<td style="padding:7px 10px;">
                <div style="font-weight:600;color:${C.text};">${escapeHTML(it.articulo||it.nombre||"")}</div>
                ${it.descripcion ? `<div style="font-size:10px;color:${C.muted};">${escapeHTML(it.descripcion)}</div>` : ""}
                ${esc.length ? `<div style="font-size:10px;font-weight:700;color:${C.blue};margin-top:3px;">📊 Precio según cantidad</div>` : ""}
              </td>`;
            if (esc.length) {
              const lineas = (fn) => esc.map(e => `<div style="padding:2px 0;">${fn(e)}</div>`).join("");
              return `<tr style="border-bottom:1px solid ${C.border};">
                ${nombreCell}
                <td style="padding:7px 10px;text-align:right;">${lineas(e => (parseNumber(e.cantidad)||0) + " " + escapeHTML(it.unidad||""))}</td>
                <td style="padding:7px 10px;text-align:right;">${lineas(e => fmtCOP(e.precio_unitario))}</td>
                ${!isOCP ? `<td style="padding:7px 10px;text-align:right;color:${C.muted};">—</td>` : ""}
                <td style="padding:7px 10px;text-align:right;font-weight:700;">${lineas(e =>
                  fmtCOP((parseNumber(e.cantidad)||0) * (parseNumber(e.precio_unitario)||0)))}</td>
              </tr>`;
            }
            return `<tr style="border-bottom:1px solid ${C.border};">
              ${nombreCell}
              <td style="padding:7px 10px;text-align:right;">${qty} ${escapeHTML(it.unidad||"")}</td>
              <td style="padding:7px 10px;text-align:right;">${fmtCOP(prc)}</td>
              ${!isOCP ? `<td style="padding:7px 10px;text-align:right;">${dsc>0?dsc+"%":"—"}</td>` : ""}
              <td style="padding:7px 10px;text-align:right;font-weight:700;">${fmtCOP(sub)}</td>
            </tr>`;
          }).join("")}
        </tbody>
      </table>`;

  // ── Totales ──
  const subtotal  = parseNumber(doc.subtotal)||0;
  const iva       = parseNumber(doc.iva)||0;
  const total     = parseNumber(doc.total)||0;
  const descuento = parseNumber(doc.descuento_global)||0;

  // Con escalas de cantidad no hay un total del documento: el cliente elige la
  // cantidad y ahí se define el valor. Mostrar "$ 0" sería engañoso.
  const hayEscalasDoc = items.some(tieneEscalas);
  const totalesHTML = hayEscalasDoc
    ? `<div style="margin-top:10px;background:${C.blue}10;border-left:3px solid ${C.blue};border-radius:6px;padding:8px 11px;font-size:11.5px;color:${C.text};">
        <strong>Precios por cantidad.</strong> ${items.filter(tieneEscalas).length === items.length
          ? "Este documento no tiene un total sumado"
          : `Los ítems por cantidad no suman al total (subtotal de los ítems con cantidad fija: <strong>${fmtCOP(subtotal)}</strong>)`}
        — el valor final depende de la cantidad que confirme el cliente.
       </div>`
    : `
    <div style="display:flex;justify-content:flex-end;margin-top:10px;">
      <div style="min-width:220px;font-size:12px;">
        <div style="display:flex;justify-content:space-between;padding:4px 0;"><span style="color:${C.muted};">Subtotal:</span><span>${fmtCOP(subtotal)}</span></div>
        ${descuento>0 ? `<div style="display:flex;justify-content:space-between;padding:4px 0;color:#dc2626;"><span>Descuento:</span><span>-${fmtCOP(descuento)}</span></div>` : ""}
        ${desgloseIVA(items).mezclado
          // Con regímenes mezclados, el "IVA:" a secas no dice cuánto iba
          // exento o excluido, que es justo lo que hay que poder verificar. Los
          // documentos anteriores a la clasificación nunca entran aquí (sus
          // líneas no tienen régimen), así que conservan su línea de siempre.
          ? renglonesIVA(items, iva).map(r => `<div style="display:flex;justify-content:space-between;padding:3px 0;font-size:11.5px;">
              <span style="color:${C.muted};">${escapeHTML(r.lbl)}:</span><span>${fmtCOP(r.valor)}</span></div>`).join("")
          : (iva>0 ? `<div style="display:flex;justify-content:space-between;padding:4px 0;"><span style="color:${C.muted};">IVA:</span><span>${fmtCOP(iva)}</span></div>` : "")}
        <div style="display:flex;justify-content:space-between;padding:8px 0 4px;border-top:2px solid ${info.color};margin-top:4px;font-weight:800;font-size:12px;color:${info.color};"><span>TOTAL:</span><span>${fmtCOP(total)}</span></div>
      </div>
    </div>`;

  // ── Origen / hijos ──
  const origenHTML = doc._origen
    ? `<div style="background:${DOC_INFO[doc._origen.tipo]?.color||C.muted}12;border:1px solid ${DOC_INFO[doc._origen.tipo]?.color||C.muted}30;border-radius:6px;padding:6px 10px;font-size:11.5px;color:${C.muted};margin-bottom:10px;">
        📎 Originado de <strong>${escapeHTML(doc._origen.numero)}</strong> (${doc._origen.tipo})
       </div>` : "";

  const hijosHTML = hijos.length > 0
    ? `<div style="background:${C.amber}12;border:1px solid ${C.amber}40;border-radius:6px;padding:6px 10px;font-size:11.5px;margin-bottom:10px;">
        🔗 Generó: ${hijos.map(h=>`<strong style="color:${DOC_INFO[h.tipo]?.color||C.mathiz};">${escapeHTML(h.numero)} (${h.tipo})</strong>`).join(", ")}
       </div>` : "";

  // ── Botón editar ──
  const _ocpBloqTotal = tipo === "OCP" && (doc.estado === "recibida" || ocpTotalmenteIngresada(doc));
  const editBtn = _ocpBloqTotal
    // La OCP recibida sigue bloqueada para edición normal (cambiar cantidades
    // desalinearía el inventario ya movido), pero el PRECIO sí se puede ajustar
    // por una vía controlada: el proveedor cambia precios y la OCP tiene que
    // poder cuadrar con su factura. Ver "ajustar-precios-ocp" en cxp.js.
    ? `<span style="font-size:11.5px;color:#047857;font-weight:700;padding:8px 14px;background:#d1fae5;border-radius:6px;display:inline-block;">
        🔒 OCP procesada — cantidades bloqueadas</span>
       ${doc._procesado && doc._procesado.factura ? "" : `
       <button data-action="ajustar-precios-ocp" data-id="${doc.id}" style="${btnStyle(C.amber)}margin-left:8px;"
         title="Cuadrar los precios con la factura del proveedor">💲 Ajustar precios</button>`}`
    : bloqueado
    ? `<button data-action="solicitar-edicion-doc" data-tipo="${tipo}" data-id="${doc.id}"
         style="${btnStyle(C.amber)}">🔒 Solicitar edición</button>`
    : `<button data-action="edit-from-view" data-tipo="${tipo}" data-id="${doc.id}"
         style="${btnStyle(info.color)}">✏️ Editar</button>`;

  state.modal = `
    <div data-action="close-modal-bg" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.5);display:flex;align-items:center;justify-content:center;z-index:1050;padding:11px;">
      <div data-action="prevent-close" style="background:white;border-radius:14px;width:860px;max-width:100%;max-height:90vh;overflow:auto;box-shadow:0 20px 60px rgba(0,0,0,.22);">
        <!-- Header -->
        <div style="padding:14px 20px;border-bottom:1px solid ${C.border};display:flex;justify-content:space-between;align-items:center;background:linear-gradient(135deg,${info.color}18,${C.blue}08);border-radius:14px 14px 0 0;">
          <div style="display:flex;align-items:center;gap:9px;">
            <span style="font-size:17px;">${info.icon||"📄"}</span>
            <div>
              <div style="font-size:16px;font-weight:800;color:${info.color};">${escapeHTML(doc.numero)}</div>
              <div style="font-size:10.5px;color:${C.muted};">${info.label} · ${doc.fecha||"—"}</div>
            </div>
            <span style="background:${estadoColor}22;color:${estadoColor};padding:3px 10px;border-radius:20px;font-size:10.5px;font-weight:700;">${estadoLabel}</span>
          </div>
          <div style="display:flex;gap:6px;align-items:center;">
            ${botonBitacora(info.key, doc.id, doc.numero, { referencia: doc.numero })}
            <button data-action="close-modal" style="background:transparent;border:none;font-size:16px;color:${C.muted};cursor:pointer;padding:4px 8px;">✕</button>
          </div>
        </div>
        <!-- Cuerpo -->
        <div style="padding:18px 20px;">
          ${origenHTML}${hijosHTML}
          <!-- Tercero + Asesor -->
          <div style="display:flex;gap:10px;margin-bottom:9px;flex-wrap:wrap;">
            <div style="flex:1;min-width:180px;background:${C.bg};border-radius:6px;padding:7px 10px;">
              <div style="font-size:10px;font-weight:700;color:${C.muted};margin-bottom:4px;">${isOCP?"PROVEEDOR":"CLIENTE"}</div>
              <div style="font-weight:700;color:${C.text};font-size:14px;">${escapeHTML(tercero?.nombre||"—")}</div>
              ${tercero?.nit ? `<div style="font-size:10.5px;color:${C.muted};">NIT: ${escapeHTML(tercero.nit)}</div>` : ""}
              ${tercero?._libre ? `<div style="font-size:9.5px;font-weight:800;color:#92400e;margin-top:3px;">✏️ Tercero no registrado en Maestros</div>` : ""}
            </div>
            ${doc.asesor_comercial ? `
            <div style="flex:1;min-width:180px;background:${C.amber}10;border-radius:6px;padding:7px 10px;">
              <div style="font-size:10px;font-weight:700;color:${C.muted};margin-bottom:4px;">ASESOR COMERCIAL</div>
              <div style="font-weight:700;color:${C.text};font-size:12px;">🧑‍💼 ${escapeHTML(doc.asesor_comercial)}</div>
            </div>` : ""}
            ${doc.fecha_entrega ? `
            <div style="background:${C.bg};border-radius:6px;padding:7px 10px;">
              <div style="font-size:10px;font-weight:700;color:${C.muted};margin-bottom:4px;">ENTREGA</div>
              <div style="font-weight:600;color:${C.text};font-size:12px;">${doc.fecha_entrega}</div>
            </div>` : ""}
          </div>
          <!-- Items -->
          <div style="border:1px solid ${C.border};border-radius:6px;overflow:hidden;margin-bottom:9px;">
            ${itemsHTML}
          </div>
          ${totalesHTML}
          ${doc.notas ? `<div style="margin-top:14px;padding:7px 10px;background:${C.bg};border-radius:6px;font-size:11.5px;color:${C.muted};border-left:3px solid ${info.color};">
            <strong style="color:${C.text};">Notas:</strong> <span style="white-space:pre-line;">${htmlParaMostrar(doc.notas)}</span>
          </div>` : ""}
        </div>
        <!-- Footer -->
        <div style="padding:14px 20px;border-top:1px solid ${C.border};display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap;">
          <div style="font-size:10.5px;color:${C.muted};">
            ${bloqueado ? `🔒 <span style="color:${C.amber};">Este documento ${tieneHijos?"generó otros documentos":"está bloqueado"} — edición restringida</span>` : "✅ Documento editable"}
          </div>
          <div style="display:flex;gap:8px;flex-wrap:wrap;">
            <button data-action="print-doc" data-tipo="${tipo}" data-id="${doc.id}" style="${btnStyle(null,'ghost')}">📄 Ver / PDF</button>
            ${editBtn}
            <button data-action="close-modal" style="${btnStyle(null,'secondary')}">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  `;
  render();
}

export function showDocForm(tipo, doc) {
  const info = DOC_INFO[tipo];
  const isRC = tipo === "RC";
  const isOCP = tipo === "OCP";

  state.editingDoc = doc ? JSON.parse(JSON.stringify(doc)) : {
    fecha: today(),
    cliente_id: "",
    proveedor_id: "",
    items: [],
    notas: "",
    estado: "borrador",
    ...(isOCP ? { estado_pago: "por_pagar" } : {})
  };
  state.editingTipo = tipo;
  state._precargaCliente = null;   // la precarga es de ESTE formulario

  renderDocFormModal();
}

// ─── Escalas de cantidad ─────────────────────────────────────────────────────
// El cliente pide el mismo artículo a varias cantidades (100, 500, 1000) y cada
// rango tiene su precio. En vez de repetir el ítem —con su foto y su
// descripción— tres veces, la línea guarda sus escalas: cada una con su
// cantidad y su precio.
//
// Un ítem con escalas NO tiene una cantidad única, así que no aporta a los
// totales del documento: el cliente decide después con cuál se queda. Eso es lo
// que hace `aportaATotales`, y por eso la cotización con escalas se imprime sin
// un total sumado.
export function escalasDeItem(it) {
  return (it && Array.isArray(it._escalas) ? it._escalas : [])
    .filter(e => (parseNumber(e.cantidad) || 0) > 0 || (parseNumber(e.precio_unitario) || 0) > 0);
}

export function tieneEscalas(it) {
  return escalasDeItem(it).length > 0;
}

export function aportaATotales(it) {
  return !tieneEscalas(it);
}

// Costo unitario del ítem para calcular el margen de cada escala (los costos
// propios de la línea se reparten entre las unidades de esa escala).
export function costoUnitarioEscala(it, cantidad) {
  const prod = (state.data.productos || []).find(p => p.nombre === it.articulo);
  const costoProd = prod ? (parseNumber(prod.costo) || 0) : (parseNumber(it._costoManual) || 0);
  const costosLinea = (it._costosLinea || []).reduce((s, c) =>
    s + (parseNumber(c.cantidad) || 0) * (parseNumber(c.valor_tercero) || 0), 0);
  const cant = parseNumber(cantidad) || 0;
  return costoProd + (cant > 0 ? costosLinea / cant : 0);
}

// Al convertir la cotización (a OP, RS, etc.) ya no hay lugar para varios
// precios: el cliente confirmó UNA cantidad. Aquí se pregunta cuál, ítem por
// ítem, porque de otro modo la orden saldría con cantidad y precio en cero.
export function renderElegirEscalaModal() {
  const sel = state._escalaSel;
  if (!sel) return;
  const source = state.data[DOC_INFO[sel.fromTipo].key].find(d => d.id === sel.fromId);
  if (!source) { state._escalaSel = null; return; }
  const toInfo = DOC_INFO[sel.toTipo];

  const bloques = (source.items || []).map((it, i) => {
    const esc = escalasDeItem(it);
    if (!esc.length) return "";
    return `
      <div style="border:1px solid ${C.border};border-radius:8px;padding:9px 11px;">
        <div style="font-weight:700;color:${C.text};font-size:12.5px;margin-bottom:2px;">${escapeHTML(it.articulo || "")}</div>
        ${it.descripcion ? `<div style="font-size:10.5px;color:${C.muted};margin-bottom:6px;">${escapeHTML(it.descripcion)}</div>` : ""}
        <div style="display:grid;gap:5px;">
          ${esc.map((e, j) => {
            const cant = parseNumber(e.cantidad) || 0;
            const pu   = parseNumber(e.precio_unitario) || 0;
            const elegida = sel.elegidas[i] === j;
            return `<label data-action="elegir-escala" data-item="${i}" data-esc="${j}"
              style="display:flex;align-items:center;gap:9px;cursor:pointer;padding:6px 9px;border-radius:6px;
                     border:1.5px solid ${elegida ? C.accent : C.border};background:${elegida ? C.accent + "10" : "white"};">
              <span style="font-size:13px;">${elegida ? "🔘" : "⚪"}</span>
              <span style="font-weight:700;color:${C.text};font-size:12px;min-width:90px;">${cant} und</span>
              <span style="color:${C.muted};font-size:11.5px;">× ${fmtCOP(pu)}</span>
              <span style="margin-left:auto;font-weight:800;color:${C.accent};font-size:12px;">${fmtCOP(cant * pu)}</span>
            </label>`;
          }).join("")}
        </div>
      </div>`;
  }).filter(Boolean).join("");

  state.modal = `
    <div data-action="cancelar-elegir-escala" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.55);display:flex;align-items:center;justify-content:center;z-index:1150;padding:11px;">
      <div data-action="prevent-close" style="background:white;border-radius:14px;width:520px;max-width:100%;max-height:88vh;overflow:auto;box-shadow:0 20px 60px rgba(0,0,0,.25);">
        <div style="padding:10px 12px;border-bottom:1px solid ${C.border};display:flex;justify-content:space-between;align-items:center;">
          <h3 style="margin:0;font-size:15.5px;color:${C.text};font-weight:700;">📊 ¿Qué cantidad aprobó el cliente?</h3>
          <button data-action="cancelar-elegir-escala" style="background:transparent;border:none;font-size:16px;color:${C.muted};cursor:pointer;">✕</button>
        </div>
        <div style="padding:11px;">
          <div style="font-size:11.5px;color:${C.muted};margin-bottom:10px;">
            ${escapeHTML(source.numero || "")} se cotizó con precios por cantidad. La ${toInfo.label} necesita
            una sola cantidad por ítem: elige la que el cliente confirmó.
          </div>
          <div style="display:grid;gap:9px;">${bloques}</div>
          ${sel.error ? `<div style="margin-top:9px;background:#fef2f2;border:1px solid #fca5a5;border-radius:6px;padding:6px 10px;font-size:11.5px;color:${C.red};font-weight:700;">⚠️ ${escapeHTML(sel.error)}</div>` : ""}
          <div style="font-size:10px;color:${C.muted};margin-top:9px;">💡 Si el cliente pidió otra cantidad, elige la más cercana y ajústala en la ${toInfo.label} (el precio queda editable).</div>
          <div style="display:flex;gap:10px;justify-content:flex-end;margin-top:14px;padding-top:12px;border-top:1px solid ${C.border};">
            <button data-action="cancelar-elegir-escala" style="${btnStyle(null,"secondary")}">Cancelar</button>
            <button data-action="confirmar-elegir-escala" style="${btnStyle(C.accent)}">✅ Continuar</button>
          </div>
        </div>
      </div>
    </div>
  `;
  render();
}

// ─── La celda del tercero de un costo asociado ──────────────────────────────
// No es un campo de texto: es lo que el ERP sabe del tercero elegido más el
// botón que abre el buscador. La ficha se resume ahí mismo (documento y
// tarifas) porque es lo que decide si se le puede hacer la cuenta de cobro o
// si falta completarla — y una ficha a medias solo se nota tarde, cuando hay
// que reportar la exógena.
export function celdaTerceroCosto(c, attrsBuscar, attrsQuitar, compacta) {
  const fs = compacta ? 10.5 : 11.5;
  const nombre = (c.proveedor_nombre || "").trim();
  if (!nombre) {
    return `<button ${attrsBuscar} style="width:100%;padding:${compacta ? "4px 6px" : "5px 7px"};border:1px dashed ${C.border};border-radius:6px;background:white;color:${C.muted};font-size:${fs}px;cursor:pointer;text-align:left;">🔍 Buscar tercero…</button>`;
  }
  const t = terceroDeCosto(nombre);
  const detalle = t
    ? [t.nit ? `CC/NIT ${t.nit}` : "", (parseNumber(t.retefuente) || 0) > 0 ? `RF ${parseNumber(t.retefuente)}%` : "",
       (parseNumber(t.reteica) || 0) > 0 ? `ICA ${parseNumber(t.reteica)}%` : "",
       t.responsable_iva ? "resp. IVA" : ""].filter(Boolean).join(" · ")
    : "";
  return `
    <div style="display:flex;align-items:flex-start;gap:3px;">
      <div ${attrsBuscar} title="Cambiar el tercero" style="flex:1;min-width:0;cursor:pointer;padding:${compacta ? "3px 5px" : "4px 6px"};border:1px solid ${C.border};border-radius:6px;background:white;">
        <div style="font-weight:700;color:${C.text};font-size:${fs}px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${escapeHTML(nombre)}</div>
        <div style="font-size:9px;color:${t ? C.muted : "#b45309"};white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
          ${t ? escapeHTML(detalle || "ficha sin tarifas") : "⚠️ sin ficha — elígelo del maestro"}
        </div>
      </div>
      <button ${attrsQuitar} title="Quitar el tercero" style="background:transparent;border:none;color:${C.muted};cursor:pointer;font-size:12px;padding:2px 3px;">✕</button>
    </div>`;
}

// ─── ¿Qué documento nace de este costo? ─────────────────────────────────────
// Un costo asociado se paga de dos maneras muy distintas, y la diferencia no es
// de forma: una marcación con una temporaria se compra con ORDEN DE COMPRA (y
// su IVA es descontable); un transporte con una persona natural se legaliza con
// una CUENTA DE COBRO que ella firma, y ahí hay que practicarle retención al
// causar (art. 392 E.T.). Se pregunta en la fila, junto al concepto y su valor,
// que es cuando se sabe la respuesta.
//
// La celda también muestra el documento que YA nació de este costo: sin eso, el
// hilo entre la orden y su orden de compra o su cuenta por pagar solo se veía
// entrando al otro módulo a buscarlo.
// `attrs(campo)` deja que otra ventana use la misma celda con sus propios
// enganches (la liquidación de la OP edita los costos por `state.liqConceptos`,
// no por `state.editingDoc`): la pregunta es la misma, el sitio donde se guarda
// no. Se pide por campo porque la celda hace DOS preguntas encadenadas.
export function destinoCostoCelda(c, i, attrs) {
  const enganche = typeof attrs === "function"
    ? attrs
    : (campo) => `data-costo-concepto="${i}" data-costo-field="${campo}"`;
  if (c._esComision) {
    return `<div style="font-size:9.5px;color:${C.muted};text-align:center;">comisión</div>`;
  }
  const opciones = [
    ["", "— elegir —"],
    ["ocp", "🛒 Orden de compra"],
    ["cxp", "🧾 Cuenta de cobro"],
    ["nada", "— no generar —"]
  ];
  const via = c._via || "";
  const { ocp, cxp, cc } = docsDeCosto(c);

  let pie = "";
  if (ocp) {
    pie = `<div style="font-size:9.5px;color:#0F766E;font-weight:700;margin-top:2px;">✅ ${escapeHTML(ocp.numero || "")} — en Órdenes de Compra</div>`;
  } else if (cxp) {
    pie = `<div style="font-size:9.5px;color:#0F766E;font-weight:700;margin-top:2px;">✅ ${escapeHTML(cxp.numero || "")}${cc ? ` → ${escapeHTML(cc.numero || "")}` : " — pendiente de cuenta de cobro"}</div>`;
  } else if (!via) {
    const sug = viaSugerida(c.concepto);
    pie = `<div style="font-size:9.5px;color:${C.muted};margin-top:2px;">💡 sugerido: ${sug.via === "cxp" ? "cuenta de cobro" : "orden de compra"}</div>`;
  } else if (via !== "nada" && !(c.proveedor_nombre || "").trim()) {
    pie = `<div style="font-size:9.5px;color:#b45309;margin-top:2px;">Falta el tercero</div>`;
  }

  return `
    <select ${enganche("_via")} style="${inputStyle}font-size:11px;padding:5px 7px;cursor:pointer;">
      ${opciones.map(([v, l]) => `<option value="${v}" ${via === v ? "selected" : ""}>${l}</option>`).join("")}
    </select>
    ${via === "cxp" ? selectorOcpAdemas(c, enganche("_ocpAdemas")) : ""}
    ${pie}`;
}

// ─── Además de la cuenta de cobro, ¿se le manda una orden de compra? ────────
// Lo que se le PAGA a la persona es la cuenta de cobro que firma. Pero antes de
// eso hay que decirle qué tiene que cumplir, y eso se le manda por escrito: una
// orden de compra INFORMATIVA, de su propia serie (OCI), sin IVA, que no entra
// a la bodega ni a la contabilidad y que se cierra cuando el proveedor cumple.
export function selectorOcpAdemas(c, attrs) {
  const val = c._ocpAdemas || "";
  return `
    <select ${attrs} style="${inputStyle}font-size:10.5px;padding:4px 6px;cursor:pointer;margin-top:3px;">
      <option value="" ${val !== "si" ? "selected" : ""}>Sin orden de compra</option>
      <option value="si" ${val === "si" ? "selected" : ""}>📋 Además, OCP informativa</option>
    </select>
    ${val === "si" ? `<div style="font-size:9px;color:${C.muted};margin-top:2px;">Va en su propia serie (OCI), sin IVA, y no se ingresa: es el papel del compromiso.</div>` : ""}`;
}

export function renderDocFormModal() {
  const tipo = state.editingTipo;
  const info = DOC_INFO[tipo];
  const isRC = tipo === "RC";
  const isOCP = tipo === "OCP";
  const f = state.editingDoc;

  // Los ítems con escalas de cantidad no suman: no tienen una cantidad única.
  const lineasTotales = (f.items||[]).filter(aportaATotales);
  const subtotal = lineasTotales
    .reduce((s, it) => s + (parseNumber(it.cantidad) * parseNumber(it.precio_unitario)), 0);
  // El IVA se suma LÍNEA POR LÍNEA: calcularlo sobre el subtotal entero da un
  // valor equivocado en cuanto el documento mezcla tarifas, o lleva un bien
  // excluido (art. 424) o exento (art. 477) que no debe causar impuesto.
  const desglose = desgloseIVA(lineasTotales.map(it => ({
    ...it, total: parseNumber(it.cantidad) * parseNumber(it.precio_unitario)
  })));
  const iva = isRC ? 0 : desglose.iva;
  const total = subtotal + iva;
  f._subtotal = subtotal; f._iva = iva; f._total = total; f._desgloseIVA = desglose;

  const clientOptions = (state.data.clientes||[]).map(c =>
    `<option value="${escapeHTML(c.nombre)}" data-id="${c.id}">${escapeHTML(c.nombre)}${c.nit ? " — NIT " + escapeHTML(c.nit) : ""}</option>`
  ).join("");

  const provOptions = (state.data.proveedores||[]).map(p =>
    `<option value="${escapeHTML(p.nombre)}" data-id="${p.id}">${escapeHTML(p.nombre)}${p.nit ? " — NIT " + escapeHTML(p.nit) : ""}</option>`
  ).join("");

  // Nombre mostrado en el input según el ID guardado. Con un tercero NO
  // registrado no hay ficha que buscar: el nombre lo lleva el propio documento.
  // (Si no se contemplara, el input saldría vacío al reabrir y el `blur` del
  // buscador borraría el cliente del documento.)
  const clienteNombre = esClienteLibre(f)
    ? f._clienteLibre.nombre
    : (f.cliente_id ? (state.data.clientes.find(c => c.id === f.cliente_id) || {}).nombre || "" : "");
  const provNombre = f.proveedor_id ? (state.data.proveedores.find(p => p.id === f.proveedor_id) || {}).nombre || "" : "";

  let itemsHTML;
  if ((f.items||[]).length === 0) {
    itemsHTML = `<div style="padding:11px;text-align:center;background:#f8fafc;border:1px dashed ${C.border};border-radius:6px;color:${C.muted};font-size:12px;">Sin ítems. Haz clic en "+ Agregar ítem".</div>`;
  } else {
    const showCostoMargen = tipo === "CT" || tipo === "OP";
    const isCT = tipo === "CT";
    const cols = isRC
      ? ["#","Artículo","Descripción","Referencia","Cant","Bolsas","Observ.",""]
      : isCT
        ? ["#","Artículo","Descripción","Referencia","Impresión","Cant","P.Unit","Total","Costo","Margen",""]
        : showCostoMargen
          ? ["#","Artículo","Descripción","Referencia","Color","Logo","Impresión", isOCP ? "Ubicación" : "Tinta","Cant","P.Unit","Total","Costo","Margen",""]
          : ["#","Artículo","Descripción","Referencia","Color","Logo","Impresión", isOCP ? "Ubicación" : "Tinta","Cant","P.Unit","Total",""];

    // Cuánto queda por remisionar de la OP de origen. Antes esto se escribía
    // dentro del campo de observaciones ("Disponible: 12025 de 12025"), que es
    // del usuario y se imprime en la remisión: ahora es una ayuda en pantalla
    // bajo la cantidad, se recalcula sola y no ensucia el documento.
    const pendienteOPHTML = (doc, item) => {
      if (!doc._origen || doc._origen.tipo !== "OP" || !item.articulo) return "";
      const op = (state.data.pedidos || []).find(p => p.id === doc._origen.id);
      if (!op) return "";
      const linea = (op.items || []).find(x => x.articulo === item.articulo);
      if (!linea) return "";
      const cantOP = parseNumber(linea.cantidad) || 0;
      const pendiente = cantOP - getCantidadRemisionadaOP(op.id, item.articulo, doc.id || null);
      if (cantOP <= 0) return "";
      const puesta = parseNumber(item.cantidad) || 0;
      const color = puesta > pendiente ? "#dc2626" : "#64748b";
      return `<div style="font-size:9px;font-weight:700;color:${color};margin-top:2px;text-align:right;" title="Cantidad de la OP que aún no se ha remisionado">
        Disponible: ${pendiente} de ${cantOP}${puesta > pendiente ? " ⚠️" : ""}</div>`;
    };

    // Un ítem que se arma al entregar saca de bodega otra cosa que lo que dice
    // la remisión. Decirlo ANTES de confirmarla evita la sorpresa de ver caer el
    // stock de un producto que no aparece en el documento.
    const kitOPHTML = (doc, item) => {
      if (!doc._origen || doc._origen.tipo !== "OP" || !item.articulo) return "";
      const op = (state.data.pedidos || []).find(p => p.id === doc._origen.id);
      if (!op) return "";
      if (!componentesDeArticulo(op, item.articulo).length) return "";
      // POR UNIDAD, no el total de lo que se va a entregar: la cantidad se
      // teclea y el campo no se re-renderiza en cada letra (eso mataría el
      // foco), así que un total quedaría desactualizado justo cuando importa.
      // La proporción, en cambio, no cambia nunca.
      return `<div style="font-size:9px;font-weight:700;color:#7c3aed;margin-top:2px;" title="Este artículo se arma al entregar: de la bodega salen sus partes, no él.">
        🧩 Se arma al entregar — por unidad sale de bodega: ${escapeHTML(descripcionKit(op, item.articulo))}</div>`;
    };

    // Todas las demás columnas llevan ancho fijo, así que sin un mínimo propio
    // el nombre y la descripción se quedan con las sobras y salen recortados
    // ("Set Eje…"): con muchos ítems es imposible saber cuál se está borrando.
    const tdArticulo = "padding:3px;min-width:250px;";
    const tdDescripcion = "padding:3px;min-width:150px;";

    const rows = f.items.map((it, i) => {
      const refCell = `<td style="padding:3px;width:90px;"><input data-item="${i}" data-field="referencia" value="${escapeHTML(it.referencia||"")}" placeholder="Ref." style="${inputStyle}font-size:11.5px;padding:5px 7px;"/></td>`;
      const prodMatch = (state.data.productos||[]).find(p => p.nombre === it.articulo) || null;
      // Con costos de línea, el precio deja de ser un número que se teclea: sale
      // del costo real por unidad (producto + costos ÷ cantidad) con la
      // rentabilidad establecida. Así el precio BAJA al subir la cantidad — el
      // mismo screen fijo pesa menos por unidad en 100 que en 50.
      // El precio SIEMPRE se puede teclear: precio y margen son dos caras de lo
      // mismo. Solo se recalcula solo cuando hay un margen fijado a mano (o,
      // en catálogo con costos de línea, con la rentabilidad del producto);
      // si no, manda el precio escrito y el margen se muestra derivado.
      // `precioDerivado` marca la línea cuyo precio SALE del costo y el margen,
      // para poder decírselo al usuario en el campo. Antes esta bandera existía
      // pero nunca se asignaba: la celda de solo lectura que dependía de ella no
      // se pintaba jamás, y como el recálculo en vivo solo escribía en ESA celda,
      // el precio nuevo se quedaba en memoria sin llegar a la pantalla — se veía
      // el precio anterior junto a un total ya calculado con el nuevo.
      let precioDerivado = false;
      if (isCT && it.articulo) {
        if (margenFijadoLinea(it) != null) {
          const pc = prodMatch ? calcPrecioCatalogoItem(it, prodMatch) : calcPrecioManualItem(it);
          if (pc != null && pc > 0) { it.precio_unitario = pc; precioDerivado = true; }
        } else if (prodMatch && itemConCostosLinea(it) && !it._precioManual) {
          // Solo si el precio nunca se tecleó. Sin esta condición, al abrir la
          // cotización el precio escrito a mano se reemplazaba por el que sale
          // del margen del producto — "guardo un precio y al volver a entrar
          // aparece otro".
          const pc = calcPrecioCatalogoItem(it, prodMatch);
          if (pc != null) { it.precio_unitario = pc; precioDerivado = true; }
        }
      }
      // El costo real por unidad, para explicar en el campo de dónde sale el
      // precio. Se calcula aquí porque la celda del costo vive más abajo.
      const _costoRealLinea = isCT && it.articulo
        ? costoUnitarioItem(it, prodMatch ? prodMatch.costo : it._costoManual) : 0;
      const tituloPrecio = precioDerivado
        ? `Calculado: costo real por unidad ${fmtCOP(_costoRealLinea)} (incluye los costos asociados de la línea repartidos entre ${parseNumber(it.cantidad)||0} unidades) con el ${(margenEfectivoLinea(it, prodMatch)||0).toFixed(1)}% de rentabilidad. Se puede teclear otro precio: entonces manda el precio y el margen pasa a ser el que resulte.`
        : "Precio de venta unitario";
      const inputs = isRC
        ? `
          <td style="${tdArticulo}">
            <input data-item="${i}" data-field="articulo" title="${escapeHTML(it.articulo)}" value="${escapeHTML(it.articulo)}" style="${inputStyle}font-size:11.5px;padding:5px 7px;"/>
            ${kitOPHTML(f, it)}
          </td>
          <td style="${tdDescripcion}"><input data-item="${i}" data-field="descripcion" title="${escapeHTML(it.descripcion)}" value="${escapeHTML(it.descripcion)}" style="${inputStyle}font-size:11.5px;padding:5px 7px;"/></td>
          ${refCell}
          <td style="padding:3px;width:70px;">
            <input data-item="${i}" data-field="cantidad" inputmode="decimal" value="${escapeHTML(it.cantidad||"")}" style="${inputStyle}font-size:11.5px;padding:5px 7px;text-align:right;"/>
            ${pendienteOPHTML(f, it)}
          </td>
          <td style="padding:3px;width:70px;"><input data-item="${i}" data-field="bolsas" inputmode="numeric" value="${escapeHTML(it.bolsas||"")}" style="${inputStyle}font-size:11.5px;padding:5px 7px;text-align:right;"/></td>
          <td style="padding:3px;"><input data-item="${i}" data-field="observaciones" value="${escapeHTML(it.observaciones||"")}" style="${inputStyle}font-size:11.5px;padding:5px 7px;"/></td>
        `
        : isCT
          ? `
          <td style="${tdArticulo}">
            <input data-item="${i}" data-field="articulo" title="${escapeHTML(it.articulo)}" value="${escapeHTML(it.articulo)}" style="${inputStyle}font-size:11.5px;padding:5px 7px;"/>
            ${it.articulo ? (()=>{
              const _op = state.editingDoc && state.editingDoc.tipo === "OP" ? state.editingDoc.id : null;
              const _b = getStockProducto(it.articulo);
              const _comp = getComprometidoPorEntregar(it.articulo, _op);
              const _s = _b - _comp;                          // lo que se puede prometer
              const _c = parseNumber(it.cantidad)||0;
              const _col = _s<=0?"#dc2626":(_c>0&&_s<_c?"#f59e0b":"#16a34a");
              return `<div style="font-size:9px;font-weight:700;color:${_col};margin-top:2px;">📦 Disponible: ${_s}${_c>0&&_s<_c?" — insuficiente":""}${_comp>0?` <span style="color:${C.muted};font-weight:600;">(${_b} en bodega, ${_comp} ya vendido)</span>`:""}</div>`;
            })() : ""}
            ${(it.articulo && !prodMatch) ? `<button data-action="crear-producto-desde-item" data-idx="${i}" style="margin-top:4px;font-size:10px;padding:2px 6px;border-radius:4px;border:1px solid ${C.purple};background:${C.purple}12;color:${C.purple};cursor:pointer;font-weight:700;">➕ Crear producto</button>` : ""}
          </td>
          <td style="${tdDescripcion}"><input data-item="${i}" data-field="descripcion" title="${escapeHTML(it.descripcion)}" value="${escapeHTML(it.descripcion)}" style="${inputStyle}font-size:11.5px;padding:5px 7px;"/></td>
          ${refCell}
          <td style="padding:3px;width:110px;"><input data-item="${i}" data-field="impresion" list="list-tecnicas-impresion" autocomplete="off" value="${escapeHTML(it.impresion||"")}" placeholder="Elige o escribe" style="${inputStyle}font-size:11.5px;padding:5px 7px;"/></td>
          <td style="padding:3px;width:80px;"><input data-item="${i}" data-field="cantidad" inputmode="decimal" value="${escapeHTML(it.cantidad||"")}" style="${inputStyle}font-size:11.5px;padding:5px 7px;text-align:right;"/></td>
          ${/* El precio siempre se puede teclear —precio y margen son dos caras de
                lo mismo— así que es un input incluso cuando viene calculado; lo
                que cambia es que se marca como derivado y se explica en el título. */ ""}
          <td style="padding:3px;width:110px;">
            <input data-item="${i}" data-field="precio_unitario" inputmode="decimal" title="${escapeHTML(tituloPrecio)}" value="${escapeHTML(it.precio_unitario||"")}" style="${inputStyle}font-size:11.5px;padding:5px 7px;text-align:right;${precioDerivado ? `background:#faf5ff;border-color:#c4b5fd;` : ""}"/>
            <div data-punit-hint="${i}" style="font-size:9px;color:#7c3aed;font-weight:700;text-align:right;margin-top:2px;">${precioDerivado ? `↻ del costo ${fmtCOP(_costoRealLinea)}` : ""}</div>
          </td>
          <td style="padding:3px;width:110px;font-weight:700;font-size:11.5px;text-align:right;color:${tieneEscalas(it) ? C.muted : C.text};">${
            tieneEscalas(it)
              ? `<span style="font-weight:600;font-size:10px;" title="Esta línea se cotiza por cantidad: el total está en el cuadro azul, uno por cantidad.">por cantidad ↓</span>`
              : fmtCOP(parseNumber(it.cantidad) * parseNumber(it.precio_unitario))}</td>
        `
          : `
          <td style="${tdArticulo}"><input data-item="${i}" data-field="articulo" title="${escapeHTML(it.articulo)}" value="${escapeHTML(it.articulo)}" style="${inputStyle}font-size:11.5px;padding:5px 7px;"/></td>
          <td style="${tdDescripcion}"><input data-item="${i}" data-field="descripcion" title="${escapeHTML(it.descripcion)}" value="${escapeHTML(it.descripcion)}" style="${inputStyle}font-size:11.5px;padding:5px 7px;"/></td>
          ${refCell}
          <td style="padding:3px;width:80px;"><input data-item="${i}" data-field="color" value="${escapeHTML(it.color||"")}" style="${inputStyle}font-size:11.5px;padding:5px 7px;"/></td>
          <td style="padding:3px;width:80px;"><input data-item="${i}" data-field="logo" value="${escapeHTML(it.logo||"")}" style="${inputStyle}font-size:11.5px;padding:5px 7px;"/></td>
          <td style="padding:3px;width:110px;"><input data-item="${i}" data-field="impresion" list="list-tecnicas-impresion" autocomplete="off" value="${escapeHTML(it.impresion||"")}" placeholder="Elige o escribe" style="${inputStyle}font-size:11.5px;padding:5px 7px;"/></td>
          <td style="padding:3px;width:90px;"><input data-item="${i}" data-field="${isOCP ? "ubicacion" : "tinta"}" value="${escapeHTML(isOCP ? it.ubicacion||"" : it.tinta||"")}" style="${inputStyle}font-size:11.5px;padding:5px 7px;"/></td>
          <td style="padding:3px;width:80px;"><input data-item="${i}" data-field="cantidad" inputmode="decimal" value="${escapeHTML(it.cantidad||"")}" style="${inputStyle}font-size:11.5px;padding:5px 7px;text-align:right;"/></td>
          <td style="padding:3px;width:110px;"><input data-item="${i}" data-field="precio_unitario" inputmode="decimal" value="${escapeHTML(it.precio_unitario||"")}" style="${inputStyle}font-size:11.5px;padding:5px 7px;text-align:right;"/></td>
          <td style="padding:3px;width:110px;font-weight:700;font-size:11.5px;text-align:right;color:${C.text};">${fmtCOP(parseNumber(it.cantidad) * parseNumber(it.precio_unitario))}</td>
        `;

      // Columna de costo y margen (CT y OP): muestra el costo del producto en maestros y valida antigüedad
      let costoCell = "";
      let margenCell = "";
      if (showCostoMargen) {
        const prod = prodMatch;
        if (!prod) {
          if (isCT && it.articulo) {
            // El input es el costo BASE que teclea el usuario; debajo va el
            // costo unitario REAL, que incluye los costos asociados repartidos.
            // Sin eso, el precio sale de un costo que no está a la vista.
            costoCell = `<td data-costo-display-wrap="${i}" style="padding:3px;width:130px;">
              <input data-item="${i}" data-field="_costoManual" type="number" inputmode="decimal" min="0" value="${escapeHTML(it._costoManual!=null?String(it._costoManual):"")}" placeholder="Costo" style="${inputStyle}font-size:10.5px;padding:4px 6px;text-align:right;"/>
              <div data-costo-display="${i}" data-costo-modo="extra" style="text-align:right;margin-top:2px;font-size:10px;">${costoLineaHTML(it, null, "extra")}</div>
            </td>`;
            // Sin margen fijado se muestra el que resulta del precio escrito:
            // así el campo nunca queda mudo si se cotiza tecleando el precio.
            const _costoMan = costoUnitarioItem(it, it._costoManual);
            const _pvMan = parseNumber(it.precio_unitario) || 0;
            const _mMan = margenFijadoLinea(it) != null
              ? String(it._margenManual)
              : (_pvMan > 0 && _costoMan > 0 ? ((1 - _costoMan / _pvMan) * 100).toFixed(1) : "");
            margenCell = `<td style="padding:3px;width:100px;"><input data-item="${i}" data-field="_margenManual" type="number" inputmode="decimal" step="0.01" min="0" max="99" value="${escapeHTML(_mMan)}" placeholder="Margen %" style="${inputStyle}font-size:10.5px;padding:4px 6px;text-align:right;"/></td>`;
          } else {
            costoCell = `<td style="padding:3px;width:120px;font-size:10.5px;color:${C.muted};text-align:center;">—</td>`;
            margenCell = `<td style="padding:3px;width:90px;font-size:10.5px;color:${C.muted};text-align:center;">—</td>`;
          }
        } else {
          const costoVal = costoUnitarioItem(it, costoBaseProducto(prod));
          let diasDesde = null;
          if (prod._costo_fecha) {
            diasDesde = Math.floor((new Date(today()+"T12:00:00") - new Date(prod._costo_fecha+"T12:00:00")) / (1000*60*60*24));
          }
          const esViejo = prod._costo_fecha == null || diasDesde > 15;
          costoCell = `
            <td style="padding:3px;width:130px;font-size:10.5px;text-align:right;">
              <div data-costo-display="${i}" data-costo-modo="completo">${costoLineaHTML(it, prod, "completo")}</div>
              ${esViejo
                ? `<button data-action="update-product-cost" data-product-id="${prod.id}" data-item-idx="${i}" style="margin-top:3px;font-size:10px;padding:2px 6px;border-radius:4px;border:1px solid ${C.amber};background:#fffbeb;color:${C.amber};cursor:pointer;">⚠️ ${prod._costo_fecha ? "Costo de hace " + diasDesde + " días" : "Sin fecha"} — Actualizar</button>`
                : `<div style="font-size:9px;color:${C.muted};">act. hace ${diasDesde} día${diasDesde===1?"":"s"}</div>`
              }
            </td>
          `;
          // Margen de utilidad = 1 - (costo unitario / precio de venta unitario), en porcentaje
          const precioVenta = parseNumber(it.precio_unitario) || 0;
          if (isCT) {
            // En la cotización el margen de la línea se puede ajustar: escribirlo
            // recalcula el precio de ESTA línea sin tocar el margen del producto.
            const margenLinea = it._margenManual != null && it._margenManual !== ""
              ? String(it._margenManual)
              : (precioVenta > 0 && costoVal > 0)
                ? ((1 - (costoVal / precioVenta)) * 100).toFixed(1)
                : (margenEfectivoLinea(it, prod) != null ? margenEfectivoLinea(it, prod).toFixed(1) : "");
            const mNum = parseNumber(margenLinea);
            const margenColor = !(mNum > 0) ? C.muted : mNum < 20 ? C.red : mNum < 40 ? C.amber : "#10b981";
            margenCell = `<td style="padding:3px;width:100px;" title="Margen de esta línea. Ajustarlo recalcula el precio de la línea y NO cambia el margen del producto en el catálogo."><input data-item="${i}" data-field="_margenManual" type="number" inputmode="decimal" step="0.01" min="0" max="99" value="${escapeHTML(margenLinea)}" placeholder="%" style="${inputStyle}font-size:11.5px;padding:4px 6px;text-align:center;font-weight:700;color:${margenColor};"/></td>`;
          } else if (precioVenta > 0) {
            const margenPct = (1 - (costoVal / precioVenta)) * 100;
            const margenColor = margenPct < 20 ? C.red : margenPct < 40 ? C.amber : "#10b981";
            margenCell = `<td style="padding:3px;width:90px;font-size:11.5px;font-weight:700;text-align:center;color:${margenColor};">${margenPct.toFixed(1)}%</td>`;
          } else {
            margenCell = `<td style="padding:3px;width:90px;font-size:10.5px;color:${C.muted};text-align:center;">—</td>`;
          }
        }
      }
      // Costos propios de la línea (marcación, domicilio, maquila…). Solo en la
      // cotización: es donde se arma el precio. Al convertirla en OP pasan a los
      // costos asociados del documento y entran al costo total.
      const costosLinea = isCT ? (it._costosLinea || []) : [];
      const totalCostosLinea = costosLinea.reduce((sum, c) => sum + (parseNumber(c.cantidad)||0) * (parseNumber(c.valor_tercero)||0), 0);
      const filaCostos = (isCT && costosLinea.length) ? `
        <tr style="background:#f0fdf4;">
          <td></td>
          <td colspan="${cols.length - 1}" style="padding:4px 6px 9px;">
            <div style="border-left:3px solid #10b981;border-radius:0 6px 6px 0;background:white;padding:7px 9px;">
              <div style="font-size:10px;font-weight:800;color:#047857;letter-spacing:.4px;margin-bottom:5px;">
                💰 COSTOS DE ESTA LÍNEA <span style="font-weight:600;color:${C.muted};">— pasan a la orden de producción</span>
              </div>
              <table style="width:100%;border-collapse:collapse;">
                <thead><tr>
                  <th style="text-align:left;font-size:9.5px;color:${C.muted};font-weight:700;padding:0 4px 3px;">Concepto</th>
                  <th style="text-align:left;font-size:9.5px;color:${C.muted};font-weight:700;padding:0 4px 3px;width:170px;">Proveedor</th>
                  <th style="text-align:left;font-size:9.5px;color:${C.muted};font-weight:700;padding:0 4px 3px;width:160px;" title="Si este costo ES un producto del catálogo, elígelo: la orden de compra saldrá con ese artículo y su IVA.">Producto <span style="font-weight:600;">(opcional)</span></th>
                  <th style="text-align:right;font-size:9.5px;color:${C.muted};font-weight:700;padding:0 4px 3px;width:80px;">Cant</th>
                  <th style="text-align:right;font-size:9.5px;color:${C.muted};font-weight:700;padding:0 4px 3px;width:120px;">Valor unit.</th>
                  <th style="text-align:right;font-size:9.5px;color:${C.muted};font-weight:700;padding:0 4px 3px;width:110px;">Total</th>
                  <th style="width:26px;"></th>
                </tr></thead>
                <tbody>
                  ${costosLinea.map((c, j) => `
                    <tr>
                      <td style="padding:2px 4px;"><input data-costo-linea="${i}" data-costo-idx="${j}" data-costo-field="concepto" value="${escapeHTML(c.concepto||"")}" placeholder="Ej: Marcación tampografía, domicilio…" style="${inputStyle}font-size:11px;padding:4px 6px;"/></td>
                      ${/* Mismo buscador que en la OP: estos costos se vuelven
                            los costos asociados de la orden, así que el tercero
                            tiene que ser uno del maestro desde aquí. */ ""}
                      <td style="padding:2px 4px;">${celdaTerceroCosto(c, `data-action="buscar-tercero-costo-linea" data-idx="${i}" data-sub="${j}"`, `data-action="quitar-tercero-costo-linea" data-idx="${i}" data-sub="${j}"`, true)}</td>
                      ${/* Apuntar el costo a un producto del catálogo es lo que
                            convierte la orden de compra en una compra de
                            artículos reales: cada uno con su IVA (la matera al
                            19%, la mata viva excluida) y con su ficha de
                            inventario. Vacío = concepto suelto, como siempre. */ ""}
                      <td style="padding:2px 4px;">
                        <input data-costo-linea="${i}" data-costo-idx="${j}" data-costo-field="articulo"
                          list="list-productos-costos" autocomplete="off"
                          value="${escapeHTML(c.articulo||"")}" placeholder="— sin producto —"
                          style="${inputStyle}font-size:11px;padding:4px 6px;"/>
                        ${(() => {
                          if (!c.articulo) return "";
                          const prodC = productoDeArticulo(c.articulo);
                          if (!prodC) return `<div style="font-size:9px;color:#b45309;margin-top:2px;">No está en el catálogo — saldrá como concepto</div>`;
                          const rC = regimenDeProducto(prodC);
                          return `<div style="font-size:9px;color:${rC.tipo === "gravado" ? C.muted : "#92400e"};margin-top:2px;font-weight:700;">${escapeHTML(etiquetaRegimen(rC))}</div>`;
                        })()}
                      </td>
                      <td style="padding:2px 4px;"><input data-costo-linea="${i}" data-costo-idx="${j}" data-costo-field="cantidad" type="number" inputmode="decimal" min="0" value="${c.cantidad!=null?c.cantidad:""}" placeholder="0" style="${inputStyle}font-size:11px;padding:4px 6px;text-align:right;"/></td>
                      <td style="padding:2px 4px;"><input data-costo-linea="${i}" data-costo-idx="${j}" data-costo-field="valor_tercero" type="number" inputmode="decimal" min="0" value="${c.valor_tercero!=null?c.valor_tercero:""}" placeholder="0" style="${inputStyle}font-size:11px;padding:4px 6px;text-align:right;"/></td>
                      <td style="padding:2px 4px;text-align:right;font-weight:700;font-size:11px;color:${C.text};">${fmtCOP((parseNumber(c.cantidad)||0) * (parseNumber(c.valor_tercero)||0))}</td>
                      <td style="padding:2px;text-align:center;"><button data-action="remove-costo-linea" data-idx="${i}" data-sub="${j}" style="background:transparent;border:none;color:${C.red};cursor:pointer;font-size:14px;">🗑</button></td>
                    </tr>`).join("")}
                </tbody>
              </table>
              <div style="display:flex;justify-content:space-between;align-items:center;margin-top:6px;padding-top:5px;border-top:1px dashed ${C.border};">
                <button data-action="add-costo-linea" data-idx="${i}" style="${btnStyle("#10b981", null, true)}font-size:10.5px;">+ Otro costo</button>
                <div style="font-size:11px;font-weight:800;color:#047857;">Costos de la línea: ${fmtCOP(totalCostosLinea)}</div>
              </div>
            </div>
          </td>
        </tr>` : "";

      // Escalas de cantidad de la línea: el mismo artículo a 100, 500 y 1000,
      // cada cantidad con su precio y su margen. Solo en la cotización.
      const escalas = isCT ? (it._escalas || []) : [];
      const filaEscalas = (isCT && escalas.length) ? `
        <tr style="background:#eff6ff;">
          <td></td>
          <td colspan="${cols.length - 1}" style="padding:4px 6px 9px;">
            <div style="border-left:3px solid ${C.blue};border-radius:0 6px 6px 0;background:white;padding:7px 9px;">
              <div style="font-size:10px;font-weight:800;color:#1e40af;letter-spacing:.4px;margin-bottom:5px;">
                📊 PRECIO POR CANTIDAD <span style="font-weight:600;color:${C.muted};">— se imprime una sola vez el artículo, con una línea por cantidad</span>
              </div>
              <table style="width:100%;border-collapse:collapse;">
                <thead><tr>
                  <th style="text-align:right;font-size:9.5px;color:${C.muted};font-weight:700;padding:0 4px 3px;width:110px;">Cantidad</th>
                  <th style="text-align:right;font-size:9.5px;color:${C.muted};font-weight:700;padding:0 4px 3px;width:130px;">Precio unit.</th>
                  <th style="text-align:right;font-size:9.5px;color:${C.muted};font-weight:700;padding:0 4px 3px;width:130px;">Total</th>
                  <th style="text-align:center;font-size:9.5px;color:${C.muted};font-weight:700;padding:0 4px 3px;width:90px;">Margen</th>
                  <th style="width:26px;"></th>
                </tr></thead>
                <tbody>
                  ${escalas.map((e, j) => {
                    const _cant = parseNumber(e.cantidad) || 0;
                    const _pu   = parseNumber(e.precio_unitario) || 0;
                    const _cu   = costoUnitarioEscala(it, _cant);
                    // El margen de la escala se puede escribir: fijarlo calcula
                    // el precio de ESA cantidad desde su costo por unidad. Si no
                    // se fijó, manda el precio y el margen sale derivado.
                    const _mFijo = margenFijadoEscala(e);
                    const _m    = _mFijo != null ? _mFijo : ((_pu > 0 && _cu > 0) ? (1 - _cu / _pu) * 100 : null);
                    const _mCol = _m == null ? C.muted : _m < 20 ? C.red : _m < 40 ? C.amber : "#10b981";
                    return `
                    <tr>
                      <td style="padding:2px 4px;"><input data-escala="${i}" data-escala-idx="${j}" data-escala-field="cantidad" type="number" inputmode="decimal" min="0" value="${e.cantidad!=null?e.cantidad:""}" placeholder="Ej: 100" style="${inputStyle}font-size:11px;padding:4px 6px;text-align:right;"/></td>
                      <td style="padding:2px 4px;"><input data-escala="${i}" data-escala-idx="${j}" data-escala-field="precio_unitario" type="number" inputmode="decimal" min="0" value="${e.precio_unitario!=null?e.precio_unitario:""}" placeholder="0" style="${inputStyle}font-size:11px;padding:4px 6px;text-align:right;"/></td>
                      <td data-escala-total="${i}-${j}" style="padding:2px 4px;text-align:right;font-weight:700;font-size:11px;color:${C.text};">${fmtCOP(_cant * _pu)}</td>
                      <td style="padding:2px 4px;" title="Margen de esta cantidad. Escribirlo calcula su precio desde el costo por unidad de esa cantidad (los costos de la línea se reparten entre más unidades). Borrarlo devuelve el mando al precio."><input data-escala="${i}" data-escala-idx="${j}" data-escala-field="margen" type="number" inputmode="decimal" step="0.01" min="0" max="99" value="${_m == null ? "" : _m.toFixed(1)}" placeholder="%" style="${inputStyle}font-size:11px;padding:4px 6px;text-align:center;font-weight:700;color:${_mCol};"/></td>
                      <td style="padding:2px;text-align:center;"><button data-action="remove-escala" data-idx="${i}" data-sub="${j}" style="background:transparent;border:none;color:${C.red};cursor:pointer;font-size:14px;">🗑</button></td>
                    </tr>`;
                  }).join("")}
                </tbody>
              </table>
              <div style="display:flex;justify-content:space-between;align-items:center;margin-top:6px;padding-top:5px;border-top:1px dashed ${C.border};gap:10px;">
                <button data-action="add-escala" data-idx="${i}" style="${btnStyle(C.blue, null, true)}font-size:10.5px;">+ Otra cantidad</button>
                <div style="font-size:10px;color:${C.muted};text-align:right;">
                  Esta línea no suma al total del documento: el cliente elige la cantidad.
                </div>
              </div>
            </div>
          </td>
        </tr>` : "";

      // El orden de los ítems es el que sale impreso, así que se puede acomodar
      // arrastrando la fila por su número (asa ⠿). Se arrastra SOLO desde el
      // asa: con la fila entera arrastrable, seleccionar texto dentro de un
      // campo se convertiría en un arrastre.
      const sePuedeOrdenar = f.items.length > 1;
      const btnMover = (dir, glifo, titulo, hab) => `
        <button data-action="mover-item" data-idx="${i}" data-dir="${dir}" title="${titulo}" ${hab ? "" : "disabled"}
          style="background:transparent;border:none;padding:0;line-height:1;font-size:9px;cursor:${hab ? "pointer" : "default"};color:${hab ? C.muted : "#e2e8f0"};">${glifo}</button>`;
      return `<tr data-item-row="${i}" style="border-top:1px solid ${C.border};">
        <td ${sePuedeOrdenar ? `data-item-asa="${i}" title="Arrastra para cambiar el orden"` : ""}
            style="padding:3px;width:52px;color:${C.muted};${sePuedeOrdenar ? "cursor:grab;user-select:none;" : ""}">
          <div style="display:flex;align-items:center;justify-content:center;gap:3px;">
            ${sePuedeOrdenar ? `<span style="font-size:11px;color:${C.dim};letter-spacing:1px;">⠿</span>` : ""}
            <span>${i+1}</span>
            ${sePuedeOrdenar ? `<span style="display:flex;flex-direction:column;gap:1px;">
              ${btnMover(-1, "▲", "Subir", i > 0)}
              ${btnMover(1, "▼", "Bajar", i < f.items.length - 1)}
            </span>` : ""}
          </div>
        </td>
        ${inputs}
        ${costoCell}
        ${margenCell}
        <td style="padding:3px;width:52px;text-align:center;white-space:nowrap;">
          ${isCT ? `<button data-action="add-costo-linea" data-idx="${i}" title="Agregar costos a esta línea (marcación, domicilio…)" style="background:transparent;border:none;color:${costosLinea.length ? "#047857" : C.muted};cursor:pointer;font-size:14px;">💰${costosLinea.length ? `<span style="font-size:9px;font-weight:800;">${costosLinea.length}</span>` : ""}</button>` : ""}
          ${isCT ? `<button data-action="add-escala" data-idx="${i}" title="Cotizar este mismo artículo a varias cantidades, cada una con su precio" style="background:transparent;border:none;color:${escalas.length ? C.blue : C.muted};cursor:pointer;font-size:14px;">📊${escalas.length ? `<span style="font-size:9px;font-weight:800;">${escalas.length}</span>` : ""}</button>` : ""}
          <button data-action="remove-item" data-idx="${i}" style="background:transparent;border:none;color:${C.red};cursor:pointer;font-size:16px;">🗑</button>
        </td>
      </tr>${filaCostos}${filaEscalas}`;
    }).join("");

    itemsHTML = `
      <datalist id="list-productos-costos">${(state.data.productos||[])
        .map(pr => `<option value="${escapeHTML(pr.nombre)}"></option>`).join("")}</datalist>
      <datalist id="list-tecnicas-impresion">${TECNICAS_IMPRESION.map(t => `<option value="${escapeHTML(t)}"></option>`).join("")}</datalist>
      <div>
        <table style="width:100%;border-collapse:collapse;font-size:11.5px;">
          <thead>
            <tr style="background:#f1f5f9;">
              ${cols.map(c => `<th style="position:sticky;top:44px;z-index:5;background:#f1f5f9;padding:8px 6px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">${c}</th>`).join("")}
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
      </div>
    `;
  }

  const margenTotalInfo = (tipo === "CT" || tipo === "OP") ? calcularMargenTotal(f.items) : null;
  const margenTotalHTML = margenTotalInfo ? (() => {
    const colorIni = margenTotalInfo.pct < 20 ? C.red : margenTotalInfo.pct < 40 ? C.amber : "#10b981";
    const labelIni = tipo === "OP" ? "Margen de utilidad inicial" : "Margen de utilidad total";
    let html = `<div style="font-size:12px;margin-top:6px;padding-top:6px;border-top:1px dashed ${C.border};">${labelIni}: <strong style="color:${colorIni};">${margenTotalInfo.pct.toFixed(1)}%</strong></div>`;
    // (El margen total ya incluye los costos de línea: calcularMargenTotal los
    // suma como costo real del ítem, así que no hace falta una línea aparte.)
    if (tipo === "OP") {
      const totalCostosAsociados = (f._conceptosCosto||[]).reduce((s,c) => s + (parseNumber(c.cantidad)||0) * (parseNumber(c.valor_tercero)||0), 0);
      const costoTotalFinal = margenTotalInfo.costoTotal + totalCostosAsociados;
      const margenFinalPct = margenTotalInfo.ventaTotal > 0 ? (1 - (costoTotalFinal / margenTotalInfo.ventaTotal)) * 100 : margenTotalInfo.pct;
      const colorFin = margenFinalPct < 20 ? C.red : margenFinalPct < 40 ? C.amber : "#10b981";
      html += `<div style="font-size:12px;margin-top:4px;">Margen de utilidad final <span style="color:${C.muted};font-size:10.5px;">(con costos asociados)</span>: <strong style="color:${colorFin};">${margenFinalPct.toFixed(1)}%</strong></div>`;
    }
    return html;
  })() : "";

  // Con ítems por cantidad el total del documento no existe todavía: mostrar
  // "$ 0" al lado de precios de millones se lee como un error de la cotización.
  const soloEscalas = (f.items || []).length > 0 && (f.items || []).every(tieneEscalas);
  const totalsHTML = isRC ? "" : `
    <div style="margin-top:14px;padding:10px;background:#f8fafc;border-radius:6px;text-align:right;" id="form-totals-box">
      ${soloEscalas ? `
      <div style="text-align:left;font-size:11.5px;color:${C.text};">
        <strong style="color:${C.blue};">📊 Cotización por cantidad.</strong>
        No hay un total del documento: cada cantidad tiene el suyo. Se define cuando el cliente
        confirme la cantidad (se pregunta al convertirla en Orden de Producción).
      </div>` : `
      <div style="font-size:12px;color:${C.muted};margin-bottom:4px;">Subtotal: <strong style="color:${C.text};">${fmtCOP(subtotal)}</strong></div>
      ${renglonesIVA(lineasTotales.map(it => ({ ...it, total: parseNumber(it.cantidad) * parseNumber(it.precio_unitario) })), iva).map(r => `<div style="font-size:12px;color:${C.muted};margin-bottom:4px;">${escapeHTML(r.lbl)}: <strong style="color:${C.text};">${fmtCOP(r.valor)}</strong></div>`).join("")}
      <div style="font-size:16px;font-weight:800;color:${info.color};">TOTAL: ${fmtCOP(total)}</div>`}
      ${margenTotalHTML}
    </div>
  `;

  const extraOP = tipo === "OP" ? `
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-bottom:9px;">
      <div>
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;">N° Orden de Compra del cliente</label>
        <input data-form="numero_oc_cliente" value="${escapeHTML(f.numero_oc_cliente||"")}" placeholder="N° OC del cliente (opcional)" style="${inputStyle}"/>
      </div>
      <div>
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;">Condiciones de envío</label>
        <input data-form="condiciones_envio" value="${escapeHTML(f.condiciones_envio||"")}" placeholder="Ej: Entrega en bodega del cliente" style="${inputStyle}"/>
      </div>
      <div>
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;">Forma de pago</label>
        <input data-form="condiciones_pago" value="${escapeHTML(f.condiciones_pago||"")}" placeholder="Ej: Crédito 30 días" style="${inputStyle}"/>
      </div>
      <div>
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;">Enviar a (dirección de entrega)</label>
        <textarea data-form="enviar_a" rows="3" placeholder="Nombre / dirección / contacto / teléfono de quien recibe" style="${inputStyle}resize:vertical;">${escapeHTML(f.enviar_a||"")}</textarea>
        <div style="font-size:10px;color:${C.muted};margin-top:4px;">💡 Se imprime en el bloque "ENVIAR A" del documento. Si se deja vacío, se usa la dirección del cliente.</div>
      </div>
    </div>
    <div style="margin-bottom:9px;padding:9px;background:#f8fafc;border-left:3px solid #2B4A82;border-radius:6px;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
        <h4 style="margin:0;color:${C.text};font-size:12px;font-weight:700;">📅 Fechas de entrega</h4>
        <button data-action="add-entrega-op" style="${btnStyle(C.accent,null,true)}">+ Agregar fecha</button>
      </div>
      ${(f._entregas && f._entregas.length > 0) ? f._entregas.map((ent,i) => `
        <div style="display:flex;gap:8px;align-items:center;margin-bottom:6px;">
          <div style="font-size:11.5px;font-weight:600;color:${C.muted};width:78px;flex-shrink:0;">Entrega ${i+1}</div>
          <input data-entrega="${i}" data-entrega-field="fecha" type="date" value="${escapeHTML(ent.fecha||"")}" style="${inputStyle}flex:1;"/>
          <input data-entrega="${i}" data-entrega-field="nota" value="${escapeHTML(ent.nota||"")}" placeholder="Nota (opcional)" style="${inputStyle}flex:2;"/>
          <button data-action="remove-entrega-op" data-idx="${i}" style="background:transparent;border:none;color:${C.red};cursor:pointer;font-size:16px;flex-shrink:0;">🗑</button>
        </div>
      `).join("") : `<div style="font-size:11.5px;color:${C.muted};">Sin fechas de entrega definidas. Haz clic en "+ Agregar fecha".</div>`}
    </div>
  ` : "";

  const extraCT = tipo === "CT" ? `
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-bottom:9px;">
      <div>
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;">Tiempo de entrega (días hábiles) <span style="color:${C.red};">*</span></label>
        <input data-form="tiempo_entrega" type="number" min="1" step="1" inputmode="numeric"
          value="${escapeHTML(String(f.tiempo_entrega ?? ""))}" placeholder="Ej: 10" style="${inputStyle}"/>
        <div style="font-size:10px;color:${f.tiempo_entrega ? C.muted : C.amber};margin-top:3px;font-weight:${f.tiempo_entrega ? "400" : "600"};">
          ${f.tiempo_entrega
            ? `Saldrá impreso como <b>${escapeHTML(textoTiempoEntrega(f.tiempo_entrega))}</b>`
            : "⚠️ Obligatorio: el cliente necesita saber en cuánto se le entrega."}
        </div>
      </div>
      <div>
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;">Condiciones de pago</label>
        <input data-form="condiciones_pago" value="${escapeHTML(f.condiciones_pago||"")}" placeholder="Se carga automáticamente del cliente" style="${inputStyle}"/>
        <div style="font-size:10px;color:${C.muted};margin-top:4px;">💡 Se precarga automáticamente al seleccionar cliente/proveedor</div>
      </div>
      <div>
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;">Lugar de entrega</label>
        <input data-form="lugar_entrega" value="${escapeHTML(f.lugar_entrega||"")}" placeholder="Ej: Bogotá D.C." style="${inputStyle}"/>
      </div>
      <div>
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;">Forma de pago</label>
        <input data-form="forma_pago" value="${escapeHTML(f.forma_pago||"")}" placeholder="Se carga automáticamente del cliente" style="${inputStyle}"/>
        <div style="font-size:10px;color:${C.muted};margin-top:4px;">💡 Se precarga de la ficha del cliente al seleccionarlo</div>
      </div>
      ${tipo === "CT" ? `<div>
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;">Vigencia (días)</label>
        <input type="number" min="0" inputmode="numeric" data-form="_dias_vigencia" placeholder="Ej: 1, 2, 5, 15, 20" value="${f._dias_vigencia != null ? escapeHTML(String(f._dias_vigencia)) : ""}" style="${inputStyle}"/>
        <div style="font-size:10px;color:${C.muted};margin-top:4px;" id="vigencia-info">
          ${(() => {
            if (f._dias_vigencia === "" || f._dias_vigencia == null) return "Escribe el número de días de vigencia a partir de hoy.";
            const calc = calcularFechaPorDias(f._dias_vigencia);
            if (!calc) return "Escribe el número de días de vigencia a partir de hoy.";
            const base = `Fecha de vigencia: <strong>${fmtDate(calc.fecha)}</strong> (${calc.nombreDia})`;
            return calc.esFinDeSemana
              ? base + ` <span style="color:${C.red};font-weight:700;">⚠️ Cae en día no hábil (${calc.nombreDia})</span>`
              : base;
          })()}
        </div>
      </div>` : ""}
      <div>
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;">🧑‍💼 Asesor comercial</label>
        ${f.asesor_comercial ? `
          <div style="display:flex;align-items:center;gap:8px;padding:8px 10px;background:${C.amber}10;border:1px solid ${C.amber}40;border-radius:6px;">
            <span style="background:${C.amber}20;color:${C.amber};padding:3px 10px;border-radius:6px;font-size:11.5px;font-weight:700;">🧑‍💼 ${escapeHTML(f.asesor_comercial)}</span>
            <span style="font-size:10px;color:${C.muted};">Heredado del cliente · No editable</span>
            <input type="hidden" name="asesor_comercial" value="${escapeHTML(f.asesor_comercial)}">
          </div>
        ` : `
          <div style="padding:8px 10px;background:#f8fafc;border:1px dashed ${C.border};border-radius:6px;font-size:10.5px;color:${C.muted};">
            Sin asesor asignado · Se hereda automáticamente al seleccionar el cliente
          </div>
        `}
      </div>
    </div>
    ${(() => {
      // La persona de contacto ya NO se elige aquí: se pregunta al guardar, en
      // una ventana propia y de respuesta obligatoria (ver pedirContactoCT).
      // Aquí solo se muestra, informativo, a quién quedó dirigida la cotización.
      if (!f._contacto || !f._contacto.nombre) return "";
      return `
        <div style="margin-bottom:9px;padding:8px 11px;background:#f0fdf4;border:1px solid #86efac;border-radius:8px;">
          <div style="font-size:10px;color:#047857;font-weight:700;letter-spacing:.3px;">👤 DIRIGIDA A</div>
          <div style="font-size:12px;font-weight:700;color:${C.text};margin-top:2px;">
            ${escapeHTML(f._contacto.nombre)}${f._contacto.cargo ? ` <span style="font-weight:500;color:${C.muted};">— ${escapeHTML(f._contacto.cargo)}</span>` : ""}
          </div>
          <div style="font-size:10px;color:${C.muted};margin-top:2px;">Se confirma al guardar.</div>
        </div>
      `;
    })()}
  ` : "";

  const extraOCP = tipo === "OCP" ? `
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-bottom:9px;">
      <div>
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;">Fecha de entrega</label>
        <input data-form="fecha_entrega" type="date" value="${escapeHTML(f.fecha_entrega||"")}" style="${inputStyle}"/>
      </div>
      <div>
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;">Condiciones de pago</label>
        <input data-form="condiciones_pago" value="${escapeHTML(f.condiciones_pago||"")}" placeholder="Se carga automáticamente del proveedor" style="${inputStyle}"/>
      </div>
      <div style="grid-column:1/3;">
        ${f._fromCosto ? `
          <div style="padding:8px 10px;background:#f8fafc;border:1px dashed ${C.border};border-radius:6px;font-size:10.5px;color:${C.muted};">
            🔗 Esta orden nació de un costo asociado de <b>${escapeHTML((f._origen && f._origen.numero) || "una OP")}</b> y su vínculo lo administra ese costo.
          </div>
        ` : (() => {
          const ops = (state.data.pedidos || []).filter(op => op.estado !== "cancelada")
            .sort((a, b) => String(b.numero||"").localeCompare(String(a.numero||"")));
          const sel = (f._origen && f._origen.tipo === "OP") ? f._origen.id : "";
          return `
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;">🔗 OP asociada <span style="font-weight:500;">(opcional)</span></label>
          <select data-action="ocp-asociar-op" style="${inputStyle}cursor:pointer;">
            <option value="">— Sin OP asociada —</option>
            ${ops.map(op => {
              const cli = (state.data.clientes || []).find(c => c.id === op.cliente_id);
              return `<option value="${op.id}" ${sel === op.id ? "selected" : ""}>${escapeHTML(op.numero || "")}${cli ? " — " + escapeHTML(cli.nombre) : ""}</option>`;
            }).join("")}
          </select>
          <div style="font-size:10px;color:${C.muted};margin-top:4px;">💡 El costo de esta orden entra a la liquidación y al margen de esa OP. Sirve para compras de urgencia hechas por fuera de la conversión — y se puede cambiar después.</div>
          `;
        })()}
      </div>
      <div style="grid-column:1/3;">
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;">Enviar a (dirección de entrega)</label>
        <textarea data-form="enviar_a" rows="3" placeholder="Nombre / dirección / contacto / teléfono de quien recibe" style="${inputStyle}resize:vertical;">${escapeHTML(f.enviar_a||"")}</textarea>
        <div style="font-size:10px;color:${C.muted};margin-top:4px;">💡 Se imprime en el bloque "ENVIAR A" de la orden. Si se deja vacío, se usa la dirección de la empresa.</div>
      </div>
    </div>
  ` : "";

  state.modal = `
    <div data-action="close-modal-bg" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;z-index:1000;padding:11px;">
      <div data-action="prevent-close" style="background:white;border-radius:14px;width:1240px;max-width:100%;max-height:90vh;overflow:auto;box-shadow:0 20px 60px rgba(0,0,0,.2);">
        <div style="padding:10px 12px;border-bottom:1px solid ${C.border};display:flex;justify-content:space-between;align-items:center;background:linear-gradient(135deg,${info.color}10,${C.blue}08);">
          <h3 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">${f.id ? "Editar" : "Nueva"} ${info.label}</h3>
          <div style="display:flex;gap:6px;align-items:center;">
            ${f.id && (state.data[info.key] || []).some(x => x.id === f.id) ? botonBitacora(info.key, f.id, f.numero, { referencia: f.numero }) : ""}
            <button data-action="close-modal" style="background:transparent;border:none;font-size:16px;color:${C.muted};cursor:pointer;padding:0;">✕</button>
          </div>
        </div>
        <div style="padding:11px;">
          ${f._origen ? `
            <div style="background:linear-gradient(135deg,${DOC_INFO[f._origen.tipo].color}15,${C.bg});border:1px solid ${DOC_INFO[f._origen.tipo].color}40;border-radius:6px;padding:9px;margin-bottom:9px;display:flex;align-items:center;gap:10px;">
              <div style="font-size:16px;">${DOC_INFO[f._origen.tipo].icon}</div>
              <div style="flex:1;">
                <div style="font-size:10.5px;color:${C.muted};font-weight:700;">CONVERSIÓN DESDE</div>
                <div style="font-size:14px;font-weight:700;color:${C.text};">${escapeHTML(f._origen.numero)} <span style="font-size:10.5px;font-weight:500;color:${C.muted};">— ${DOC_INFO[f._origen.tipo].label}</span></div>
              </div>
              <div style="font-size:10.5px;color:${C.muted};">${fmtDate(f._origen.fecha)}</div>
            </div>
          ` : ""}
          ${isRC ? `
            <div style="padding:10px;background:#fff3cd;border-left:3px solid #f59e0b;border-radius:6px;margin-bottom:9px;">
              <h4 style="margin:0 0 12px;color:${C.text};font-size:12px;font-weight:700;">🔗 SELECCIONAR ORDEN DE PRODUCCIÓN</h4>
              <div>
                <label style="font-size:10.5px;color:${C.muted};font-weight:600;">⭐ OP (Obligatorio)*</label>
                <select data-form-op-selector style="width:100%;padding:8px;border:1px solid ${C.border};border-radius:6px;font-size:11.5px;margin-top:4px;">
                  <option value="">— Selecciona una OP —</option>
                  ${(state.data.pedidos || [])
                    .filter(op => {
                      if (["cancelada", "convertida"].includes(op.estado)) return false;
                      return (op.items || []).some(it => {
                        const cantOP = parseNumber(it.cantidad) || 0;
                        const cantFacturada = parseNumber(it._cantidadFacturada) || 0;
                        return cantOP > cantFacturada;
                      });
                    })
                    .map(op => {
                      let cantDisp = 0;
                      (op.items || []).forEach(it => {
                        const c = parseNumber(it.cantidad) || 0;
                        const f = parseNumber(it._cantidadFacturada) || 0;
                        cantDisp += c - f;
                      });
                      return `<option value="${op.id}" ${f._origen?.id === op.id ? 'selected' : ''}>${escapeHTML(op.numero)} — ${escapeHTML((state.data.clientes.find(cl => cl.id === op.cliente_id) || {}).nombre || "?")} (${cantDisp} unidades disponibles)</option>`;
                    }).join('')}
                </select>
                <div style="font-size:10px;color:${C.muted};margin-top:4px;">💡 Selecciona una OP para cargar sus líneas pendientes</div>
              </div>
            </div>
          ` : ""}
          <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:9px;margin-bottom:9px;">
            <div>
              <label style="font-size:10.5px;color:${C.muted};font-weight:600;">Número</label>
              <input data-form="numero" value="${escapeHTML(f.numero||"(automático)")}" style="${inputStyle}"/>
            </div>
            <div>
              <label style="font-size:10.5px;color:${C.muted};font-weight:600;">Fecha</label>
              <input data-form="fecha" type="date" value="${f.fecha}" style="${inputStyle}"/>
            </div>
            <div>
              <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Estado</label>
              <div style="${inputStyle}display:flex;align-items:center;background:#f8fafc;">
                <span style="background:${(ESTADO_COLOR[f.estado]||"#6b7280")}18;color:${ESTADO_COLOR[f.estado]||"#6b7280"};border:1px solid ${(ESTADO_COLOR[f.estado]||"#6b7280")}40;padding:2px 9px;border-radius:6px;font-size:10.5px;font-weight:700;">${(ESTADOS[tipo]||{})[f.estado] || f.estado}</span>
              </div>
              <div style="font-size:10px;color:${C.muted};margin-top:3px;">💡 Usa "Completar" o cambia el estado desde la lista</div>
            </div>
          </div>
          <div style="${isRC ? "display:none;" : "display:grid;grid-template-columns:1fr;gap:9px;margin-bottom:9px;"}">
            <div>
              <label style="font-size:10.5px;color:${C.muted};font-weight:600;">${isOCP ? "Proveedor" : "Cliente"} <span style="color:${C.red};font-weight:700;">*</span></label>
              <input
                data-form-lookup="${isOCP ? "proveedor_id" : "cliente_id"}"
                data-lookup-type="${isOCP ? "proveedores" : "clientes"}"
                list="${isOCP ? "list-proveedores" : "list-clientes"}"
                value="${escapeHTML(isOCP ? provNombre : clienteNombre)}"
                placeholder="🔍 Escribe nombre del ${isOCP ? "proveedor" : "cliente"}..."
                autocomplete="off"
                style="${inputStyle}"
              />
              <datalist id="${isOCP ? "list-proveedores" : "list-clientes"}">
                ${isOCP ? provOptions : clientOptions}
              </datalist>
              ${!isOCP && esClienteLibre(f) ? `
                <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-top:5px;padding:7px 10px;background:#fffbeb;border:1px solid #fcd34d;border-radius:8px;">
                  <span style="font-size:10.5px;font-weight:800;color:#92400e;">✏️ Tercero no registrado</span>
                  <span style="font-size:10.5px;color:#92400e;">${escapeHTML(f._clienteLibre.nombre)}${f._clienteLibre.nit ? " · NIT " + escapeHTML(f._clienteLibre.nit) : ""}</span>
                  <button type="button" data-action="editar-cliente-libre" style="${btnStyle(null,"secondary",true)}margin-left:auto;">Editar datos</button>
                  <button type="button" data-action="quitar-cliente-libre" style="${btnStyle(null,"ghost",true)}">Quitar</button>
                </div>
                <div style="font-size:10px;color:${C.muted};margin-top:3px;">No se crea ficha en Maestros: la cotización guarda estos datos por su cuenta.</div>
              ` : `<div style="font-size:10px;color:${C.muted};margin-top:3px;">💡 Selecciona de la lista que aparece</div>`}
            </div>
          </div>
          ${!isRC ? extraCT : ""}
          ${extraOP}
          ${extraOCP}
          <!-- Fija al desplazar: con muchos ítems, el título y los botones de
               agregar tienen que seguir a la vista para no perder el hilo. -->
          <div id="barra-items" style="position:sticky;top:0;z-index:6;background:white;display:flex;justify-content:space-between;align-items:center;padding:8px 0;margin-bottom:2px;box-shadow:0 6px 8px -8px rgba(15,23,42,.35);">
            <h4 style="margin:0;color:${C.text};font-size:14px;">📦 Ítems</h4>
            <div style="display:flex;gap:6px;">
              ${(state.data.productos||[]).length > 0 ? `<button data-action="search-products" style="${btnStyle(C.purple, null, true)}">🔍 Desde catálogo</button>` : ""}
              <button data-action="add-item" style="${btnStyle(C.accent, null, true)}">+ Agregar ítem</button>
            </div>
          </div>
          ${itemsHTML}
          ${totalsHTML}
          ${/* También durante la CONVERSIÓN CT→OP. La orden NACE aquí, y es
                aquí donde llegan los costos de línea de la cotización: si el
                bloque se esconde, la pregunta de qué se crea con cada costo
                —la columna «¿Qué se crea?»— no se ve nunca en el camino
                normal, porque una OP que ya generó documentos queda bloqueada
                para edición y ese formulario ya no se vuelve a abrir. */ ""}
          ${tipo === "OP" ? `
            <div style="margin-top:18px;padding:10px;background:#f8fafc;border-left:3px solid #10b981;border-radius:6px;">
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">
                <h4 style="margin:0;color:${C.text};font-size:12px;font-weight:700;">💰 COSTOS ASOCIADOS</h4>
                <button data-action="add-costo-concepto" style="${btnStyle(C.accent, null, true)}">+ Agregar concepto</button>
              </div>
              ${(f._conceptosCosto||[]).length === 0 ? `
                <div style="padding:10px;text-align:center;background:white;border:1px dashed ${C.border};border-radius:6px;color:${C.muted};font-size:11.5px;">
                  Sin conceptos de costo. Haz clic en "+ Agregar concepto".
                </div>
              ` : `
                <datalist id="list-productos-costos-op">${(state.data.productos||[])
                  .map(pr => `<option value="${escapeHTML(pr.nombre)}"></option>`).join("")}</datalist>
                <div style="overflow-x:auto;">
                  <table style="width:100%;border-collapse:collapse;font-size:11.5px;">
                    <thead>
                      <tr style="background:#ecfdf5;">
                        <th style="padding:6px 8px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Concepto</th>
                        <th style="padding:6px 8px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};width:180px;">Proveedor</th>
                        <th style="padding:6px 8px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};width:170px;" title="Si este costo ES un producto del catálogo, elígelo: la orden de compra saldrá con ese artículo y su IVA.">Producto <span style="font-weight:600;">(opcional)</span></th>
                        <th style="padding:6px 8px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};width:160px;" title="Si este producto es una PARTE del ítem que se vende (se arma al entregar), elige a qué ítem compone: al remisionar saldrá de bodega esta parte y no el artículo armado.">Compone a <span style="font-weight:600;">(kit)</span></th>
                        <th style="padding:6px 8px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};width:100px;">Cantidad</th>
                        <th style="padding:6px 8px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};width:140px;">Valor Tercero</th>
                        <th style="padding:6px 8px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};width:140px;">Total</th>
                        ${/* El destino del costo: una marcación con una
                              temporaria se compra con orden de compra; un
                              transporte se legaliza con una cuenta de cobro que
                              la persona firma. Se pregunta aquí, en la fila,
                              porque es donde se ve el concepto y su valor. */ ""}
                        <th style="padding:6px 8px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};width:175px;" title="¿Este costo se compra con una orden de compra al proveedor, o se legaliza con una cuenta de cobro que el tercero firma? La orden nace en el módulo de Órdenes de Compra; la cuenta de cobro se administra en Cuentas por Pagar.">¿Qué se crea?</th>
                        <th style="width:30px;"></th>
                      </tr>
                    </thead>
                    <tbody>
                      ${(f._conceptosCosto||[]).map((c,i) => `
                        <tr style="border-top:1px solid ${C.border};background:white;">
                          <td style="padding:3px;"><input data-costo-concepto="${i}" data-costo-field="concepto" value="${escapeHTML(c.concepto||"")}" placeholder="Ej: Transporte, Bordado, Maquila..." style="${inputStyle}font-size:11.5px;padding:5px 7px;"/></td>
                          ${/* El tercero se ELIGE, no se teclea: de su ficha
                                salen la tarifa de retención y el documento con
                                el que se le reporta la exógena. Con texto libre
                                cada variante del nombre creaba una ficha nueva,
                                sin cédula y sin tarifa (ver terceroPicker.js). */ ""}
                          <td style="padding:3px;">${celdaTerceroCosto(c, `data-action="buscar-tercero-costo" data-idx="${i}"`, `data-action="quitar-tercero-costo" data-idx="${i}"`)}</td>
                          ${/* El mismo vínculo que en la cotización: apuntar el
                                costo a un producto del catálogo hace que la OCP
                                pida el artículo real, con su IVA. */ ""}
                          <td style="padding:3px;">
                            <input data-costo-concepto="${i}" data-costo-field="articulo"
                              list="list-productos-costos-op" autocomplete="off"
                              value="${escapeHTML(c.articulo||"")}" placeholder="— sin producto —"
                              style="${inputStyle}font-size:11.5px;padding:5px 7px;"/>
                            ${(() => {
                              if (!c.articulo) return "";
                              const prodC = productoDeArticulo(c.articulo);
                              if (!prodC) return `<div style="font-size:9.5px;color:#b45309;margin-top:2px;">No está en el catálogo — saldrá como concepto</div>`;
                              const rC = regimenDeProducto(prodC);
                              return `<div style="font-size:9.5px;color:${rC.tipo === "gravado" ? C.muted : "#92400e"};margin-top:2px;font-weight:700;">${escapeHTML(etiquetaRegimen(rC))}</div>`;
                            })()}
                          </td>
                          ${/* La otra mitad del kit: a qué línea vendida pertenece
                                esta parte. Sin producto no hay parte que sacar, así
                                que la casilla solo tiene sentido con producto puesto. */ ""}
                          <td style="padding:3px;">
                            ${!c.articulo ? `<div style="font-size:9.5px;color:${C.muted};">—</div>` : `
                              <select data-costo-concepto="${i}" data-costo-field="_articuloOrigen"
                                style="${inputStyle}font-size:11px;padding:5px 7px;">
                                <option value="">— no es parte de un ítem —</option>
                                ${(f.items||[]).filter(x => x.articulo).map(x =>
                                  `<option value="${escapeHTML(x.articulo)}" ${normalize(x.articulo) === normalize(c._articuloOrigen||"") ? "selected" : ""}>${escapeHTML(x.articulo)}</option>`
                                ).join("")}
                              </select>
                              ${c._articuloOrigen ? `<div style="font-size:9.5px;color:#7c3aed;margin-top:2px;font-weight:700;">🧩 sale de bodega al remisionar</div>` : ""}
                            `}
                          </td>
                          <td style="padding:3px;"><input data-costo-concepto="${i}" data-costo-field="cantidad" type="number" inputmode="decimal" value="${c.cantidad!=null?c.cantidad:""}" placeholder="0" style="${inputStyle}font-size:11.5px;padding:5px 7px;text-align:right;"/></td>
                          <td style="padding:3px;"><input data-costo-concepto="${i}" data-costo-field="valor_tercero" type="number" inputmode="decimal" value="${c.valor_tercero!=null?c.valor_tercero:""}" placeholder="0" style="${inputStyle}font-size:11.5px;padding:5px 7px;text-align:right;"/></td>
                          <td data-costo-total="${i}" style="padding:3px;font-weight:700;text-align:right;color:${C.text};">${fmtCOP((parseNumber(c.cantidad)||0) * (parseNumber(c.valor_tercero)||0))}</td>
                          <td style="padding:3px;">${destinoCostoCelda(c, i)}</td>
                          <td style="padding:3px;text-align:center;"><button data-action="remove-costo-concepto" data-idx="${i}" style="background:transparent;border:none;color:${C.red};cursor:pointer;font-size:16px;">🗑</button></td>
                        </tr>
                      `).join("")}
                    </tbody>
                  </table>
                </div>
              `}
              <div style="margin-top:8px;padding:8px;background:white;border-radius:4px;font-size:11.5px;font-weight:700;color:#10b981;text-align:right;">
                Total Costos: ${fmtCOP((f._conceptosCosto||[]).reduce((s,c) => s + (parseNumber(c.cantidad)||0) * (parseNumber(c.valor_tercero)||0), 0))}
              </div>
              <div style="font-size:10px;color:${C.muted};margin-top:6px;">💡 Si asignas un proveedor a un concepto con valor, se registrará automáticamente en Cuentas por Pagar con trazabilidad a esta OP.</div>
            </div>
          ` : ""}
          ${tipo === "OP" ? `
            <div style="margin-top:18px;padding:10px;background:#f8fafc;border-left:3px solid #2B4A82;border-radius:6px;">
              <h4 style="margin:0 0 12px;color:${C.text};font-size:12px;font-weight:700;">📎 DOCUMENTOS ADJUNTOS</h4>
              <div style="margin-bottom:12px;">
                <label style="display:block;font-size:10.5px;color:${C.muted};font-weight:600;margin-bottom:6px;">Cargar documento (PDF o JPG)</label>
                <div style="display:flex;gap:8px;">
                  <input type="file" id="upload-doc-op" accept=".pdf,.jpg,.jpeg,.png" style="flex:1;padding:6px;border:1px solid ${C.border};border-radius:4px;font-size:11.5px;"/>
                  <button data-action="agregar-documento-op" style="background:#2B4A82;border:none;color:white;padding:6px 16px;border-radius:4px;font-weight:700;cursor:pointer;font-size:11.5px;">📤 Cargar</button>
                </div>
                <div style="font-size:10px;color:${C.muted};margin-top:4px;">⚠️ Los documentos se guardarán cuando se implemente el repositorio</div>
              </div>
              ${!f._documentos || f._documentos.length === 0 ? `
                <div style="padding:9px;text-align:center;background:white;border:1px dashed ${C.border};border-radius:4px;color:${C.muted};font-size:11.5px;">
                  Sin documentos aún
                </div>
              ` : `
                <div style="display:flex;flex-direction:column;gap:6px;">
                  ${(f._documentos || []).map((doc, idx) => `
                    <div style="display:flex;justify-content:space-between;align-items:center;padding:8px;background:white;border:1px solid ${C.border};border-radius:4px;font-size:10.5px;">
                      <div>
                        <div style="font-weight:700;color:${C.text};">
                          ${doc.tipo === 'pdf' ? '📄' : '🖼️'} ${escapeHTML(doc.nombre)}
                        </div>
                      </div>
                      <button data-action="eliminar-documento-op" data-idx="${idx}" style="background:none;border:none;color:${C.red};cursor:pointer;font-size:16px;">🗑</button>
                    </div>
                  `).join('')}
                </div>
              `}
            </div>
          ` : ""}
          <div style="margin-top:14px;">
            <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Notas / Observaciones</label>
            ${editorRicoHTML({
              campo: "notas",
              valor: f.notas || "",
              ayuda: "Selecciona con el mouse el texto que quieras resaltar y usa la barra: negrilla, subrayado, color o tamaño. Se imprime tal cual."
            })}
          </div>
          <div style="margin-top:18px;display:flex;gap:10px;justify-content:flex-end;padding-top:14px;border-top:1px solid ${C.border};">
            <button data-action="close-modal" style="${btnStyle(null,"secondary")}">Cancelar</button>
            <button data-action="save-doc" style="${btnStyle(null,"secondary")}">💾 Guardar</button>
            ${f.estado !== "completada" ? `<button data-action="save-doc" data-finalize="1" style="${btnStyle(info.color)}">✅ Completar</button>` : ""}
          </div>
        </div>
      </div>
    </div>
  `;
  render();
}

// Mini-formulario para crear un cliente sin abandonar el documento: solo el
// nombre es obligatorio; el resto se completa después en Maestros → Clientes.
// Al confirmar, el cliente queda creado, sincronizado y asignado al documento.
export function renderCrearClienteRapidoModal() {
  const d = state._crearClienteDraft;
  if (!d) return;
  const vendedores = (state.data.empleados || []).filter(e => e.cargo === "vendedor" || e.es_vendedor);
  state.modal = `
    <div data-action="cancelar-crear-cliente" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.55);display:flex;align-items:center;justify-content:center;z-index:1150;padding:11px;">
      <div data-action="prevent-close" style="background:white;border-radius:14px;width:440px;max-width:100%;max-height:88vh;overflow:auto;box-shadow:0 20px 60px rgba(0,0,0,.25);">
        <div style="padding:10px 12px;border-bottom:1px solid ${C.border};display:flex;justify-content:space-between;align-items:center;">
          <h3 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">➕ Crear cliente rápido</h3>
          <button data-action="cancelar-crear-cliente" style="background:transparent;border:none;font-size:16px;color:${C.muted};cursor:pointer;">✕</button>
        </div>
        <div style="padding:11px;">
          <div style="display:grid;gap:9px;">
            <div>
              <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Nombre / Razón social <span style="color:${C.red};">*</span></label>
              <input value="${escapeHTML(d.nombre || "")}" oninput="state._crearClienteDraft.nombre=this.value" style="${inputStyle}"/>
            </div>
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:9px;">
              <div>
                <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">NIT / Cédula (opcional)</label>
                <input value="${escapeHTML(d.nit || "")}" oninput="state._crearClienteDraft.nit=this.value" style="${inputStyle}"/>
              </div>
              <div>
                <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Teléfono (opcional)</label>
                <input value="${escapeHTML(d.telefono || "")}" oninput="state._crearClienteDraft.telefono=this.value" style="${inputStyle}"/>
              </div>
            </div>
            <div>
              <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Correo (opcional)</label>
              <input type="email" value="${escapeHTML(d.email || "")}" oninput="state._crearClienteDraft.email=this.value" style="${inputStyle}"/>
            </div>
            ${vendedores.length ? `
            <div>
              <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Asesor comercial (opcional)</label>
              <select onchange="state._crearClienteDraft.asesor_comercial=this.value" style="${inputStyle}cursor:pointer;">
                <option value="">— Sin asignar —</option>
                ${vendedores.map(v => `<option value="${escapeHTML(v.nombre)}" ${d.asesor_comercial === v.nombre ? "selected" : ""}>${escapeHTML(v.nombre)}</option>`).join("")}
              </select>
            </div>` : ""}
          </div>
          <div style="font-size:10px;color:${C.muted};margin-top:9px;">💡 Con el nombre basta para cotizar. Los demás datos (dirección, condiciones de pago, régimen…) se completan cuando quieras en Maestros → Clientes.</div>
          ${d.error ? `<div style="margin-top:9px;background:#fef2f2;border:1px solid #fca5a5;border-radius:6px;padding:6px 10px;font-size:11.5px;color:${C.red};font-weight:700;">⚠️ ${escapeHTML(d.error)}</div>` : ""}
          <div style="display:flex;gap:10px;justify-content:flex-end;margin-top:14px;padding-top:12px;border-top:1px solid ${C.border};">
            <button data-action="cancelar-crear-cliente" style="${btnStyle(null,"secondary")}">Cancelar</button>
            <button data-action="confirmar-crear-cliente" style="${btnStyle(C.accent)}">✅ Crear y usar en el documento</button>
          </div>
        </div>
      </div>
    </div>
  `;
  render();
}

// Cotizarle a un tercero que NO está en el maestro de Clientes. Los datos se
// guardan sobre la propia cotización (no se crea ficha), que es justo lo que se
// quiere con un prospecto: cotizar hoy sin llenar Maestros de fichas que quizá
// nunca compren. Al convertir la CT en OP sí se exige crear la ficha real.
export function renderClienteLibreModal() {
  const d = state._clienteLibreDraft;
  if (!d) return;
  const campo = (clave, etiqueta, tipoInput) => `
    <div>
      <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${etiqueta}</label>
      <input ${tipoInput ? `type="${tipoInput}"` : ""} value="${escapeHTML(d[clave] || "")}"
        oninput="state._clienteLibreDraft.${clave}=this.value" style="${inputStyle}"/>
    </div>`;
  state.modal = `
    <div data-action="cancelar-cliente-libre" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.55);display:flex;align-items:center;justify-content:center;z-index:1150;padding:11px;">
      <div data-action="prevent-close" style="background:white;border-radius:14px;width:460px;max-width:100%;max-height:88vh;overflow:auto;box-shadow:0 20px 60px rgba(0,0,0,.25);">
        <div style="padding:10px 12px;border-bottom:1px solid ${C.border};display:flex;justify-content:space-between;align-items:center;">
          <h3 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">✏️ Cotizar a un tercero no registrado</h3>
          <button data-action="cancelar-cliente-libre" style="background:transparent;border:none;font-size:16px;color:${C.muted};cursor:pointer;">✕</button>
        </div>
        <div style="padding:11px;">
          <div style="background:#fffbeb;border:1px solid #fcd34d;border-radius:8px;padding:8px 11px;font-size:11px;color:#92400e;line-height:1.5;margin-bottom:11px;">
            <b>No se crea ficha en Maestros.</b> Estos datos quedan guardados en la cotización y salen impresos.
            Cuando el prospecto compre y haya que convertir la CT en orden de producción, ahí sí se pedirá crear el cliente.
          </div>
          <div style="display:grid;gap:9px;">
            ${campo("nombre", `Nombre / Razón social <span style="color:${C.red};">*</span>`)}
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:9px;">
              ${campo("nit", "NIT / Cédula (opcional)")}
              ${campo("telefono", "Teléfono (opcional)")}
            </div>
            ${campo("email", "Correo (opcional)", "email")}
            <div style="display:grid;grid-template-columns:2fr 1fr;gap:9px;">
              ${campo("direccion", "Dirección (opcional)")}
              ${campo("ciudad", "Ciudad (opcional)")}
            </div>
          </div>
          ${d.error ? `<div style="margin-top:9px;background:#fef2f2;border:1px solid #fca5a5;border-radius:6px;padding:6px 10px;font-size:11.5px;color:${C.red};font-weight:700;">⚠️ ${escapeHTML(d.error)}</div>` : ""}
          <div style="display:flex;gap:10px;justify-content:flex-end;margin-top:14px;padding-top:12px;border-top:1px solid ${C.border};">
            <button data-action="cancelar-cliente-libre" style="${btnStyle(null,"secondary")}">Cancelar</button>
            <button data-action="confirmar-cliente-libre" style="${btnStyle("#d97706")}">✅ Usar este tercero</button>
          </div>
        </div>
      </div>
    </div>
  `;
  render();
}

export function renderConfirmarCrearProductoModal() {
  const d = state._crearProductoDraft;
  if (!d) return;
  state.modal = `
    <div data-action="cancelar-crear-producto" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.55);display:flex;align-items:center;justify-content:center;z-index:1150;padding:11px;">
      <div data-action="prevent-close" style="background:white;border-radius:6px;width:420px;max-width:100%;box-shadow:0 20px 60px rgba(0,0,0,.3);">
        <div style="padding:18px 20px;border-bottom:1px solid ${C.border};background:#f8fafc;">
          <h3 style="margin:0;font-size:12px;color:${C.text};font-weight:700;">📦 Confirmar creación de producto</h3>
          <div style="font-size:11.5px;color:${C.muted};margin-top:4px;">${escapeHTML(d.nombre)}</div>
        </div>
        <div style="padding:11px;">
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:9px;font-size:11.5px;background:#f8fafc;padding:10px;border-radius:6px;">
            <div><div style="color:${C.muted};font-weight:600;">Costo</div><div style="font-weight:700;color:${C.text};">${fmtCOP(d.costo)}</div></div>
            <div><div style="color:${C.muted};font-weight:600;">Margen</div><div style="font-weight:700;color:${C.text};">${d.margen}%</div></div>
            <div style="grid-column:1/3;border-top:1px dashed ${C.border};padding-top:8px;"><div style="color:${C.muted};font-weight:600;">Precio de venta (calculado)</div><div style="font-weight:800;color:${C.mathiz};font-size:16px;">${fmtCOP(d.precio_venta)}</div></div>
          </div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:9px;">
            <div style="grid-column:1/3;">
              <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Referencia / Código</label>
              <input data-crear-prod-field="referencia" value="${escapeHTML(d.referencia||"")}" placeholder="Ej: BOL-441" style="${inputStyle}"/>
              <div style="font-size:10px;color:${C.muted};margin-top:3px;">Con referencia puedes volver a llamar este mismo producto en la cotización, aunque el nombre se repita.</div>
            </div>
            <div>
              <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Categoría</label>
              <input data-crear-prod-field="categoria" value="${escapeHTML(d.categoria||"")}" placeholder="Ej: Textil, Tecnología..." style="${inputStyle}"/>
            </div>
            <div>
              <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Unidad de empaque</label>
              <input data-crear-prod-field="unidad" value="${escapeHTML(d.unidad||"")}" placeholder="Ej: Unidad, Caja x12, Paquete x50..." style="${inputStyle}"/>
            </div>
          </div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:6px;">📷 Imagen del producto <span style="color:${C.red};">*</span> obligatoria</label>
          ${zonaImagenHTML({ destino:"crearProducto", inputId:"crear-producto-imagen-input", imagen:d.imagen, obligatoria:true })}
          <div style="font-size:10px;color:${C.muted};margin:5px 0 8px;">Esta imagen se mostrará en la impresión de Cotizaciones.</div>
          ${!d.imagen ? `<div style="font-size:10.5px;color:${C.red};font-weight:600;margin-bottom:6px;">⚠️ Debes cargar una imagen para poder crear el producto.</div>` : ""}
          <div style="margin-top:14px;display:flex;gap:10px;justify-content:flex-end;">
            <button data-action="cancelar-crear-producto" style="${btnStyle(null,"secondary")}">Cancelar</button>
            <button data-action="confirmar-crear-producto" ${!d.imagen?"disabled":""} style="${btnStyle(C.purple)}${!d.imagen?"opacity:.5;cursor:not-allowed;":""}">✅ Crear producto</button>
          </div>
        </div>
      </div>
    </div>
  `;
  render();
}

export function handleCrearProductoFieldInput(e) {
  if (!state._crearProductoDraft) return;
  state._crearProductoDraft[e.target.dataset.crearProdField] = e.target.value;
}

// Guardaba el archivo TAL CUAL con readAsDataURL: por aquí entraron 52 PNG de
// 616 KB de promedio. El camino real ya no pasa por esta función (ver los
// listeners en actions.js), pero sigue exportada y en window, así que comprime
// igual — un segundo camino sin comprimir es exactamente lo que causó el
// problema.
export async function handleCrearProductoImagenChange(e) {
  const file = e.target.files && e.target.files[0];
  if (!file) return;
  if (!file.type.startsWith("image/")) { alert("⚠️ Selecciona un archivo de imagen válido"); return; }
  if (file.size > 25 * 1024 * 1024) { alert("⚠️ La imagen es demasiado grande (máximo 25MB)."); return; }
  try {
    const comprimida = await comprimirImagen(file, 800, 0.82);
    if (!state._crearProductoDraft) return;
    state._crearProductoDraft.imagen = comprimida;
    renderConfirmarCrearProductoModal();
  } catch (err) {
    alert("⚠️ No se pudo procesar la imagen: " + (err.message || err));
  }
}

// Ítems de una OP que no se pueden remisionar porque el inventario no alcanza.
// Devuelve lo pendiente y lo disponible de cada uno, para poder explicarlo.
export function faltantesStockOP(op, excluirRcId) {
  if (!op) return [];
  return (op.items || []).map(it => {
    const articulo = it.articulo || "";
    const pendiente = Math.max(0, (parseNumber(it.cantidad) || 0)
      - getCantidadRemisionadaOP(op.id, articulo, excluirRcId || null));
    // Un artículo que se ARMA al entregar nunca está en la bodega: su stock es
    // cero por definición, y preguntárselo bloquearía la remisión para siempre.
    // Lo que manda es cuántas unidades se pueden armar con las partes que hay.
    const armables = stockDisponibleKit(op, articulo, op.id);
    if (armables != null) {
      return { articulo, pendiente, stock: armables, enBodega: armables,
               comprometido: 0, duenos: [], _kit: componentesDeArticulo(op, articulo) };
    }
    // Contra lo DISPONIBLE, no contra el stock bruto: la mercancía que otra
    // factura ya vendió sigue en el kardex pero no se puede despachar aquí.
    return { articulo, pendiente,
             stock: getStockDisponible(articulo, op.id),
             enBodega: getStockProducto(articulo),
             comprometido: getComprometidoPorEntregar(articulo, op.id),
             duenos: comprometidosDe(articulo, op.id),
             apartados: apartadosAjenos(articulo, op.id) };
  }).filter(x => x.pendiente > 0 && x.stock < x.pendiente);
}

// Texto del aviso cuando el inventario no da para remisionar.
export function avisoFaltantesStock(op, faltantes) {
  const detalle = faltantes.map(f => {
    const comp = parseNumber(f.comprometido) || 0;
    const linea = `• ${f.articulo}: faltan ${f.pendiente - f.stock} (pendiente ${f.pendiente}, disponible ${f.stock})`;
    // Si el artículo se arma, decir cuál parte es la que no alcanza: "faltan 60
    // suculentas" no dice dónde comprar, "solo hay 40 materas" sí.
    if (f._kit && f._kit.length) {
      const partes = f._kit.map(c => {
        const disp = getStockDisponible(c.articulo, op.id);
        const alcanza = c.porUnidad > 0 ? Math.floor(disp / c.porUnidad) : 0;
        return `${c.articulo}: ${disp} en bodega → alcanza para ${alcanza}`;
      }).join("\n    ↳ ");
      const apart = f._kit.flatMap(c => apartadosAjenos(c.articulo, op.id).map(a => `${a.cantidad} ${c.articulo} para ${a.pedido_numero}`));
      return `${linea}\n    ↳ se arma al entregar con:\n    ↳ ${partes}` +
             (apart.length ? `\n    ↳ apartado para otro pedido (flujo piloto): ${apart.join(", ")}` : "");
    }
    // Lo apartado en el piloto para otra orden también tiene dueño.
    const aps = f.apartados || [];
    const lineaApartado = aps.length
      ? `\n    ↳ ${aps.reduce((s, a) => s + a.cantidad, 0)} apartados para otro pedido (flujo piloto): ` +
        aps.map(a => `${a.cantidad} para ${a.pedido_numero}`).join(", ") : "";
    if (comp <= 0) return linea + (aps.length ? `\n    ↳ hay ${f.enBodega} en bodega` : "") + lineaApartado;
    // La mercancía está en la bodega, pero ya está vendida. Decir de quién es
    // evita que alguien "la tome prestada" y descomplete el pedido del otro.
    const quien = (f.duenos || []).map(d =>
      `${d.cantidad} de ${d.cliente || "otro cliente"} (factura ${d.factura})`).join(", ");
    return `${linea}\n    ↳ hay ${f.enBodega} en bodega, pero ${comp} ya está facturado y pendiente de entregar` +
           (quien ? `: ${quien}` : "") + lineaApartado;
  }).join("\n");
  const conApartado = faltantes.some(f => (f.apartados || []).length ||
    (f._kit || []).some(c => apartadosAjenos(c.articulo, op.id).length));
  const pistaApartado = conApartado
    ? "\n\nLo apartado se libera en Flujo piloto → Pedidos (PV) → el pedido dueño → «Liberar», si ya no lo necesita."
    : "";
  const sinFicha = faltantes.filter(f => f.stock === 0 && !(parseNumber(f.comprometido) > 0) && !(f.apartados || []).length);
  const pista = sinFicha.length > 0
    ? "\n\nSi la mercancía ya llegó, revisa que esté ingresada al inventario y que el nombre del artículo " +
      "coincida con el de la ficha (Inventario → el artículo debe llamarse igual que en la orden)."
    : "";
  return `No se puede remisionar ${op.numero}: el inventario no alcanza.\n\n${detalle}${pista}${pistaApartado}\n\n` +
    "Ingresa la mercancía (Compras → Ingreso de mercancía) o ajusta las cantidades antes de remisionar.";
}

export function convertDoc(fromTipo, toTipo, fromId) {
  const fromInfo = DOC_INFO[fromTipo];
  const toInfo = DOC_INFO[toTipo];
  const source = state.data[fromInfo.key].find(d => d.id === fromId);
  if (!source) { alert("Documento origen no encontrado"); return; }

  // Remisionar es sacar mercancía: sin inventario suficiente no se puede, ni
  // por aquí ni desde el módulo de Remisiones. Antes el botón simplemente se
  // escondía y no había forma de saber por qué.
  if (toTipo === "RC" && fromTipo === "OP") {
    const faltantes = faltantesStockOP(source);
    if (faltantes.length > 0) { alert("⚠️ " + avisoFaltantesStock(source, faltantes)); return; }
  }

  // Un tercero NO registrado sirve para cotizar, pero de aquí en adelante el
  // documento entra a producción, inventario, cartera y facturación electrónica:
  // todo eso necesita una ficha real. Es el momento natural de convertir el
  // prospecto en cliente, así que se ofrece crearlo con los datos ya escritos.
  if (toTipo !== "OCP" && esClienteLibre(source)) {
    const l = source._clienteLibre;
    if (!confirm(
      `"${l.nombre}" todavía no está registrado como cliente.\n\n` +
      `Para convertir esta cotización en ${toInfo.label} hay que crearlo en Maestros ` +
      `(la orden necesita ficha real para producción, cartera y facturación).\n\n` +
      `¿Crear el cliente ahora con los datos de la cotización?`
    )) return;
    state._clienteLibrePromover = { tipo: fromTipo, id: fromId, toTipo };
    state._crearClienteDraft = {
      nombre: l.nombre || "", nit: l.nit || "", telefono: l.telefono || "",
      email: l.email || "", asesor_comercial: source.asesor_comercial || "", error: null
    };
    renderCrearClienteRapidoModal();
    return;
  }

  // Ítems cotizados a varias cantidades: antes de seguir hay que saber cuál
  // aprobó el cliente. Sin esto la orden nacería con cantidad y precio en cero.
  const conEscalas = (source.items || []).some(tieneEscalas);
  const claveEscala = fromId + ">" + toTipo;
  if (conEscalas && (!state._escalasElegidas || state._escalasElegidas._para !== claveEscala)) {
    state._escalaSel = { fromTipo, toTipo, fromId, elegidas: {}, error: null };
    renderElegirEscalaModal();
    return;
  }

  // Nota: el origen ya NO se marca como "convertida" aquí.
  // Solo se marcará cuando el nuevo documento se guarde exitosamente (ver "save-doc"),
  // así si el usuario cancela, el documento origen permanece intacto y disponible para convertir.

  // Pre-llenar el nuevo documento con los datos del origen
  const isOCP = toTipo === "OCP";
  const isRC = toTipo === "RC";

  // La cantidad elegida reemplaza las escalas: de aquí en adelante el ítem es
  // uno normal, con su cantidad y su precio, y queda anotado de qué escala salió.
  const elegidas = (state._escalasElegidas && state._escalasElegidas._para === claveEscala)
    ? state._escalasElegidas : null;
  const itemsOrigen = (source.items || []).map((it, i) => {
    const esc = escalasDeItem(it);
    if (!esc.length) return it;
    const e = esc[elegidas ? (elegidas[i] || 0) : 0] || esc[0];
    const cant = parseNumber(e.cantidad) || 0;
    const pu   = parseNumber(e.precio_unitario) || 0;
    return { ...it, cantidad: cant, precio_unitario: pu, total: cant * pu, _escalas: [] };
  });
  state._escalasElegidas = null;

  // Transformar items según el destino
  let newItems = itemsOrigen.map(it => {
    const base = {
      articulo: it.articulo || "",
      descripcion: it.descripcion || "",
      referencia: it.referencia || "",
      cantidad: it.cantidad || 0
    };
    if (isRC) {
      let cantidad = base.cantidad;
      if (fromTipo === "OP") {
        const disponible = parseNumber(it.cantidad) - getCantidadRemisionadaOP(fromId, it.articulo, null);
        cantidad = Math.max(0, Math.min(parseNumber(it.cantidad), disponible));
      }
      return { ...base, cantidad, bolsas: 1, observaciones: "" };
    }
    const fullItem = {
      ...base,
      color: it.color || "",
      logo: it.logo || "",
      impresion: it.impresion || "",
      precio_unitario: it.precio_unitario || 0,
      total: it.total || 0
    };
    if (isOCP) {
      fullItem.ubicacion = it.tinta || it.ubicacion || "";
      // Para OCP, usar el costo del catálogo de productos si existe; si no, estimar 40% del precio de venta
      const prodRef = (state.data.productos||[]).find(p => p.nombre === it.articulo);
      const costoRef = prodRef ? (parseNumber(prodRef.costo) || 0) : 0;
      fullItem.precio_unitario = costoRef > 0 ? costoRef : Math.round((it.precio_unitario || 0) * 0.4);
      fullItem.total = fullItem.cantidad * fullItem.precio_unitario;
    } else {
      fullItem.tinta = it.tinta || it.ubicacion || "";
    }
    return fullItem;
  });

  // Si es conversión OP → RC, descartar ítems sin cantidad disponible para remisionar
  if (isRC && fromTipo === "OP") {
    newItems = newItems.filter(it => parseNumber(it.cantidad) > 0);
    if (newItems.length === 0) {
      alert("⚠️ No hay cantidades pendientes por remisionar en esta OP. Todos los ítems ya fueron remisionados en otras Remisiones.");
      return;
    }
  }

  // Crear el nuevo documento como borrador con referencia al origen
  const newDoc = {
    fecha: today(),
    cliente_id: isOCP ? "" : (source.cliente_id || ""),
    proveedor_id: isOCP ? "" : "",
    items: newItems,
    notas: source.notas ? `Convertido desde ${source.numero}\n\n${source.notas}` : `Convertido desde ${source.numero}`,
    estado: "borrador",
    _origen: { tipo: fromTipo, id: fromId, numero: source.numero, fecha: source.fecha }
  };

  // Si es OCP, inicializar como cuenta por pagar
  if (toTipo === "OCP") {
    newDoc.estado_pago = "por_pagar";
  }

  // Los costos que se cargaron línea por línea en la cotización se convierten en
  // los costos asociados de la OP: ahí es donde entran al costo total y, si
  // llevan proveedor, generan la cuenta por pagar. El concepto arrastra el
  // nombre del artículo para saber de qué línea salió una vez aplanados.
  if (toTipo === "OP" && fromTipo === "CT") {
    const conceptos = [];
    itemsOrigen.forEach(it => {
      (it._costosLinea || []).forEach(c => {
        const valor = parseNumber(c.valor_tercero) || 0;
        if (valor <= 0 && !c.concepto) return;   // fila vacía que quedó suelta
        conceptos.push({
          _ccid: genId(),   // id estable del concepto desde su origen: sin él, editar la OP borraba/recreaba su OCP
          concepto: [it.articulo, c.concepto].filter(Boolean).join(" — "),
          proveedor_nombre: c.proveedor_nombre || "",
          // Si el costo apunta a un producto del catálogo, el vínculo viaja: es
          // lo que hace que la orden de compra pida el artículo de verdad.
          articulo: c.articulo || "",
          // Y de qué línea salió: con las dos cosas puestas, el costo deja de
          // ser solo un costo y pasa a ser una PARTE del artículo vendido. Al
          // remisionar sale del kardex esta parte, no el artículo que se arma.
          _articuloOrigen: it.articulo || "",
          cantidad: c.cantidad != null && c.cantidad !== "" ? c.cantidad : 1,
          valor_tercero: valor
        });
      });
    });
    if (conceptos.length) newDoc._conceptosCosto = conceptos;
  }

  // Heredar campos específicos
  if (toTipo === "OP" && source.tiempo_entrega) newDoc.tiempo_entrega = source.tiempo_entrega;
  if (toTipo === "OP" && source.condiciones_pago) newDoc.condiciones_pago = source.condiciones_pago;
  if (toTipo === "OP" && source.numero_oc_cliente) newDoc.numero_oc_cliente = source.numero_oc_cliente;
  // Propagar asesor_comercial a TODOS los docs de cliente (trazabilidad completa)
  // OCP es orden de compra a proveedor — no lleva asesor comercial
  if (!isOCP && source.asesor_comercial) newDoc.asesor_comercial = source.asesor_comercial;

  // Abrir el formulario con el nuevo documento pre-llenado
  state.editingDoc = newDoc;
  state.editingTipo = toTipo;
  state.isConversion = true;
  renderDocFormModal();
}

export function showConvertOpMultiOcp(opId) {
  const op = state.data.pedidos.find(p => p.id === opId);
  if (!op) { alert("OP no encontrada"); return; }
  if (!op.items || op.items.length === 0) { alert("Esta OP no tiene ítems"); return; }

  // ── Qué hay que comprar, artículo por artículo ──────────────────
  // Un kit NO se compra: se compran sus PARTES. Comprar "Set escolar" metería
  // al kardex una existencia que la remisión nunca va a sacar —saca los
  // cuadernos y los lápices—, y su stock es cero por definición, así que
  // saldría siempre en déficit completo.
  //
  // Las dos clases de kit se resuelven distinto, porque sus partes se compran
  // por caminos distintos:
  //
  //  · Kit de CATÁLOGO (receta en la ficha): se EXPLOTA aquí en sus
  //    componentes —20 sets de 2 cuadernos son 40 cuadernos— y entran a esta
  //    misma orden de compra junto a los productos normales. Nadie más las
  //    compra, así que excluirlas dejaba el kit sin forma de abastecerse.
  //  · Kit de LÍNEA (la suculenta, negociada en los costos de la línea): sus
  //    partes ya generan su propia OCP desde los costos asociados
  //    (sincronizarOcpDeCostos). Explotarlas aquí las compraría DOS veces.
  const requerido = new Map();      // artículo → lo que hace falta comprar
  const armadosLinea = [];          // kits de línea: se compran por sus costos
  const explotados = [];            // kits de catálogo abiertos en sus partes

  const sumar = (articulo, cantidad, descripcion, deKit) => {
    const clave = normalize(articulo || "");
    if (!clave || cantidad <= 0) return;
    const ya = requerido.get(clave);
    if (ya) {
      ya.cant += cantidad;
      if (deKit && !ya.paraKit.includes(deKit)) ya.paraKit.push(deKit);
    } else {
      requerido.set(clave, { articulo, descripcion: descripcion || "", cant: cantidad,
                             paraKit: deKit ? [deKit] : [] });
    }
  };

  op.items.forEach(it => {
    const art = it.articulo || "";
    const cant = parseNumber(it.cantidad) || 0;
    if (!art || cant <= 0) return;
    // Kit de línea: sus partes viven en los costos de esta orden.
    if (componentesDeLinea(op, art).length) { armadosLinea.push({ ...it, cant }); return; }
    const partes = partesCompradasDeKit(productoDeArticulo(art), cant);
    if (partes.length) {
      explotados.push({ articulo: art, cant, partes });
      partes.forEach(pt => sumar(pt.articulo, pt.cantidad,
        (pt.producto && pt.producto.categoria) || "", `${cant} ${art}`));
      return;
    }
    sumar(art, cant, it.descripcion || "");
  });

  if (armadosLinea.length > 0) {
    const detalleKits = armadosLinea.map(it =>
      `• ${it.articulo}: ${descripcionKit(op, it.articulo)}`).join("\n");
    alert(`ℹ️ Estos ítems se arman al entregar con partes acordadas en la propia orden, ` +
      `así que se compran desde sus COSTOS ASOCIADOS:\n\n${detalleKits}\n\n` +
      `No se incluirán en esta orden de compra.`);
  }
  if (explotados.length > 0) {
    const detalle = explotados.map(k =>
      `• ${k.cant} ${k.articulo} → ${k.partes.map(pt => `${pt.cantidad} ${pt.articulo}`).join(" + ")}`).join("\n");
    alert(`🧩 Un kit no se compra: se compran sus partes. Se pedirán los componentes:\n\n${detalle}`);
  }

  // Lo comprometido con otro cliente no sirve para esta orden: si el kardex
  // solo alcanza porque incluye mercancía ya vendida, hay que comprar.
  const analisis = [...requerido.values()].map(r => {
    const stock = getStockDisponible(r.articulo, op.id);
    return { ...r, cantidad: r.cant, stock, deficit: Math.max(0, r.cant - stock) };
  });

  if (analisis.length === 0) {
    alert(`No hay nada que comprar por aquí en ${op.numero}: todos sus ítems se arman al entregar ` +
      `con partes acordadas en la orden.\n\n` +
      `Esas se piden desde los costos asociados (cada costo con producto genera su propia OCP).`);
    return;
  }

  const conDeficit  = analisis.filter(it => it.deficit > 0);
  const sinDeficit  = analisis.filter(it => it.deficit === 0);

  // Si todo el inventario alcanza → bloquear
  if (conDeficit.length === 0) {
    const detalle = analisis.map(it => `• ${it.articulo}: ${it.stock} en stock (necesario: ${it.cant})`).join("\n");
    alert(`✅ Inventario suficiente para todos los ítems de ${op.numero}.\nNo se requieren Órdenes de Compra.\n\n${detalle}`);
    return;
  }

  // Si algunos ítems tienen stock suficiente → informar y excluirlos
  if (sinDeficit.length > 0) {
    const sufMsg = sinDeficit.map(it => `• ${it.articulo}: ${it.stock} en stock (necesario: ${it.cant})`).join("\n");
    alert(`ℹ️ Los siguientes ítems tienen stock suficiente y NO se incluirán en la OCP:\n\n${sufMsg}\n\nSe crearán OCPs solo para los ítems con déficit.`);
  }

  state.multiOcp = {
    opId,
    numGruposDeseado: 1,
    items: conDeficit.map(it => {
      const prod = (state.data.productos||[]).find(p => p.nombre === it.articulo);
      const costoProducto = prod ? (parseNumber(prod.costo) || 0) : Math.round((parseNumber(it.precio_unitario) || 0) * 0.4);
      return {
        articulo: it.articulo || "",
        descripcion: it.descripcion || "",
        cantidad: it.deficit,      // solo la cantidad faltante
        cantidadOP: it.cant,       // cuánto hace falta para la orden
        stockActual: it.stock,     // stock disponible
        // De qué kit salió esta parte, para que la orden de compra se explique
        // sola: "40 Cuaderno — para 20 Set escolar".
        paraKit: (it.paraKit || []).join(" · "),
        costo: costoProducto,
        grupo: 1
      };
    }),
    grupos: { "1": { proveedor_nombre: "", proveedor_id: "" } }
  };
  renderMultiOcpModal();
}

export function renderMultiOcpModal() {
  const mo = state.multiOcp;
  if (!mo) return;
  const op = state.data.pedidos.find(p => p.id === mo.opId);
  if (!op) { state.multiOcp = null; return; }
  const cliente = state.data.clientes.find(c => c.id === op.cliente_id) || {};

  const grupoKeys = Object.keys(mo.grupos).sort((a,b) => Number(a) - Number(b));
  const grupoOptions = grupoKeys.map(g => `<option value="${g}">Grupo ${g}</option>`).join("");

  const provDatalist = (state.data.proveedores||[]).map(p =>
    `<option value="${escapeHTML(p.nombre)}">${escapeHTML(p.nombre)}${p.nit ? " — NIT " + escapeHTML(p.nit) : ""}</option>`
  ).join("");

  const itemsRows = mo.items.map((it,i) => `
    <tr style="border-top:1px solid ${C.border};">
      <td style="padding:6px 8px;text-align:center;color:${C.muted};">${i+1}</td>
      <td style="padding:6px 8px;font-weight:600;">
        ${escapeHTML(it.articulo)}
        ${it.paraKit ? `<div style="font-size:9.5px;color:#7c3aed;font-weight:700;">🧩 para ${escapeHTML(it.paraKit)}</div>` : ""}
      </td>
      <td style="padding:6px 8px;color:${C.muted};font-size:11.5px;">${escapeHTML(it.descripcion||"")}</td>
      <td style="padding:6px 8px;text-align:right;font-weight:700;color:#16a34a;">${it.stockActual !== undefined ? it.stockActual : "—"}</td>
      <td style="padding:6px 8px;text-align:right;color:${C.muted};">${it.cantidadOP !== undefined ? it.cantidadOP : "—"}</td>
      <td style="padding:6px 8px;text-align:right;font-weight:800;color:#dc2626;">${it.cantidad}</td>
      <td style="padding:6px 8px;width:130px;">
        <input data-multiocp-item="${i}" data-multiocp-field="costo" type="number" inputmode="decimal" value="${it.costo}" style="${inputStyle}text-align:right;padding:5px 7px;"/>
      </td>
      <td style="padding:6px 8px;width:130px;">
        <select data-multiocp-item="${i}" data-multiocp-field="grupo" style="${inputStyle}padding:5px 7px;cursor:pointer;">
          ${grupoKeys.map(g => `<option value="${g}" ${String(it.grupo)===g?"selected":""}>Grupo ${g}</option>`).join("")}
        </select>
      </td>
    </tr>
  `).join("");

  const gruposHTML = grupoKeys.map(g => {
    const items = mo.items.filter(it => String(it.grupo) === g);
    const subtotal = items.reduce((s,it) => s + (parseNumber(it.cantidad)*parseNumber(it.costo)), 0);
    const grupo = mo.grupos[g];
    return `
      <div style="border:1px solid ${C.border};border-radius:6px;padding:9px;margin-bottom:10px;background:#f8fafc;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
          <div style="font-weight:700;color:${C.purple};font-size:12px;">🛒 OCP — Grupo ${g} <span style="color:${C.muted};font-weight:500;font-size:10.5px;">(${items.length} ítem${items.length!==1?"s":""})</span></div>
          ${g !== "1" ? `<button data-action="remove-grupo-ocp" data-grupo="${g}" style="background:transparent;border:none;color:${C.red};cursor:pointer;font-size:14px;">🗑 Quitar grupo</button>` : ""}
        </div>
        <div style="display:flex;gap:10px;align-items:flex-end;flex-wrap:wrap;">
          <div style="flex:1;min-width:220px;">
            <label style="font-size:10.5px;color:${C.muted};font-weight:600;">Proveedor</label>
            <input data-multiocp-grupo="${g}" list="list-prov-multiocp" value="${escapeHTML(grupo.proveedor_nombre||"")}" placeholder="🔍 Escribe o crea un proveedor..." autocomplete="off" style="${inputStyle}"/>
          </div>
          <div style="text-align:right;">
            <div style="font-size:10px;color:${C.muted};font-weight:700;">SUBTOTAL ESTIMADO</div>
            <div style="font-size:16px;font-weight:800;color:${C.purple};">${fmtCOP(subtotal)}</div>
          </div>
        </div>
      </div>
    `;
  }).join("");

  state.modal = `
    <div data-action="close-modal-bg" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;z-index:1000;padding:11px;">
      <div data-action="prevent-close" style="background:white;border-radius:14px;width:920px;max-width:100%;max-height:90vh;overflow:auto;box-shadow:0 20px 60px rgba(0,0,0,.2);">
        <div style="padding:10px 12px;border-bottom:1px solid ${C.border};display:flex;justify-content:space-between;align-items:center;background:#f8fafc;">
          <div>
            <h3 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">🛒 Convertir a Orden(es) de Compra</h3>
            <div style="font-size:11.5px;color:${C.muted};margin-top:2px;">Desde ${escapeHTML(op.numero)} — ${escapeHTML(cliente.nombre||"")}</div>
          </div>
          <button data-action="close-modal" style="background:transparent;border:none;font-size:16px;color:${C.muted};cursor:pointer;">✕</button>
        </div>
        <datalist id="list-prov-multiocp">${provDatalist}</datalist>
        <div style="padding:11px;">
          <div style="background:#f8fafc;border:1px solid #bfdbfe;border-radius:6px;padding:10px;margin-bottom:9px;font-size:11.5px;color:#1e40af;">
            💡 Asigna un costo unitario y un grupo a cada ítem. Cada grupo se convertirá en una OCP independiente con su propio proveedor — útil cuando distintos productos se compran a distintos proveedores.
          </div>
          <div style="overflow-x:auto;margin-bottom:9px;">
            <table style="width:100%;border-collapse:collapse;font-size:12px;">
              <thead>
                <tr style="background:#f1f5f9;">
                  <th style="padding:8px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">#</th>
                  <th style="padding:8px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Artículo</th>
                  <th style="padding:8px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Descripción</th>
                  <th style="padding:8px;text-align:right;font-size:10.5px;font-weight:700;color:#16a34a;">Stock</th>
                  <th style="padding:8px;text-align:right;font-size:10.5px;font-weight:700;color:${C.muted};">Cant. OP</th>
                  <th style="padding:8px;text-align:right;font-size:10.5px;font-weight:700;color:#dc2626;">A comprar</th>
                  <th style="padding:8px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Costo unitario</th>
                  <th style="padding:8px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Grupo OCP</th>
                </tr>
              </thead>
              <tbody>${itemsRows}</tbody>
            </table>
          </div>

          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;">
            <h4 style="margin:0;color:${C.text};font-size:12px;font-weight:700;">📦 Órdenes de Compra a crear</h4>
            <div style="display:flex;gap:8px;align-items:flex-end;">
              <div>
                <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">¿Cuántos grupos / proveedores necesitas?</label>
                <input id="multiocp-num-grupos" type="number" min="1" max="20" value="${mo.numGruposDeseado || grupoKeys.length}" style="${inputStyle}width:80px;text-align:right;" oninput="state.multiOcp.numGruposDeseado=parseInt(this.value)||1;"/>
              </div>
              <button data-action="generar-grupos-ocp" style="${btnStyle(C.purple,null,true)}">⚙️ Generar grupos</button>
              <button data-action="add-grupo-ocp" style="${btnStyle(C.accent,null,true)}">+ Agregar grupo</button>
            </div>
          </div>
          ${gruposHTML}

          <div style="display:flex;gap:10px;justify-content:flex-end;padding-top:14px;border-top:1px solid ${C.border};">
            <button data-action="close-modal" style="${btnStyle(null,"secondary")}">Cancelar</button>
            <button data-action="confirmar-multi-ocp" style="${btnStyle(C.purple)}">✅ Crear ${grupoKeys.length > 1 ? grupoKeys.length + " Órdenes de Compra" : "Orden de Compra"}</button>
          </div>
        </div>
      </div>
    </div>
  `;
  render();
}

export function getFieldKey(el) {
  if (!el) return null;
  if (el.dataset && el.dataset.form) return { type:"form", name: el.dataset.form };
  if (el.dataset && el.dataset.formLookup) return { type:"lookup", name: el.dataset.formLookup };
  if (el.dataset && el.dataset.item != null && el.dataset.field) return { type:"item", idx: el.dataset.item, field: el.dataset.field };
  if (el.id) return { type:"id", id: el.id };
  return null;
}

export function findFieldByKey(key) {
  if (!key) return null;
  if (key.type === "form") return document.querySelector(`[data-form="${key.name}"]`);
  if (key.type === "lookup") return document.querySelector(`[data-form-lookup="${key.name}"]`);
  if (key.type === "item") return document.querySelector(`[data-item="${key.idx}"][data-field="${key.field}"]`);
  if (key.type === "id") return document.getElementById(key.id);
  return null;
}

export function getNextFieldKey(el) {
  const modal = (el.closest && el.closest('[data-action="prevent-close"]')) || document;
  const focusables = Array.from(modal.querySelectorAll('input, select, textarea'))
    .filter(x => !x.disabled && x.type !== "hidden");
  const idx = focusables.indexOf(el);
  const next = (idx >= 0 && idx + 1 < focusables.length) ? focusables[idx + 1] : null;
  return getFieldKey(next);
}

// ─── Autoguardado del documento en curso ─────────────────────────────────────
// Un documento abierto vive solo en memoria: si el navegador se cierra, se
// pierde lo escrito y ni siquiera queda en "documentos a medias" (esa lista se
// arma con los borradores YA guardados). Aquí se guarda solo, como borrador,
// unos segundos después de dejar de escribir.
//
// NO es el guardado normal: no valida, no numera dos veces, no finaliza y no
// abre la ventana del contacto. Solo pone a salvo lo que haya.
//
// Arranca únicamente cuando el documento ya es "de verdad" —tiene tercero y al
// menos un artículo con nombre—; así abrir un formulario y cerrarlo no deja
// basura ni consume consecutivos.
const AUTOGUARDADO_MS = 4000;
let autoguardadoTimer = null;
let autoguardando = false;

function valeLaPenaGuardar(f, tipo) {
  if (!f || f._locked) return false;
  if (!["CT", "OP", "OCP", "RC"].includes(tipo)) return false;
  const tieneTercero = tipo === "OCP" ? !!f.proveedor_id : !!(f.cliente_id || esClienteLibre(f));
  const tieneArticulo = (f.items || []).some(it => String(it.articulo || "").trim());
  return tieneTercero && tieneArticulo;
}

export function programarAutoguardado() {
  clearTimeout(autoguardadoTimer);
  autoguardadoTimer = setTimeout(() => { autoguardarBorrador(); }, AUTOGUARDADO_MS);
}

export function cancelarAutoguardado() {
  clearTimeout(autoguardadoTimer);
  autoguardadoTimer = null;
}

export async function autoguardarBorrador() {
  const f = state.editingDoc;
  const tipo = state.editingTipo;
  if (autoguardando || !valeLaPenaGuardar(f, tipo)) return;
  // Con una ventana encima del formulario (contacto, crear cliente, tercero no
  // registrado) el usuario está a medio contestar algo: guardar ahí sería
  // meterse en medio y además pisar el formulario con un re-render.
  if (state._ctContacto || state._crearClienteDraft || state._clienteLibreDraft) return;
  autoguardando = true;
  try {
    const info = DOC_INFO[tipo];
    const isRC = tipo === "RC";
    const items = (f.items || []).map(it => {
      const cantidad = parseNumber(it.cantidad);
      const precio = parseNumber(it.precio_unitario);
      // Las bolsas se normalizan como en el guardado manual: una casilla vacía
      // ("") iba tal cual a una columna numérica y Supabase rechazaba TODAS las
      // líneas — la remisión quedaba en la nube sin líneas (RS-0228).
      return { ...it, cantidad, precio_unitario: isRC ? 0 : precio, total: isRC ? 0 : cantidad * precio,
               ...(isRC ? { bolsas: parseNumber(it.bolsas) || 1 } : {}) };
    });
    const subtotal = items.filter(aportaATotales).reduce((s, it) => s + (it.total || 0), 0);
    const iva = isRC ? 0 : desgloseIVA(items.filter(aportaATotales)).iva;

    // El número se pide UNA sola vez; a partir de ahí se actualiza el mismo
    // documento (y el "Guardar" manual posterior también, no duplica).
    if (!f.numero || f.numero === "(automático)") {
      f.numero = await siguienteNumeroDoc(info.prefix);
    }
    if (!f.id) f.id = genId();

    const borrador = { ...f, items, subtotal, iva, total: subtotal + iva, estado: f.estado || "borrador" };
    delete borrador._subtotal; delete borrador._iva; delete borrador._total;
    delete borrador._contacto_idx;
    sellarAutor(borrador);

    const lista = state.data[info.key] || [];
    const i = lista.findIndex(x => x.id === borrador.id);
    saveData(info.key, i >= 0
      ? lista.map(x => x.id === borrador.id ? borrador : x)
      : [...lista, borrador]);

    if (borrador.estado === "borrador") registrarPendiente(tipo, borrador.id);
    mostrarAvisoAutoguardado(borrador.numero);
  } catch {
    // Sin sesión o sin red: no se puede numerar/guardar. El aviso de salida
    // sigue protegiendo el trabajo, así que no se interrumpe al usuario.
  } finally {
    autoguardando = false;
  }
}

// Confirmación discreta: que se note que quedó a salvo, sin estorbar.
function mostrarAvisoAutoguardado(numero) {
  try {
    let el = document.getElementById("__autoguardado");
    if (!el) {
      el = document.createElement("div");
      el.id = "__autoguardado";
      el.style.cssText = "position:fixed;bottom:16px;left:16px;z-index:1200;background:#0f172a;color:white;font-size:11px;font-weight:600;padding:7px 12px;border-radius:18px;box-shadow:0 6px 18px rgba(0,0,0,.22);font-family:sans-serif;pointer-events:none;";
      document.body.appendChild(el);
    }
    el.textContent = `💾 Borrador guardado (${numero})`;
    el.style.transition = ""; el.style.opacity = "1";
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.style.transition = "opacity .5s"; el.style.opacity = "0"; }, 2600);
  } catch { /* sin DOM */ }
}

// Botones que aparecen DEBAJO del campo de búsqueda (crear cliente / cotizar
// sin crearlo) y que se pulsan mientras el campo tiene el foco.
//
// El `blur` del buscador programa un re-render del formulario a los 50 ms. Un
// clic humano dura bastante más (80-150 ms entre apretar y soltar), así que ese
// re-render llegaba PRIMERO: destruía el botón antes de que el clic se
// disparara, y de paso dejaba el campo Cliente vacío. Para el usuario, "se
// borra todo" y el botón no hace nada.
//
// Cancelar el mousedown evita que el campo pierda el foco, así no hay blur, no
// hay re-render, y el clic llega intacto.
function noRobarFoco(btn) {
  btn.addEventListener("mousedown", ev => ev.preventDefault());
}

export function handleLookupInput(e) {
  if (!e.target) return;
  
  const el = e.target;
  const fieldId = el.dataset.formLookup;
  const lookupType = el.dataset.lookupType;
  const inputValue = (el.value || "").trim();
  
  if (!fieldId || !lookupType) return;
  
  const collection = state.data[lookupType] || [];

  // Buscar match exacto o parcial
  let match = null;
  
  // Primero intentar match exacto
  match = collection.find(c => normalize(c.nombre) === normalize(inputValue));
  
  // Si no encuentra exacto, buscar por coincidencia parcial
  if (!match && inputValue) {
    match = collection.find(c => normalize(c.nombre).includes(normalize(inputValue)));
  }
  
  // Creación rápida de cliente: si lo escrito no corresponde a ningún cliente,
  // se ofrece crearlo sin salir del documento (mismo patrón que "Crear producto"
  // en las líneas). El botón se maneja con DOM directo: un render() aquí
  // destruiría el campo mientras se escribe.
  if (fieldId === "cliente_id" && state.editingDoc) {
    // Con un tercero NO registrado ya elegido, lo escrito ES su nombre: no hay
    // nada que ofrecer ni que borrar. (Si el usuario escribe otra cosa, deja de
    // coincidir y abajo se limpia el tercero libre para volver a empezar.)
    const libreVigente = esClienteLibre(state.editingDoc)
      && normalize(state.editingDoc._clienteLibre.nombre) === normalize(inputValue);

    let btn = document.getElementById("btn-crear-cliente-rapido");
    let btnLibre = document.getElementById("btn-cliente-libre");
    if (!match && !libreVigente && inputValue.length >= 3) {
      if (!btn) {
        btn = document.createElement("button");
        btn.id = "btn-crear-cliente-rapido";
        btn.type = "button";
        btn.dataset.action = "crear-cliente-rapido";
        btn.style.cssText = "margin-top:5px;font-size:10px;padding:3px 8px;border-radius:4px;border:1px solid " + C.accent + ";background:" + C.accent + "12;color:" + C.accent + ";cursor:pointer;font-weight:700;font-family:inherit;";
        noRobarFoco(btn);
        el.parentElement.appendChild(btn);
      }
      btn.dataset.nombre = inputValue;
      btn.textContent = `➕ Crear cliente "${inputValue}"`;
      // Segunda salida: cotizarle sin crear la ficha. Para prospectos que
      // todavía no son clientes, y así el maestro no se llena de fichas
      // muertas. Solo en cotizaciones: una OP/RC/factura sí exige ficha real.
      if (state.editingTipo === "CT") {
        if (!btnLibre) {
          btnLibre = document.createElement("button");
          btnLibre.id = "btn-cliente-libre";
          btnLibre.type = "button";
          btnLibre.dataset.action = "usar-cliente-libre";
          btnLibre.style.cssText = "margin-top:5px;margin-left:6px;font-size:10px;padding:3px 8px;border-radius:4px;border:1px solid #d97706;background:#fffbeb;color:#92400e;cursor:pointer;font-weight:700;font-family:inherit;";
          noRobarFoco(btnLibre);
          el.parentElement.appendChild(btnLibre);
        }
        btnLibre.dataset.nombre = inputValue;
        btnLibre.textContent = "✏️ Cotizar sin crearlo";
      }
    } else {
      if (btn) btn.remove();
      if (btnLibre) btnLibre.remove();
    }

    // Escribió algo distinto del tercero libre: se descarta para no dejar
    // pegado un nombre que ya no corresponde a lo que dice el campo.
    if (!libreVigente && esClienteLibre(state.editingDoc)) delete state.editingDoc._clienteLibre;
    if (libreVigente) return;   // el tercero libre manda: no tocar cliente_id
  }

  // Actualizar el documento o maestro en edición
  if (state.editingDoc) {
    // Guardar el ID del cliente/proveedor
    const idAnterior = state.editingDoc[fieldId];
    state.editingDoc[fieldId] = match ? match.id : "";
    // Cambió el cliente: el contacto elegido era de OTRA empresa, así que la
    // pregunta "¿a quién va dirigida?" vuelve a tener sentido.
    if (fieldId === "cliente_id" && idAnterior !== state.editingDoc[fieldId]) {
      state.editingDoc._contactoConfirmado = false;
    }
    
    // Precarga desde la ficha del cliente (plazo, forma de pago, asesor) en
    // documentos nuevos. Se RECUERDA de qué cliente vino: el campo busca por
    // coincidencia parcial mientras se teclea, y un cliente que coincidió un
    // instante con las primeras letras dejaba pegado su plazo (así salieron a
    // 30 días cotizaciones a terceros no registrados). Ver core/precargaCliente.js.
    if (lookupType === "clientes" && !state.editingDoc.id) {
      const previa = state._precargaCliente;
      const nuevoId = match ? match.id : "";
      if (!previa || previa.de !== nuevoId) {
        deshacerPrecarga(state.editingDoc, previa);
        state._precargaCliente = match ? aplicarPrecarga(state.editingDoc, match, { esConversion: !!state.isConversion }) : null;
        // SIN repintar aquí: esto corre con cada letra, y repintar a mitad de
        // la escritura reemplaza el campo —se pierde lo tecleado y los botones
        // de «Crear cliente / Cotizar sin crearlo»—. Al salir del campo el
        // formulario se repinta solo (blur) y ahí aparecen plazo y asesor.
      }
    }
  } else if (state.editingMaestro) {
    state.editingMaestro[fieldId] = match ? match.id : "";
  }
}

// ─── Sincronizar costos asociados (OP) → OCPs ───────────────────────────────
// Solo procesa los conceptos cuyo DESTINO confirmado es "ocp": desde que el
// destino se pregunta (o se sugiere por memoria), un concepto puede volverse
// orden de compra, cuenta por pagar directa (ver cuentasPagar.js) o nada.
export function sincronizarOcpDeCostos(final) {
  // En fila con la sincronización de CxP de la MISMA orden: dos guardados a la
  // vez leían los dos los conceptos sin documento y creaban dos veces (ver
  // core/enSerie.js y la OP-0219, que quedó con diez CxP en vez de cinco).
  return enSerie("costos:" + final.id, () => _sincronizarOcpDeCostos(final));
}

async function _sincronizarOcpDeCostos(final) {
// ─── Sincronizar costos asociados (OP) con Cuentas por Pagar ───
// Los costos de línea que van al MISMO proveedor se agrupan en UNA sola
// OCP, con cada costo como una línea individual (aunque se parezcan o
// repitan). Antes se creaba una OCP por concepto, lo que llenaba de
// órdenes de compra repetidas al mismo proveedor.
{
  const newConceptos = final._conceptosCosto || [];
  const _origenOP = { tipo:"OP", id: final.id, numero: final.numero, fecha: final.fecha };

  let ocpListW = [...state.data.ocp];
  let provList = [...state.data.proveedores];

  // Id estable del concepto (para el borrado legítimo por diferencia)
  newConceptos.forEach(c => { if (!c._ccid) c._ccid = genId(); });

  // 1. Conceptos válidos (con proveedor y valor), resolviendo su proveedor.
  //    Los que quedan sin proveedor/valor pierden su vínculo a OCP.
  // La clave del grupo es el proveedor Y la clase de orden, porque una OFICIAL y
  // una INFORMATIVA no pueden compartir documento: llevan series distintas y la
  // informativa no se ingresa ni se causa.
  const grupos = new Map();   // "provId|clase" -> { prov, informativa, lineas:[…] }
  for (const c of newConceptos) {
    const cantidad = parseNumber(c.cantidad) || 0;
    const valorTercero = parseNumber(c.valor_tercero) || 0;
    const totalC = cantidad * valorTercero;
    const provNombre = (c.proveedor_nombre || "").trim();
    // Comisiones nunca. Y de los demás, dos caminos llegan a una orden de compra:
    //   · destino "ocp" — la compra formal de siempre;
    //   · destino "cxp" con «además, orden de compra» — el papel que se le manda
    //     al proveedor para que sepa qué tiene que cumplir, aunque lo que se le
    //     pague sea una cuenta de cobro.
    if (c._esComision) continue;
    const esOcp = c._via === "ocp";
    const ocpExtra = c._via === "cxp" && c._ocpAdemas === "si";
    if ((!esOcp && !ocpExtra) || !provNombre || totalC <= 0) { delete c._ocpId; if (!ocpExtra) delete c.proveedor_id; continue; }

    let prov = provList.find(p => normalize(p.nombre) === normalize(provNombre));
    if (!prov) {
      prov = { id: genId(), nombre: provNombre, nit:"", telefono:"", email:"", direccion:"", dias_pago: 30 };
      provList = [...provList, prov];
    }
    c.proveedor_id = prov.id;
    // Informativa = SOLO la que acompaña a una cuenta de cobro. La que nace del
    // destino "orden de compra" es una compra de verdad: oficial y con su IVA.
    const informativa = ocpExtra;
    const clave = prov.id + "|" + (informativa ? "i" : "o");
    if (!grupos.has(clave)) grupos.set(clave, { prov, informativa, lineas: [] });
    grupos.get(clave).lineas.push({ c, cantidad, valorTercero, totalC });
  }

  // La línea de la OCP. Si el costo apunta a un producto del catálogo, el
  // artículo ES ese producto: así la orden de compra pide lo que de verdad se
  // compra, con su IVA y con una ficha de inventario a la que el ingreso puede
  // llegar. Sin producto queda el concepto como texto, igual que siempre.
  const linea = (v) => {
    const prodRef = (v.c.articulo || "").trim() ? productoDeArticulo(v.c.articulo) : null;
    const it = {
      // El costo del que nace la línea: con él, la próxima sincronización la
      // reconoce y le conserva lo que se tecleó (ver conservarDetalleLineas).
      _ccid: v.c._ccid,
      articulo: prodRef ? prodRef.nombre : (v.c.concepto || "Costo asociado"),
      descripcion: prodRef
        ? [v.c.concepto, `para ${final.numero}`].filter(Boolean).join(" · ")
        : `Costo asociado a ${final.numero}`,
      color:"", logo:"", impresion:"", ubicacion:"",
      cantidad: v.cantidad, precio_unitario: v.valorTercero, total: v.totalC
    };
    // Lo que se respondió en «¿lleva IVA?» viaja en la LÍNEA, no en un total
    // aparte: así el régimen queda escrito en la orden de compra —que es un
    // documento— y el IVA se sigue sumando línea por línea como en todo el ERP.
    // "No" gana siempre: quien compra tiene la factura del proveedor delante.
    // Sin IVA solo la informativa: la orden de compra oficial lleva el que
    // corresponda, y eso lo decide la ficha del proveedor y el régimen del bien.
    if (v.informativa) { it.iva_tipo = "excluido"; it.iva_pct = 0; }
    return it;
  };

  // El IVA de una OCP de costos. Solo lo causan las líneas que apuntan a un
  // producto del catálogo: de esas sabemos su régimen. Un concepto de texto
  // libre (marcación, domicilio) sigue en cero como hasta ahora — cambiarlo
  // sin que nadie lo pida movería el valor de las órdenes ya existentes.
  // El IVA de una OCP nacida de costos. Manda el proveedor: si es responsable de
  // IVA, su servicio causa IVA y ese IVA es DESCONTABLE — dejarlo en cero era
  // regalarle a la DIAN un impuesto que la empresa ya pagó (una marcación de
  // $600.000 de una temporaria se iba con $114.000 sin descontar).
  //
  // El cálculo es por línea, como en todo el ERP: una línea que apunta a un
  // producto del catálogo toma el régimen de ese bien (una mata viva sigue
  // excluida, art. 424), y una de texto libre cae en gravado a la tarifa
  // general, que es lo que es un servicio de marcación o de transporte.
  const ivaDeOcpCostos = (items, lineas, prov, informativa) => {
    // Una orden informativa va SIN IVA por definición: no se causa, así que no
    // hay descontable que llevar — es un control de lo que el proveedor debe
    // cumplir, no el documento con el que se contabiliza la compra.
    if (informativa) return 0;
    if (!prov || !prov.responsable_iva) return 0;
    return items.length ? desgloseIVA(items).iva : 0;
  };
  const usadas = new Set();   // OCPs que quedan en uso

  // 2. Una OCP por proveedor con todas sus líneas.
  for (const { prov, informativa, lineas } of grupos.values()) {
    lineas.forEach(v => { v.informativa = informativa; });
    // OCPs _fromCosto vivas ya vinculadas a este grupo (por _ocpId)
    const existentes = [];
    const vistas = new Set();
    for (const v of lineas) {
      const id = v.c._ocpId;
      // Solo se reutiliza una orden de la MISMA clase: si un costo pasa de
      // oficial a informativa (o al revés) le toca documento nuevo, con el
      // consecutivo de su serie. Reusar la vieja dejaría una OCP-xxxx que ya no
      // se causa, o una OCI-xxxx metida en la contabilidad.
      if (id && !vistas.has(id)) {
        vistas.add(id);
        const o = ocpListW.find(o => o.id === id && o._fromCosto && !!o._informativa === !!informativa);
        if (o) existentes.push(o);
      }
    }
    const pagadas = existentes.filter(o => getMontoPagadoOCP(o) > 0);

    // Caso raro y delicado: 2+ OCP del grupo con abonos. Consolidar
    // perdería historial de pagos → se dejan separadas (una por concepto).
    if (pagadas.length >= 2) {
      for (const v of lineas) {
        const previa = v.c._ocpId && ocpListW.find(o => o.id === v.c._ocpId);
        if (previa) {
          const itsU = conservarDetalleLineas([linea(v)], previa.items);
          const ivaU = ivaDeOcpCostos(itsU, [v], prov, informativa);
          ocpListW = ocpListW.map(o => o.id === v.c._ocpId ? { ...o, proveedor_id: prov.id, items:itsU, subtotal:v.totalC, iva:ivaU, total:v.totalC + ivaU, _origen:_origenOP } : o);
          usadas.add(v.c._ocpId);
        } else {
          const itsN = [linea(v)];
          const ivaN = ivaDeOcpCostos(itsN, [v], prov, informativa);
          const nueva = { id: genId(), numero: await siguienteNumeroDoc(informativa ? "OCI" : "OCP"), fecha: final.fecha || today(), proveedor_id: prov.id, items:itsN, subtotal:v.totalC, iva:ivaN, total:v.totalC + ivaN, estado:"borrador", estado_pago:"por_pagar", _origen:_origenOP, _fromCosto:true, ...(informativa ? { _informativa: true } : {}) };
          sellarAutor(nueva); ocpListW = [...ocpListW, nueva]; v.c._ocpId = nueva.id; usadas.add(nueva.id);
        }
      }
      continue;
    }

    // Consolidar en una sola OCP: la pagada (para conservar sus abonos) o
    // la primera existente; si no hay, una nueva.
    const target = pagadas[0] || existentes[0] || null;
    const items = conservarDetalleLineas(lineas.map(linea), target ? target.items : []);
    const subtotal = items.reduce((s, it) => s + it.total, 0);
    const iva = ivaDeOcpCostos(items, lineas, prov, informativa);
    let ocpId;
    if (target) {
      ocpListW = ocpListW.map(o => o.id === target.id ? { ...o, proveedor_id: prov.id, items, subtotal, iva, total: subtotal + iva, _origen:_origenOP } : o);
      ocpId = target.id;
    } else {
      const nueva = { id: genId(), numero: await siguienteNumeroDoc(informativa ? "OCI" : "OCP"), fecha: final.fecha || today(), proveedor_id: prov.id, items, subtotal, iva, total: subtotal + iva, estado:"borrador", estado_pago:"por_pagar", _origen:_origenOP, _fromCosto:true, ...(informativa ? { _informativa: true } : {}) };
      sellarAutor(nueva); ocpListW = [...ocpListW, nueva]; ocpId = nueva.id;
    }
    usadas.add(ocpId);
    lineas.forEach(v => v.c._ocpId = ocpId);
  }

  // 3. Limpiar OCPs _fromCosto de ESTA OP que ya no se usan y no tienen
  //    abonos (per-concepto sobrantes tras consolidar, o de conceptos
  //    quitados). Las que tienen abonos se conservan siempre.
  ocpListW = ocpListW.filter(o => {
    if (!(o._fromCosto && o._origen && o._origen.id === final.id)) return true;
    if (usadas.has(o.id)) return true;
    return getMontoPagadoOCP(o) > 0;
  });

  saveData("proveedores", provList);
  saveData("ocp", ocpListW);
}

}

export async function aplicarCambioEstadoDoc(tipo, doc, newState) {
  if (tipo === "CT" && newState === "enviada" && !doc._fecha_enviada) {
    doc._fecha_enviada = today();
  }
  if (tipo === "FACT" && newState === "emitida" && !doc._asientoVenta) {
    // Fijar las retenciones del cliente ANTES del asiento: quedan guardadas en
    // la factura y la cartera calcula el neto real por cobrar con ellas.
    const _ret = calcularRetencionesVenta(doc);
    if (_ret.total > 0) doc.retenciones = { retefuente:_ret.montoRF, reteica:_ret.montoRICA, reteiva:_ret.montoRIVA };
    const asiento = await generarAsientoVenta(doc);
    doc._asientoVenta = asiento.id;
  }
  if (tipo === "FACT" && newState === "pagada" && !doc._asientoCobro) {
    // Cobrar solo el SALDO pendiente: los abonos previos ya tienen su asiento y
    // lo retenido por el cliente no entra por bancos (acreditar el total dejaba
    // la CxC en negativo).
    const _saldoF = getSaldoFactura(doc);
    if (_saldoF > 0) {
      const asiento = await generarAsientoCobroFactura(doc, _saldoF, "transferencia");
      doc._asientoCobro = asiento.id;
    }
  }
  if (tipo === "NC" && newState === "emitida" && !doc._asientoNC) {
    const asiento = await generarAsientoNotaCredito(doc);
    doc._asientoNC = asiento.id;
  }
  // Una remisión SIN líneas no entregó nada: completarla la dejaría marcada
  // como entregada (y con el inventario "descontado") sin mover el kardex, y
  // después el ERP la trataría como una entrega real — hasta facturarla.
  if (tipo === "RC" && ["completada", "entregada"].includes(newState) &&
      !(doc.items || []).some(it => (parseNumber(it.cantidad) || 0) > 0)) {
    throw new Error(`"${doc.numero}" no tiene líneas con cantidad: una entrega sin artículos no se puede completar.\n\n` +
      `Ábrela y pon lo que se entregó, o elimínala si no se usó.`);
  }
  if (tipo === "RC" && newState === "completada" && !doc._inventarioDescontado) {
    // Un artículo que se arma al entregar no está en la bodega: lo que sale son
    // sus partes. Las dos listas son distintas a propósito — el kardex se mueve
    // por COMPONENTE y el costo de ventas se lleva por el artículo VENDIDO, que
    // es el que está en la factura. Ambas se calculan ANTES de sacar nada: el
    // egreso mueve el costo promedio.
    const opOrigen = (doc._origen && doc._origen.tipo === "OP")
      ? (state.data.pedidos || []).find(p => p.id === doc._origen.id) : null;
    const salidas = egresosDeRemision(doc, opOrigen);
    const costos = costosDeRemision(doc, opOrigen);
    // La salida se firma con la remisión que la produce. Sin esto el kardex la
    // anotaba como "Ajuste", y un ajuste es lo que nadie puede explicar: la
    // mercancía parecía desaparecer de la bodega sin documento, no aparecía al
    // filtrar la trazabilidad por remisiones, y la única lectura posible era que
    // el ingreso se había perdido. Cuando sale una parte, se anota de qué
    // artículo armado viene: si no, el kardex de la matera no explicaría por qué
    // salió al entregar una suculenta.
    salidas.forEach(c => ajustarInventario(c.articulo, -c.cantidad,
      { tipo:"RC", id: doc.id, numero: doc.numero,
        nota: c._deKit ? `parte de ${c._deKit}` : null }, doc.fecha));
    doc._inventarioDescontado = true;
    // Si esta mercancía ya se había facturado por anticipado, su costo de ventas
    // se registra ahora, con la fecha de la salida.
    try { await registrarCostoEntrega(doc, costos); }
    catch (err) { console.error("⚠️ No se pudo registrar el costo de la entrega:", err); }
  }
}

// ─── Borrar un documento que ya movió algo ──────────────────────────────────
// Una remisión completada YA sacó la mercancía del kardex. Borrarla sin más
// dejaba la salida huérfana: el inventario en cero, la mercancía en la bodega y
// una OCP que parecía no haber llegado nunca. Pasó de verdad — RS-0224 se
// eliminó después de entregar y se llevó del kardex 50 humidificadores, 100
// sets de bar y 50 termos que estaban físicamente en la bodega; la OCP-0304
// mostraba el ingreso hecho y el inventario decía que no había nada.
//
// Devuelve un motivo cuando el documento NO se puede borrar, y null cuando ya
// se dejó todo reversado y se puede seguir.
export function prepararBorradoDoc(tipo, doc) {
  // ── 1. Una entrega ya facturada ─────────────────────────────────────────
  // Puede no aparecer como "hijo" si la factura cubre varias entregas: el
  // _origen apunta a la primera y las demás viajan en _origenes.
  if (tipo === "RC") {
    const factura = (state.data.facturas || []).find(f => f.estado !== "anulada" &&
      [f._origen, ...(Array.isArray(f._origenes) ? f._origenes : [])]
        .filter(Boolean).some(o => o.tipo === "RC" && o.id === doc.id));
    if (factura) {
      return `"${doc.numero}" ya está facturada en ${factura.numero} y no se puede eliminar.\n\n` +
        `Borrarla dejaría la factura apuntando a una entrega que no existe. Para deshacer la venta, ` +
        `anula la factura con una nota crédito.`;
    }
  }

  // ── 2. Nada que ya generó otro documento ────────────────────────────────
  // El hijo quedaría apuntando al vacío. Pasó: se borró la OP-0213 y su
  // OCP-0302 quedó colgando de una orden que no existe.
  const hijos = descendientesDoc(tipo, doc).filter(h => h.nivel === 0);
  if (hijos.length) {
    return `"${doc.numero}" ya generó ${hijos.map(h => h.numero).join(", ")} y no se puede eliminar.\n\n` +
      `Esos documentos quedarían apuntando a uno que no existe. Anula o elimina primero lo que salió de él, ` +
      `empezando por el último.`;
  }

  // ── 3. Una orden de compra que ya movió algo ────────────────────────────
  // Borrar una OCP ya ingresada dejaría una ENTRADA huérfana en el kardex:
  // inventario que el ERP cree que llegó y no llegó, inflando el stock y la
  // cuenta 1435. Y si ya está causada, su asiento se quedaría sin documento.
  // Aquí no se reversa: la mercancía está o no está en la bodega, y eso lo
  // decide una persona con un ajuste de inventario, no un borrado.
  if (tipo === "OCP") {
    const proc = doc._procesado || {};
    const motivos = [];
    if (proc.ingreso || (doc._recepciones || []).length) motivos.push("ya ingresó mercancía al inventario");
    if (proc.factura) motivos.push(`ya está causada con la factura del proveedor${proc.factura_numero ? " " + proc.factura_numero : ""}`);
    if (getMontoPagadoOCP(doc) > 0) motivos.push(`ya tiene abonos por ${fmtCOP(getMontoPagadoOCP(doc))}`);
    if (motivos.length) {
      return `"${doc.numero}" ${motivos.join(", ")}, así que no se puede eliminar.\n\n` +
        `Borrarla dejaría el kardex y la contabilidad hablando de un documento que no existe. ` +
        `Si la compra no era, cancélala (queda el registro) y ajusta el inventario desde Inventarios.`;
    }
  }

  if (tipo !== "RC" || !doc._inventarioDescontado) return null;

  // Devolver al kardex lo que esta remisión sacó, firmado como reversa: la
  // mercancía sigue en la bodega, así que el inventario tiene que volver a
  // decirlo. Se recalcula con la MISMA puerta que lo sacó, así que de un kit
  // vuelven sus partes, no el artículo armado.
  const opOrigen = (doc._origen && doc._origen.tipo === "OP")
    ? (state.data.pedidos || []).find(p => p.id === doc._origen.id) : null;
  const salidas = egresosDeRemision(doc, opOrigen);
  salidas.forEach(c => ajustarInventario(c.articulo, c.cantidad,
    { tipo: "RC", id: doc.id, numero: doc.numero,
      nota: `reversa por eliminación de ${doc.numero}` }, today()));
  if (salidas.length) {
    alert(`↩️ ${doc.numero} había sacado mercancía de la bodega. Se devolvió al inventario:\n\n` +
      salidas.map(c => `• ${c.cantidad} ${c.articulo}`).join("\n"));
  }
  return null;
}

import { ejecutarAccion, registerActions } from "../ui/actions.js";

// ─── ¿A quién va dirigida la cotización? ─────────────────────────────────────
// Pregunta OBLIGATORIA que se hace al pulsar Guardar en una CT: el guardado se
// detiene, se resuelve aquí y al responder continúa solo. Se pregunta en la
// cotización y no en la ficha del cliente porque el destinatario es de cada
// cotización —una misma empresa cotiza a través de personas distintas—, aunque
// la respuesta se recuerda como preferencia del cliente para la siguiente vez.
//
// Siempre hay salida: si el cliente no tiene contactos cargados, se puede
// escribir uno en el momento; y "sin contacto" es una respuesta válida. Sin eso,
// «obligatoria» sería «bloqueante».
export function pedirContactoCT() {
  const f = state.editingDoc;
  const cliente = clienteDeDoc(f);
  // Un tercero no registrado no tiene ficha ni contactos guardados: la única
  // salida es escribir el contacto en el momento (o marcar "sin contacto").
  const contactos = contactosDe(cliente);
  const sel = state._ctContacto || {};

  const opcion = (valor, titulo, sub, activa) => `
    <div data-action="ct-contacto-elegir" data-valor="${valor}"
      style="display:flex;align-items:center;gap:9px;padding:9px 11px;border-radius:8px;cursor:pointer;
             border:2px solid ${activa ? C.mathiz : C.border};background:${activa ? C.mathiz + "0d" : "white"};margin-bottom:6px;">
      <div style="width:15px;height:15px;border-radius:50%;flex-shrink:0;border:2px solid ${activa ? C.mathiz : "#cbd5e1"};
                  background:${activa ? C.mathiz : "white"};box-shadow:${activa ? "inset 0 0 0 3px white" : "none"};"></div>
      <div style="flex:1;min-width:0;">
        <div style="font-size:12px;font-weight:700;color:${C.text};">${titulo}</div>
        ${sub ? `<div style="font-size:10.5px;color:${C.muted};margin-top:1px;">${sub}</div>` : ""}
      </div>
    </div>`;

  const listaHTML = contactos.map(c => opcion(
    String(c.idx),
    escapeHTML(c.nombre) + (c.cargo ? ` <span style="font-weight:500;color:${C.muted};">— ${escapeHTML(c.cargo)}</span>` : ""),
    [c.telefono, c.email].filter(Boolean).map(escapeHTML).join(" · ") + (c.inicial ? (c.telefono || c.email ? " · " : "") + "contacto inicial" : ""),
    sel.modo === String(c.idx)
  )).join("");

  state.modal = `
    <div data-action="prevent-close" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.5);display:flex;align-items:center;justify-content:center;z-index:1000;padding:11px;">
      <div data-action="prevent-close" style="background:white;border-radius:14px;width:460px;max-width:100%;max-height:90vh;overflow:auto;box-shadow:0 20px 60px rgba(0,0,0,.25);">
        <div style="height:4px;background:linear-gradient(90deg,${C.gold},${C.mathiz});border-radius:14px 14px 0 0;"></div>
        <div style="padding:15px 17px 6px;">
          <h3 style="margin:0;font-size:15px;color:${C.text};font-weight:800;">👤 ¿A quién va dirigida esta cotización?</h3>
          <div style="font-size:11px;color:${C.muted};margin-top:5px;line-height:1.5;">
            Es el nombre y el cargo que salen impresos en el formato.
            <b>${escapeHTML(cliente.nombre || "")}</b>
          </div>
        </div>
        <div style="padding:11px 17px 4px;">
          ${listaHTML}
          ${opcion("nueva", "➕ Otra persona", "Escribe el nombre y el cargo", sel.modo === "nueva")}
          ${sel.modo === "nueva" ? `
            <div style="display:flex;gap:8px;margin:-2px 0 6px;padding-left:24px;">
              <input id="ct-contacto-nombre" value="${escapeHTML(sel.nombre || "")}" placeholder="Nombre" style="${inputStyle}flex:2;"/>
              <input id="ct-contacto-cargo" value="${escapeHTML(sel.cargo || "")}" placeholder="Cargo" style="${inputStyle}flex:2;"/>
            </div>
            <div style="margin:-2px 0 6px;padding-left:24px;">
              <input id="ct-contacto-email" type="email" value="${escapeHTML(sel.email || "")}" placeholder="Correo electrónico" style="${inputStyle}"/>
            </div>
            <div style="font-size:10px;color:${C.muted};margin:-2px 0 8px;padding-left:24px;">Queda guardada en la ficha del cliente para la próxima. El correo sale impreso en la cotización.</div>
          ` : ""}
          ${opcion("ninguno", "Sin contacto", "La cotización sale a nombre de la empresa", sel.modo === "ninguno")}
        </div>
        <div style="display:flex;gap:10px;justify-content:flex-end;padding:8px 17px 15px;border-top:1px solid ${C.border};margin-top:8px;padding-top:13px;">
          <button data-action="ct-contacto-cancelar" style="${btnStyle(null,"secondary")}">Volver</button>
          <button data-action="ct-contacto-confirmar" ${sel.modo ? "" : "disabled"}
            style="${btnStyle(sel.modo ? C.mathiz : null, sel.modo ? null : "secondary")}${sel.modo ? "" : "opacity:.5;cursor:not-allowed;"}">
            💾 Responder y guardar
          </button>
        </div>
      </div>
    </div>`;
  render();
}

registerActions({
  "toggle-panel-rs-facturar": () => {
    state._panelRSFacturarAbierto = state._panelRSFacturarAbierto === false;
    render();
  },
  "ver-rs-escaneada": (d) => {
    const rc = (state.data.remisiones || []).find(r => r.id === d.id);
    if (rc) abrirRSEscaneada(rc);
  },
  "informe-final-op": (d) => {
    const op = state.data.pedidos.find(p => p.id === d.id);
    if (!op) return;
    const cliente = state.data.clientes.find(c => c.id === op.cliente_id) || {};
    const ct = (state.data.cotizaciones || []).find(x => op._origen && x.id === op._origen.id) || null;
    const liq = getLiquidacionOP(op.id) || {};

    // Todas las OCP de la OP (incluidas las nacidas de un costo): el informe
    // muestra el panorama completo de compras. La liquidación (liq) ya evita el
    // doble conteo en el margen.
    const ocpsAll = (state.data.ocp || []).filter(o => o._origen && o._origen.id === op.id);
    const ocps = ocpsAll.map(o => {
      const prov = (state.data.proveedores || []).find(p => p.id === o.proveedor_id) || {};
      return { numero: o.numero, proveedor: prov.nombre, total: parseNumber(o.total),
               pagado: getMontoPagadoOCP(o), saldo: getSaldoOCP(o) };
    });
    // Estado de caja real: pagado / por pagar sobre TODAS las OCP.
    const costoPagado = ocps.reduce((s, o) => s + o.pagado, 0);
    const costoPorPagar = ocps.reduce((s, o) => s + o.saldo, 0);

    const remisiones = (state.data.remisiones || []).filter(r => r._origen && r._origen.id === op.id).map(r => ({
      numero: r.numero, fecha: r.fecha, estado: r.estado,
      facturaNumero: (r._factura && r._factura.numero) || (r._convertedTo && r._convertedTo.numero) || null
    }));
    const facturas = (state.data.facturas || []).filter(f => remisiones.some(r => f._origen && f._origen.tipo === "RC" && r.numero && f._origen.numero === r.numero))
      .map(f => ({ numero: f.numero, fecha: f.fecha, total: parseNumber(f.total), estado_cobro: f.estado_cobro, real: !!(f._dataico && f._dataico.real) }));

    // Pendientes
    const pendientes = [];
    const ocpPorPagar = ocps.filter(o => o.saldo > 0.5);
    if (ocpPorPagar.length) pendientes.push(`${ocpPorPagar.length} orden(es) de compra por pagar — saldo ${fmtCOP(costoPorPagar)}.`);
    const rsSinFacturar = remisiones.filter(r => r.estado !== "facturada" && r.estado !== "cancelada");
    if (rsSinFacturar.length) pendientes.push(`${rsSinFacturar.length} remisión(es) entregada(s) sin facturar (${rsSinFacturar.map(r => r.numero).join(", ")}).`);
    if (remisiones.length === 0) pendientes.push("La OP aún no tiene remisiones (entregas) registradas.");
    const factSinCobrar = facturas.filter(f => f.estado_cobro && f.estado_cobro !== "pagada");
    if (factSinCobrar.length) pendientes.push(`${factSinCobrar.length} factura(s) pendiente(s) de cobro (${factSinCobrar.map(f => f.numero).join(", ")}).`);
    if (liq.margen != null && liq.margenInicial != null && (liq.margen - liq.margenInicial) < -5) {
      pendientes.push(`El margen final (${liq.margen.toFixed(1)}%) quedó ${Math.abs(liq.margen - liq.margenInicial).toFixed(1)} puntos por debajo del estimado (${liq.margenInicial.toFixed(1)}%): revisar sobrecostos.`);
    }

    exportInformeFinalOP({
      op, cliente, ct, items: op.items || [], ocps, remisiones, facturas,
      liq: { ...liq, costoPagado, costoPorPagar },
      pendientes
    });
  },
  "ct-contacto-elegir": (d) => {
    const prev = state._ctContacto || {};
    // Al cambiar de opción se conserva lo ya escrito en "otra persona": si el
    // usuario tantea entre opciones, no pierde lo que tecleó.
    if (prev.modo === "nueva") {
      prev.nombre = document.getElementById("ct-contacto-nombre")?.value ?? prev.nombre;
      prev.cargo = document.getElementById("ct-contacto-cargo")?.value ?? prev.cargo;
      prev.email = document.getElementById("ct-contacto-email")?.value ?? prev.email;
    }
    state._ctContacto = { ...prev, modo: d.valor };
    pedirContactoCT();
  },
  "ct-contacto-cancelar": () => {
    state._ctContacto = null;
    renderDocFormModal();
  },
  "ct-contacto-confirmar": async () => {
    const sel = state._ctContacto || {};
    if (!sel.modo) return;
    const f = state.editingDoc;
    // Con un tercero NO registrado no hay ficha: el contacto se escribe y viaja
    // embebido en la cotización, sin nada que guardar en Maestros.
    const libre = esClienteLibre(f);
    const cliente = libre ? null : (state.data.clientes || []).find(c => c.id === f.cliente_id);
    if (!cliente && !libre) { state._ctContacto = null; renderDocFormModal(); return; }

    let elegido = null;
    let marcaCliente = null;

    if (sel.modo === "nueva") {
      const nombre = (document.getElementById("ct-contacto-nombre")?.value || "").trim();
      const cargo = (document.getElementById("ct-contacto-cargo")?.value || "").trim();
      const email = (document.getElementById("ct-contacto-email")?.value || "").trim();
      if (!nombre) { alert("⚠️ Escribe el nombre de la persona."); return; }
      // El correo es obligatorio: es el dato que sale impreso y evita que la
      // cotización tome por error el correo general del cliente (de otra persona).
      if (!email) { alert("⚠️ Escribe el correo electrónico de la persona: es el que sale impreso en la cotización."); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { alert("⚠️ El correo no parece válido. Revísalo."); return; }
      // Se agrega a la ficha del cliente para que la próxima cotización ya la
      // ofrezca en la lista, sin volver a teclearla. (Un tercero no registrado
      // no tiene ficha: el contacto solo queda embebido en la cotización.)
      if (cliente) {
        const nuevos = [...(cliente._contactos || []), { nombre, cargo, telefono: "", email }];
        const actualizado = { ...cliente, _contactos: nuevos, contacto_imprimible: nuevos.length - 1 };
        saveData("clientes", (state.data.clientes || []).map(c => c.id === cliente.id ? actualizado : c));
      }
      elegido = { nombre, cargo, telefono: "", email };
    } else if (sel.modo === "ninguno") {
      elegido = null;
      marcaCliente = SIN_CONTACTO;
    } else {
      const c = contactosDe(cliente).find(x => String(x.idx) === String(sel.modo));
      if (c) { elegido = { nombre: c.nombre, cargo: c.cargo, telefono: c.telefono, email: c.email }; marcaCliente = c.idx; }
    }

    // La respuesta se recuerda como preferencia del cliente: la próxima
    // cotización abre esta ventana con la opción ya marcada.
    if (cliente && marcaCliente != null && cliente.contacto_imprimible !== marcaCliente) {
      saveData("clientes", (state.data.clientes || []).map(c =>
        c.id === cliente.id ? { ...c, contacto_imprimible: marcaCliente } : c));
    }

    f._contacto = elegido;
    f._contactoConfirmado = true;
    state._ctContacto = null;
    await ejecutarAccion("save-doc", state._ctFinalize ? { finalize: "1" } : {});
  }
});

registerActions({
  "new-doc": (d, el, e) => {showDocForm(d.tipo, null);
      return;},
  "edit-doc": (d, el, e) => {{
      const info = DOC_INFO[d.tipo];
      const doc = state.data[info.key].find(x => x.id === d.id);
      // OCP recibida: completamente bloqueada, no se puede reabrir
      if (d.tipo === "OCP" && doc && (doc.estado === "recibida" || ocpTotalmenteIngresada(doc))) {
        alert("🔒 Esta Orden de Compra ya fue completamente ingresada y procesada. No se permite ninguna modificación.");
        return;
      }
      if (doc && doc._locked) {
        showRevalidacionModal(d.tipo, d.id);
        return;
      }
      showDocForm(d.tipo, doc);
      return;
    }},
  "view-doc": (d, el, e) => {{
      const _vInfo = DOC_INFO[d.tipo];
      const _vDoc  = _vInfo && state.data[_vInfo.key] && state.data[_vInfo.key].find(x => x.id === d.id);
      if (!_vDoc) { alert("Documento no encontrado."); return; }
      renderDocViewModal(d.tipo, _vDoc);
      return;
    }},
  "edit-from-view": (d, el, e) => {{
      const _efInfo = DOC_INFO[d.tipo];
      const _efDoc  = _efInfo && state.data[_efInfo.key] && state.data[_efInfo.key].find(x => x.id === d.id);
      if (!_efDoc) return;
      state.modal = null;
      showDocForm(d.tipo, _efDoc);
      return;
    }},
  "solicitar-edicion-doc": (d, el, e) => {{
      // Desbloqueo con confirmación explícita (doc tiene hijos o está locked)
      const _seInfo = DOC_INFO[d.tipo];
      const _seDoc  = _seInfo && state.data[_seInfo.key] && state.data[_seInfo.key].find(x => x.id === d.id);
      if (!_seDoc) return;
      showRevalidacionModal(d.tipo, d.id);
      return;
    }},
  "revalidar-edicion": (d, el, e) => {{
      const info = DOC_INFO[d.tipo];
      const doc = state.data[info.key].find(x => x.id === d.id);
      if (!doc) return;
      // OCP recibida: bloqueo permanente, no se puede desbloquear
      if (d.tipo === "OCP" && (doc.estado === "recibida" || ocpTotalmenteIngresada(doc))) {
        state.modal = null;
        render();
        alert("🔒 Esta Orden de Compra está permanentemente bloqueada por haber sido completamente procesada. No se permite modificarla.");
        return;
      }
      // Para otros documentos: confirmar desbloqueo
      const updated = { ...doc, _locked: false };
      saveData(info.key, state.data[info.key].map(x => x.id === d.id ? updated : x));
      state.modal = null;
      showDocForm(d.tipo, updated);
      return;
    }},
  "delete-doc": (d, el, e) => {{
      // Obtener tipo e id del elemento
      const tipo = el.dataset.tipo;
      const docId = el.dataset.id;
      
      
      // Validar que tenemos los datos necesarios
      if (!tipo || !docId) {
        console.error("❌ Error: Faltan datos en botón delete (tipo=" + tipo + ", id=" + docId + ")");
        alert("❌ Error: No se puede eliminar. Intenta refrescar la página.");
        return;
      }
      
      // Buscar el documento
      const info = DOC_INFO[tipo];
      if (!info) {
        console.error("❌ Error: Tipo de documento desconocido: " + tipo);
        alert("❌ Error: Tipo de documento desconocido.");
        return;
      }
      
      
      const doc = state.data[info.key].find(x => x.id === docId);
      if (!doc) {
        console.error("❌ Error: Documento no encontrado (tipo=" + tipo + ", id=" + docId + ")");
        alert("❌ Error: Documento no encontrado.");
        return;
      }
      

      // Documentos financieros ya emitidos no se borran directo: se reversan con
      // Anular Factura/Anular NC (deja el registro contable trazado en vez de
      // desaparecer sin dejar rastro). Solo un borrador (nunca emitido/dataico)
      // puede eliminarse directamente.
      if ((tipo === "FACT" || tipo === "NC") && doc.estado !== "borrador") {
        alert(`⚠️ "${doc.numero}" ya fue emitido (estado: ${doc.estado}) y no se puede eliminar directamente.\n\nUsa la opción "Anular ${tipo === "FACT" ? "Factura" : "Nota Crédito"}" para reversarlo dejando el registro contable trazado.`);
        return;
      }

      // Mostrar confirmación
      showConfirmDelete(
        "⚠️ ELIMINAR DEFINITIVAMENTE",
        `<div style="color:${C.red};font-weight:700;margin-bottom:6px;">⚠️ Esta acción es irreversible</div>
         <div style="margin:10px 0;padding:10px;background:${C.red}15;border-left:3px solid ${C.red};border-radius:4px;">
           <div style="font-size:16px;font-weight:700;color:${C.text};margin-bottom:4px;">${escapeHTML(doc.numero)}</div>
           <div style="font-size:11.5px;color:${C.muted};">${fmtDate(doc.fecha)} • ${fmtCOP(doc.total)}</div>
           <div style="font-size:10.5px;color:${C.red};margin-top:6px;">Se eliminará permanentemente de la base de datos.</div>
         </div>`,
        () => {
          // Lo que este documento ya movió se reversa ANTES de borrarlo (o el
          // borrado se rechaza si no hay forma de deshacerlo).
          const motivo = prepararBorradoDoc(tipo, doc);
          if (motivo) { state.modal = null; alert("⚠️ " + motivo); render(); return; }
          // Eliminar el documento
          const eliminado = deleteData(info.key, docId);
          
          
          if (eliminado) {
            state.modal = null;
            alert("✅ " + info.label + " " + doc.numero + " eliminada permanentemente");
            render();
          } else {
            console.error("❌ No se pudo eliminar el documento");
            alert("❌ Error: No se pudo eliminar el documento. Por favor intenta de nuevo.");
          }
        }
      );
      return;
    }},
  "crear-cliente-rapido": (d) => {
    if (!state.editingDoc) return;
    state._crearClienteDraft = { nombre: d.nombre || "", nit: "", telefono: "", email: "", asesor_comercial: "", error: null };
    renderCrearClienteRapidoModal();
  },
  // ── Tercero NO registrado (se cotiza sin crear ficha) ──────────────────────
  "usar-cliente-libre": (d) => {
    if (!state.editingDoc) return;
    state._clienteLibreDraft = { nombre: d.nombre || "", nit: "", telefono: "", email: "", direccion: "", ciudad: "", error: null };
    renderClienteLibreModal();
  },
  "editar-cliente-libre": () => {
    if (!state.editingDoc || !esClienteLibre(state.editingDoc)) return;
    state._clienteLibreDraft = { ...state.editingDoc._clienteLibre, error: null };
    renderClienteLibreModal();
  },
  "quitar-cliente-libre": () => {
    if (!state.editingDoc) return;
    delete state.editingDoc._clienteLibre;
    state.editingDoc.cliente_id = "";
    state.editingDoc._contactoConfirmado = false;
    renderDocFormModal();
  },
  "cancelar-cliente-libre": () => {
    state._clienteLibreDraft = null;
    state.modal = null;
    renderDocFormModal();
  },
  "confirmar-cliente-libre": () => {
    const d = state._clienteLibreDraft;
    if (!d || !state.editingDoc) return;
    const nombre = (d.nombre || "").trim();
    if (!nombre) { d.error = "El nombre es obligatorio."; renderClienteLibreModal(); return; }
    // Si resulta que sí existe en Maestros, se usa la ficha real: mejor eso que
    // dejar un tercero libre duplicando un cliente que ya está registrado.
    const yaExiste = (state.data.clientes || []).find(c => normalize(c.nombre) === normalize(nombre));
    // Lo que haya precargado un cliente que coincidió de paso mientras se
    // escribía el nombre no es de este tercero.
    deshacerPrecarga(state.editingDoc, state._precargaCliente);
    state._precargaCliente = null;
    if (yaExiste) {
      delete state.editingDoc._clienteLibre;
      state.editingDoc.cliente_id = yaExiste.id;
      if (!state.editingDoc.id) state._precargaCliente = aplicarPrecarga(state.editingDoc, yaExiste, { esConversion: !!state.isConversion });
    } else {
      state.editingDoc.cliente_id = "";
      state.editingDoc._contactoConfirmado = false;
      // Un tercero no registrado no tiene ficha ni plazo pactado: se le cotiza
      // de CONTADO. Un plazo escrito a mano (no autogenerado) se respeta.
      if (!state.editingDoc.condiciones_pago || esPlazoAutogenerado(state.editingDoc.condiciones_pago)) {
        state.editingDoc.condiciones_pago = "Contado";
      }
      state.editingDoc._clienteLibre = {
        nombre,
        nit: (d.nit || "").trim(),
        telefono: (d.telefono || "").trim(),
        email: (d.email || "").trim().toLowerCase(),
        direccion: (d.direccion || "").trim(),
        ciudad: (d.ciudad || "").trim()
      };
    }
    state._clienteLibreDraft = null;
    state.modal = null;
    renderDocFormModal();
  },
  "elegir-escala": (d) => {
    if (!state._escalaSel) return;
    state._escalaSel.elegidas[parseInt(d.item)] = parseInt(d.esc);
    state._escalaSel.error = null;
    renderElegirEscalaModal();
  },
  "cancelar-elegir-escala": () => {
    state._escalaSel = null;
    state._escalasElegidas = null;
    state.modal = null;
    render();
  },
  "confirmar-elegir-escala": () => {
    const sel = state._escalaSel;
    if (!sel) return;
    const source = state.data[DOC_INFO[sel.fromTipo].key].find(x => x.id === sel.fromId);
    if (!source) { state._escalaSel = null; state.modal = null; render(); return; }
    // Cada ítem con escalas necesita su cantidad: si falta una, la orden saldría
    // con ese ítem en cero sin que nadie se dé cuenta.
    const faltan = (source.items || [])
      .map((it, i) => (tieneEscalas(it) && sel.elegidas[i] == null) ? (it.articulo || `ítem ${i + 1}`) : null)
      .filter(Boolean);
    if (faltan.length) {
      sel.error = "Falta elegir la cantidad de: " + faltan.join(", ");
      renderElegirEscalaModal();
      return;
    }
    state._escalasElegidas = { ...sel.elegidas, _para: sel.fromId + ">" + sel.toTipo };
    state._escalaSel = null;
    state.modal = null;
    convertDoc(sel.fromTipo, sel.toTipo, sel.fromId);
  },
  "cancelar-crear-cliente": () => {
    state._crearClienteDraft = null;
    state.modal = null;
    // Si venía de promover un tercero no registrado, no hay formulario abierto
    // al que volver: la conversión simplemente se cancela.
    if (state._clienteLibrePromover) { state._clienteLibrePromover = null; render(); return; }
    renderDocFormModal();
  },
  "confirmar-crear-cliente": () => {
    const d = state._crearClienteDraft;
    if (!d) return;
    const nombre = (d.nombre || "").trim();
    if (!nombre) { d.error = "El nombre es obligatorio."; renderCrearClienteRapidoModal(); return; }

    // Al promover un tercero no registrado no hay documento en edición: se
    // actualiza la cotización guardada y se retoma la conversión que la disparó.
    const prom = state._clienteLibrePromover;
    const asignar = (clienteId) => {
      if (prom) {
        const lista = state.data[DOC_INFO[prom.tipo].key] || [];
        const doc = lista.find(x => x.id === prom.id);
        if (doc) {
          doc.cliente_id = clienteId;
          delete doc._clienteLibre;
          saveData(DOC_INFO[prom.tipo].key, lista);
        }
        state._clienteLibrePromover = null;
        state._crearClienteDraft = null;
        state.modal = null;
        convertDoc(prom.tipo, prom.toTipo, prom.id);
        return;
      }
      state.editingDoc.cliente_id = clienteId;
      delete state.editingDoc._clienteLibre;
      state._crearClienteDraft = null;
      state.modal = null;
      renderDocFormModal();
    };

    const repetido = (state.data.clientes || []).find(c => normalize(c.nombre) === normalize(nombre));
    if (repetido) {
      // Ya existe: en vez de duplicarlo, se usa el existente.
      asignar(repetido.id);
      return;
    }
    const cliente = {
      id: genId(),
      nombre,
      nit: (d.nit || "").trim(),
      telefono: (d.telefono || "").trim(),
      email: (d.email || "").trim().toLowerCase(),
      asesor_comercial: d.asesor_comercial || ""
    };
    state.data.clientes = [...(state.data.clientes || []), cliente];
    saveData("clientes", state.data.clientes);
    asignar(cliente.id);
  },
  "crear-producto-desde-item": (d, el, e) => {{
      const idx = parseInt(d.idx);
      const it = state.editingDoc.items[idx];
      if (!it || !it.articulo || !it.articulo.trim()) { alert("⚠️ Escribe el nombre del artículo antes de crear el producto."); return; }
      if ((state.data.productos||[]).some(p => p.nombre === it.articulo)) { alert("Ya existe un producto con ese nombre en el catálogo."); return; }
      const costo = parseNumber(it._costoManual) || 0;
      const margen = parseNumber(it._margenManual) || 0;
      if (costo <= 0) { alert("⚠️ Escribe el costo del producto antes de crearlo."); return; }
      if (margen <= 0 || margen >= 100) { alert("⚠️ Escribe un margen de utilidad válido (entre 1% y 99%) antes de crearlo."); return; }
      state._crearProductoDraft = {
        itemIdx: idx,
        nombre: it.articulo,
        referencia: it.referencia || "",
        categoria: it.descripcion || "",
        unidad: "Unidad",
        costo, margen,
        precio_venta: calcPrecioManualItem(it),
        imagen: null
      };
      renderConfirmarCrearProductoModal();
      return;
    }},
  "cancelar-crear-producto": (d, el, e) => {state._crearProductoDraft = null;
      state.modal = null;
      renderDocFormModal();
      return;},
  "confirmar-crear-producto": async (d, el, e) => {{
      const draft = state._crearProductoDraft;
      if (!draft) return;
      if (!draft.imagen) { alert("⚠️ Debes cargar una imagen del producto antes de crearlo."); return; }
      const nuevoProducto = {
        id: genId(),
        nombre: draft.nombre,
        referencia: draft.referencia,
        categoria: draft.categoria,
        unidad: draft.unidad,
        costo: draft.costo,
        margen: draft.margen,
        precio_venta: draft.precio_venta,
        _costo_fecha: today(),
        // Mismo código interno que por Maestros: el catálogo es uno solo.
        codigo_interno: siguienteCodigoProducto(state.data.productos || []),
        imagen: draft.imagen
      };
      // La foto al bucket antes de guardar: la ficha solo lleva la ruta.
      Object.assign(nuevoProducto, await persistirImagenProducto(nuevoProducto));
      saveData("productos", [...(state.data.productos||[]), nuevoProducto]);
      // La referencia que se acaba de definir baja a la línea de la cotización:
      // si no, el producto quedaría con referencia y la línea sin ella.
      const itLinea = state.editingDoc && state.editingDoc.items && state.editingDoc.items[draft.itemIdx];
      if (itLinea && nuevoProducto.referencia) itLinea.referencia = nuevoProducto.referencia;
      state._crearProductoDraft = null;
      state.modal = null;
      renderDocFormModal();
      alert("✅ Producto \"" + nuevoProducto.nombre + "\" creado correctamente en el catálogo.");
      return;
    }},
  "ocp-asociar-op": (d, el) => {
    if (!state.editingDoc || !el) return;
    if (!el.value) { delete state.editingDoc._origen; return; }
    const op = (state.data.pedidos || []).find(p => p.id === el.value);
    if (op) state.editingDoc._origen = { tipo: "OP", id: op.id, numero: op.numero, fecha: op.fecha };
  },
  "add-costo-linea": (d) => {
    const it = state.editingDoc.items[parseInt(d.idx)];
    if (!it) return;
    if (!it._costosLinea) it._costosLinea = [];
    it._costosLinea.push({ concepto: "", proveedor_nombre: "", cantidad: 1, valor_tercero: "" });
    renderDocFormModal();
  },
  "remove-costo-linea": (d) => {
    const it = state.editingDoc.items[parseInt(d.idx)];
    if (!it || !it._costosLinea) return;
    it._costosLinea.splice(parseInt(d.sub), 1);
    renderDocFormModal();
  },
  "add-escala": (d) => {
    const it = state.editingDoc.items[parseInt(d.idx)];
    if (!it) return;
    if (!Array.isArray(it._escalas)) it._escalas = [];
    // La primera escala hereda la cantidad y el precio que ya tuviera la línea,
    // para no perder el trabajo hecho; se agrega una segunda en blanco porque
    // cotizar "por cantidades" con una sola cantidad no tiene sentido.
    if (it._escalas.length === 0) {
      it._escalas.push({ cantidad: it.cantidad || "", precio_unitario: it.precio_unitario || "", margen: "" });
    }
    it._escalas.push({ cantidad: "", precio_unitario: "", margen: "" });
    renderDocFormModal();
  },
  "remove-escala": (d) => {
    const it = state.editingDoc.items[parseInt(d.idx)];
    if (!it || !Array.isArray(it._escalas)) return;
    it._escalas.splice(parseInt(d.sub), 1);
    renderDocFormModal();
  },
  "print-doc": async (d, el, e) => { await exportPDF(d.tipo, d.id); return; },
  "convert-doc": (d, el, e) => {convertDoc(d.from, d.to, d.id);
      return;},
  "convert-op-multi-ocp": (d, el, e) => {showConvertOpMultiOcp(d.id);
      return;},
  "generar-grupos-ocp": (d, el, e) => {{
      if (!state.multiOcp) return;
      let n = parseInt(state.multiOcp.numGruposDeseado, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 20) n = 20;
      const grupos = state.multiOcp.grupos;
      const existentes = Object.keys(grupos).map(Number);
      const maxActual = existentes.length ? Math.max(...existentes) : 0;
      // Agregar grupos faltantes
      for (let i = maxActual + 1; i <= n; i++) grupos[String(i)] = { proveedor_nombre:"", proveedor_id:"" };
      // Eliminar grupos sobrantes (por encima de n) y reasignar sus ítems al grupo 1
      Object.keys(grupos).map(Number).filter(g => g > n).forEach(g => {
        delete grupos[String(g)];
        state.multiOcp.items.forEach(it => { if (String(it.grupo) === String(g)) it.grupo = "1"; });
      });
      state.multiOcp.numGruposDeseado = n;
      renderMultiOcpModal();
      return;
    }},
  "add-grupo-ocp": (d, el, e) => {{
      if (!state.multiOcp) return;
      const keys = Object.keys(state.multiOcp.grupos).map(Number);
      const next = (keys.length ? Math.max(...keys) : 0) + 1;
      state.multiOcp.grupos[String(next)] = { proveedor_nombre:"", proveedor_id:"" };
      renderMultiOcpModal();
      return;
    }},
  "remove-grupo-ocp": (d, el, e) => {{
      if (!state.multiOcp) return;
      const g = d.grupo;
      if (g === "1") return; // siempre debe existir al menos el grupo 1
      delete state.multiOcp.grupos[g];
      state.multiOcp.items.forEach(it => { if (String(it.grupo) === g) it.grupo = "1"; });
      renderMultiOcpModal();
      return;
    }},
  "confirmar-multi-ocp": async (d, el, e) => {{
      const mo = state.multiOcp;
      if (!mo) return;
      const op = state.data.pedidos.find(p => p.id === mo.opId);
      if (!op) return;

      // Agrupar ítems por grupo
      const gruposUsados = {};
      mo.items.forEach(it => {
        const g = String(it.grupo || "1");
        if (!gruposUsados[g]) gruposUsados[g] = [];
        gruposUsados[g].push(it);
      });

      // Validar que cada grupo usado tenga proveedor asignado
      for (const g of Object.keys(gruposUsados)) {
        const grupo = mo.grupos[g];
        if (!grupo || !grupo.proveedor_nombre || !grupo.proveedor_nombre.trim()) {
          alert(`⚠️ Asigna un proveedor al Grupo OCP ${g}`);
          return;
        }
      }

      let proveedores = [...state.data.proveedores];
      let ocpList = [...state.data.ocp];
      const nuevasOcp = [];

      for (const g of Object.keys(gruposUsados).sort((a,b) => Number(a) - Number(b))) {
        const grupo = mo.grupos[g];
        const nombreProv = grupo.proveedor_nombre.trim();
        let prov = proveedores.find(p => normalize(p.nombre) === normalize(nombreProv));
        if (!prov) {
          prov = { id: genId(), nombre: nombreProv, nit:"", telefono:"", email:"", direccion:"", dias_pago: 30 };
          proveedores = [...proveedores, prov];
        }

        const items = gruposUsados[g].map(it => {
          const cantidad = parseNumber(it.cantidad);
          const precio_unitario = parseNumber(it.costo);
          return {
            articulo: it.articulo, descripcion: it.descripcion,
            color:"", logo:"", impresion:"", ubicacion:"",
            cantidad, precio_unitario, total: cantidad * precio_unitario
          };
        });
        const subtotal = items.reduce((s,it) => s + it.total, 0);
        // Lo que el proveedor va a cobrar: si el bien es excluido o exento no
        // lleva IVA, así que la orden de compra tampoco puede llevarlo.
        const iva = desgloseIVA(items).iva;
        const total = subtotal + iva;

        const nuevaOcp = {
          id: genId(),
          numero: await siguienteNumeroDoc("OCP"),
          fecha: today(),
          proveedor_id: prov.id,
          items, subtotal, iva, total,
          estado: "borrador",
          estado_pago: "por_pagar",
          _origen: { tipo:"OP", id: op.id, numero: op.numero, fecha: op.fecha }
        };
        sellarAutor(nuevaOcp);   // no pasa por save-doc: se sella aquí
        ocpList = [...ocpList, nuevaOcp];
        nuevasOcp.push(nuevaOcp);
      }

      saveData("proveedores", proveedores);
      saveData("ocp", ocpList);

      // Registrar enlaces en la OP (sin bloquearla ni cambiar su estado)
      const prevLinks = getConvertedToList(op);
      const newLinks = nuevasOcp.map(o => ({ tipo:"OCP", id:o.id, numero:o.numero, fecha:new Date().toISOString() }));
      saveData("pedidos", state.data.pedidos.map(p => p.id === op.id ? { ...p, _convertedTo: [...prevLinks, ...newLinks] } : p));

      state.multiOcp = null;
      state.modal = null;
      render();
      alert(`✅ Se ${nuevasOcp.length === 1 ? "creó 1 Orden de Compra" : "crearon " + nuevasOcp.length + " Órdenes de Compra"} desde ${op.numero}`);
      return;
    }},
  // Un solo desplegable de trazabilidad abierto a la vez: la lista se lee
  // mejor así, y volver a pulsarlo lo cierra.
  "toggle-traza": (d, el, e) => {{
      const clave = `${d.tipo}:${d.id}`;
      state.trazaAbierta = state.trazaAbierta === clave ? null : clave;
      render();
      return;
    }},
  "op-pestana": (d) => { state.opPestana = d.pestana || "todas"; render(); },
  "toggle-doc-filters": (d, el, e) => {{
      if (!state.docFiltersOpen) state.docFiltersOpen = {};
      state.docFiltersOpen[d.tipo] = !state.docFiltersOpen[d.tipo];
      render();
      return;
    }},
  "limpiar-doc-filtros": (d, el, e) => {{
      if (state.docFilters && state.docFilters[d.tipo]) {
        state.docFilters[d.tipo] = { estado:"", desde:"", hasta:"", tercero:"" };
      }
      render();
      return;
    }},
  "ver-documento-detalle": (d, el, e) => {{
      const tipo = d.tipo;
      const docId = d.id;
      const numero = d.numero;
      
      if (tipo === "CT") {
        const doc = state.data.cotizaciones.find(c => c.id === docId);
        if (doc) alert(`📄 COTIZACIÓN\n\nNúmero: ${doc.numero}\nFecha: ${fmtDate(doc.fecha)}\n\n⚠️ Vista de documento será implementada cuando tengamos repositorio`);
      } else if (tipo === "OP") {
        const doc = state.data.pedidos.find(o => o.id === docId);
        if (doc) alert(`📋 ORDEN DE PRODUCCIÓN\n\nNúmero: ${doc.numero}\nFecha: ${fmtDate(doc.fecha)}\n\n⚠️ Vista de documento será implementada cuando tengamos repositorio`);
      } else if (tipo === "RC") {
        const doc = state.data.remisiones.find(r => r.id === docId);
        if (doc) alert(`📮 REMISIÓN\n\nNúmero: ${doc.numero}\nFecha: ${fmtDate(doc.fecha)}\n\n⚠️ Vista de documento será implementada cuando tengamos repositorio`);
      } else if (tipo === "FACT") {
        if (docId) {
          showVerFactura(docId);
        } else {
          const fFound = (state.data.facturas||[]).find(f=>f.numero===numero);
          if (fFound) showVerFactura(fFound.id);
          else alert(`💰 FACTURA\n\nNúmero: ${numero}\n\nNo encontrada en el sistema.`);
        }
      }
      return;
    }},
  "duplicate-doc": async (d, el, e) => {{
      const info2 = DOC_INFO[d.tipo];
      const list = state.data[info2.key] || [];
      const source = list.find(x => x.id === d.id);
      if (!source) return;

      // Determinar numero base (sin sufijo -vN) y siguiente versión (atómico, del servidor)
      const baseMatch = (source.numero || "").match(/^(.*)-v(\d+)$/i);
      const baseNumero = baseMatch ? baseMatch[1] : source.numero;

      let nextVersion;
      try {
        nextVersion = await siguienteNumeroRaw(baseNumero);
      } catch (err) {
        alert("⚠️ " + err.message);
        return;
      }
      // La cotización original (sin sufijo) ES la versión 1: el primer
      // duplicado debe salir como v2. El contador del prefijo base arranca
      // en 1 la primera vez que se duplica, por eso se corre en +1.
      const nuevoNumero = `${baseNumero}-v${nextVersion + 1}`;

      const duplicado = {
        ...JSON.parse(JSON.stringify(source)),
        id: genId(),
        numero: nuevoNumero,
        fecha: today(),
        estado: "completada"
      };
      delete duplicado._origen;
      delete duplicado._convertedTo;
      delete duplicado._locked;

      state.editingDoc = duplicado;
      state.editingTipo = d.tipo;
      state.isConversion = false;
      renderDocFormModal();
      return;
    }},
  "ir-a-documento": (d, el, e) => {{
      // Limpiar búsqueda global al navegar a un resultado
      state.globalSearch = "";
      const tipo = d.tipo;
      const docId = d.id;
      if (tipo === "FACT") {
        state.page = "FACT";
        state.modal = null;
        showVerFactura(docId);
        return;
      }
      const info2 = DOC_INFO[tipo];
      if (!info2) return;
      const doc = (state.data[info2.key] || []).find(x => x.id === docId);
      if (!doc) { alert("El documento ya no existe."); return; }
      state.page = tipo;
      if (doc._locked) {
        showRevalidacionModal(tipo, docId);
      } else {
        showDocForm(tipo, doc);
      }
      return;
    }},
  "add-item": (d, el, e) => {{
      const tipo = state.editingTipo;
      const newItem = tipo === "RC"
        ? { articulo:"", descripcion:"", referencia:"", cantidad:"", bolsas:"1", observaciones:"" }
        : { articulo:"", descripcion:"", referencia:"", color:"", logo:"", impresion:"", cantidad:"", precio_unitario:"", total:0 };
      if (tipo === "OCP") newItem.ubicacion = "";
      else if (tipo !== "RC") newItem.tinta = "";
      state.editingDoc.items = [...(state.editingDoc.items||[]), newItem];
      renderDocFormModal();
      return;
    }},
  "remove-item": (d, el, e) => {state.editingDoc.items.splice(parseInt(d.idx), 1);
      renderDocFormModal();
      return;},
  // Subir/bajar un ítem: alternativa al arrastre (y la única en pantallas
  // táctiles, donde el arrastre nativo del navegador no responde).
  "mover-item": (d) => {
    const items = state.editingDoc && state.editingDoc.items;
    const i = parseInt(d.idx);
    const j = i + parseInt(d.dir);
    if (!items || j < 0 || j >= items.length) return;
    [items[i], items[j]] = [items[j], items[i]];
    renderDocFormModal();
  },
  "add-entrega-op": (d, el, e) => {{
      if (!state.editingDoc._entregas) state.editingDoc._entregas = [];
      state.editingDoc._entregas.push({ fecha:"", nota:"" });
      renderDocFormModal();
      return;
    }},
  "remove-entrega-op": (d, el, e) => {{
      state.editingDoc._entregas.splice(parseInt(d.idx), 1);
      renderDocFormModal();
      return;
    }},
  "desc-fin-add": (d, el, e) => {{
      if (!state.editingMaestro) return;
      if (!Array.isArray(state.editingMaestro.descuentos_financieros)) state.editingMaestro.descuentos_financieros = [];
      state.editingMaestro.descuentos_financieros.push({medio:"transferencia",pct:0,dias:0});
      renderMaestroFormModal();
      return;
    }},
  "desc-fin-remove": (d, el, e) => {{
      if (!state.editingMaestro||!Array.isArray(state.editingMaestro.descuentos_financieros)) return;
      state.editingMaestro.descuentos_financieros.splice(parseInt(d.idx),1);
      renderMaestroFormModal();
      return;
    }},
  "add-contacto-cliente": (d, el, e) => {{
      if (!state.editingMaestro._contactos) state.editingMaestro._contactos = [];
      state.editingMaestro._contactos.push({ nombre:"", cargo:"", telefono:"", email:"" });
      renderMaestroFormModal();
      return;
    }},
  "remove-contacto-cliente": (d, el, e) => {{
      state.editingMaestro._contactos.splice(parseInt(d.idx), 1);
      renderMaestroFormModal();
      return;
    }},
  "agregar-documento-op": (d, el, e) => {{
      const fileInput = document.getElementById("upload-doc-op");
      if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
        alert("Selecciona un archivo");
        return;
      }
      const file = fileInput.files[0];
      const tipos = ["application/pdf", "image/jpeg", "image/jpg", "image/png"];
      if (!tipos.includes(file.type)) {
        alert("Solo se permite PDF, JPG o PNG");
        return;
      }
      if (!state.editingDoc._documentos) state.editingDoc._documentos = [];
      
      // Crear documento
      const doc = {
        id: genId(),
        nombre: file.name,
        tipo: file.type.includes("pdf") ? "pdf" : "imagen",
        tamaño: file.size,
        fechaCarga: today()
      };
      state.editingDoc._documentos.push(doc);
      fileInput.value = "";
      renderDocFormModal();
      alert(`✅ Documento "${file.name}" agregado.\n\n⚠️ Se guardará cuando se implemente el repositorio`);
      return;
    }},
  "eliminar-documento-op": (d, el, e) => {{
      if (!state.editingDoc._documentos) return;
      const idx = parseInt(d.idx);
      state.editingDoc._documentos.splice(idx, 1);
      renderDocFormModal();
      return;
    }},
  "save-doc": async (d, el, e) => {{
      cancelarAutoguardado();   // el guardado manual manda: nada pendiente detrás
      const f = state.editingDoc;
      const tipo = state.editingTipo;
      const info = DOC_INFO[tipo];
      const isOCP = tipo === "OCP";
      const isRC = tipo === "RC";
      
      // Validar cliente/proveedor
      // Un tercero NO registrado (solo cotizaciones) es cliente válido: lleva
      // sus datos encima del documento en vez de una ficha de Maestros.
      if (!isOCP && !isRC && !f.cliente_id && !esClienteLibre(f)) {
        alert("⚠️ OBLIGATORIO: Selecciona un cliente válido de la lista");
        return;
      }
      if (isOCP && !f.proveedor_id) { 
        alert("⚠️ OBLIGATORIO: Selecciona un proveedor válido de la lista"); 
        return; 
      }
      
      if (isRC && !f._origen) { 
        alert("⚠️ OBLIGATORIO: Selecciona una Orden de Producción para mantener trazabilidad"); 
        return; 
      }
      
      if (!f.items || f.items.length === 0) {
        alert("Agrega al menos un ítem");
        return;
      }

      // Flujo piloto (fase 4): la remisión que se arma desde el pedido trae el
      // tope de cada renglón —lo que el piloto le asignó en bodega a ESE pedido
      // (lo apartado más lo libre que le toca)—. Pasarse se rechaza, no se
      // recorta: sería despachar mercancía apartada para otro pedido. No viaja
      // a la nube (no tiene columna): vive solo mientras se edita.
      if (isRC && f._topesPiloto) {
        const excede = (f.items || []).filter(it => {
          const tope = f._topesPiloto[normalize(it.articulo || "")];
          return tope != null && (parseNumber(it.cantidad) || 0) > tope + 1e-9;
        });
        if (excede.length) {
          alert("⚠️ Esta remisión nació del flujo piloto y no puede despachar más de lo asignado al pedido:\n\n" +
            excede.map(it => `• ${it.articulo}: ${parseNumber(it.cantidad) || 0} pedidos, máximo ${f._topesPiloto[normalize(it.articulo || "")]}`).join("\n"));
          return;
        }
      }

      // El tiempo de entrega es lo primero que pregunta un cliente al recibir
      // una cotización: no se emite ninguna sin él.
      if (tipo === "CT" && !(Number(f.tiempo_entrega) > 0)) {
        alert("⚠️ OBLIGATORIO: indica el tiempo de entrega en días hábiles.");
        return;
      }

      // Cierre contable: no se puede crear ni editar una factura/NC con fecha
      // dentro de un periodo ya cerrado.
      if ((tipo === "FACT" || tipo === "NC") && fechaEstaCerrada(f.fecha)) {
        alert(`⚠️ No se puede guardar: el periodo contable hasta ${fmtDate(fechaCierreVigente())} ya está cerrado.`);
        return;
      }

      // Validar que las cantidades de la RC no superen lo disponible en la OP de origen
      if (isRC && f._origen && f._origen.tipo === "OP") {
        const op = state.data.pedidos.find(p => p.id === f._origen.id);
        if (op) {
          for (const it of f.items) {
            const cantidad = parseNumber(it.cantidad);
            if (cantidad <= 0) continue;
            const opItem = (op.items||[]).find(oi => oi.articulo === it.articulo);
            if (!opItem) continue; // ítem agregado manualmente, sin control de disponibilidad
            const cantOP = parseNumber(opItem.cantidad);
            const remisionadoOtras = getCantidadRemisionadaOP(op.id, it.articulo, f.id || null);
            const disponible = cantOP - remisionadoOtras;
            if (cantidad > disponible + 0.001) {
              alert(`⚠️ "${it.articulo}": solo hay ${disponible} unidad${disponible!==1?"es":""} disponible${disponible!==1?"s":""} para remisionar (OP: ${cantOP}, ya remisionado: ${remisionadoOtras}).`);
              return;
            }
          }
        }
      }

      // Pregunta obligatoria de la cotización: ¿a quién va dirigida? Se hace
      // DESPUÉS de las demás validaciones, para no preguntar por el contacto y
      // reprochar a continuación que falten ítems. El guardado se detiene aquí y
      // lo reanuda "ct-contacto-confirmar" con la respuesta ya puesta.
      if (tipo === "CT" && !f._contactoConfirmado) {
        // clienteDeDoc cubre también al tercero no registrado: devuelve un
        // objeto con la misma forma (sin contactos), así la ventana ofrece
        // "escribir otra persona" y el guardado no se queda atascado.
        const cli = clienteDeDoc(f);
        const yaElegido = f._contacto && f._contacto.nombre
          ? contactosDe(cli).find(c => c.nombre === f._contacto.nombre)
          : null;
        const porDefecto = yaElegido || contactoImprimible(cli);
        state._ctContacto = {
          modo: porDefecto ? String(porDefecto.idx)
            : (cli && cli.contacto_imprimible === SIN_CONTACTO ? "ninguno" : "")
        };
        state._ctFinalize = !!d.finalize;
        pedirContactoCT();
        return;
      }

      // Normalizar números de los ítems al guardar
      const normalizedItems = f.items.map(it => {
        const cantidad = parseNumber(it.cantidad);
        const precio = parseNumber(it.precio_unitario);
        const bolsas = parseNumber(it.bolsas) || 1;
        return {
          ...it,
          // El nombre del artículo es la llave con la que el documento encuentra
          // su producto y su ficha de inventario. Un espacio de más al final
          // ("Set de memos ") lo convierte en otro artículo distinto, y aparecen
          // fichas duplicadas y stock que no se encuentra a sí mismo.
          articulo: typeof it.articulo === "string" ? it.articulo.trim() : it.articulo,
          cantidad,
          precio_unitario: isRC ? 0 : precio,
          total: isRC ? 0 : cantidad * precio,
          bolsas: isRC ? bolsas : undefined
        };
      });

      // Igual que en el formulario: un ítem con escalas de cantidad no aporta
      // al total, porque su cantidad la define el cliente al aceptar.
      const subtotal = normalizedItems.filter(aportaATotales).reduce((s, it) => s + (it.total || 0), 0);
      const iva = isRC ? 0 : desgloseIVA(normalizedItems.filter(aportaATotales)).iva;
      const total = subtotal + iva;

      const finalize = d.finalize === "1";
      const estadoFinal = finalize ? "completada" : (f.estado || "borrador");

      const list = state.data[info.key] || [];
      let numeroFinal;
      try {
        numeroFinal = f.numero && f.numero !== "(automático)" ? f.numero : await siguienteNumeroDoc(info.prefix);
      } catch (err) {
        alert("⚠️ " + err.message);
        return;
      }
      const final = {
        ...f,
        items: normalizedItems,
        id: f.id || genId(),
        numero: numeroFinal,
        subtotal, iva, total,
        estado: estadoFinal
      };
      delete final._subtotal; delete final._iva; delete final._total;

      // `_contactoConfirmado` SÍ se persiste (columna contacto_confirmado): la
      // pregunta "¿a quién va dirigida?" se responde una vez por cotización.
      // Si no se guardara, cada edición posterior la volvería a pedir aunque ya
      // estuviera contestada. Se reinicia sola si se cambia de cliente.
      delete final._contacto_idx;

      sellarAutor(final);   // quién creó el documento (ver core/autoria.js)

      // Un documento que queda en borrador es trabajo a medias: entra en la
      // lista de pendientes desde ya, sin esperar al próximo inicio de sesión.
      if (final.estado === "borrador") registrarPendiente(tipo, final.id);

      const exists = list.find(x => x.id === final.id);

      // ─── Costos asociados (OP): a OCP, a CxP directa, o preguntar ───
      if (tipo === "OP") {
        (final._conceptosCosto || []).forEach(c => {
          if (!c._ccid) c._ccid = genId();
          // Conceptos anteriores a la elección de destino: lo que ya tenía OCP
          // sigue siendo OCP; lo que ya tenía CxP sigue siendo CxP.
          if (!c._via && c._ocpId) c._via = "ocp";
          else if (!c._via && c._cxpId) c._via = "cxp";
        });
        await sincronizarOcpDeCostos(final);
        await sincronizarCxpDirectasOP(final);
      }

      // ─── Los efectos del estado se aplican SIEMPRE, venga por donde venga ───
      // Un documento puede quedar en su estado final por dos caminos: cambiando
      // el estado desde la lista, o con el botón "Completar" del propio
      // formulario. El primero aplicaba los efectos (descontar el inventario de
      // una remisión, el asiento de una factura) y el segundo no, así que una
      // remisión completada desde aquí dejaba la mercancía dentro de la bodega
      // y el ERP seguía ofreciendo un stock que ya se había despachado.
      // Ahora los dos caminos pasan por la misma puerta. Cada efecto lleva su
      // propia guarda (_inventarioDescontado, _asientoVenta…), así que volver a
      // guardar el documento no lo repite.
      if (final.estado !== (exists ? exists.estado : null)) {
        try {
          await aplicarCambioEstadoDoc(tipo, final, final.estado);
        } catch (err) {
          alert("⚠️ No se pudo aplicar el cambio de estado: " + (err.message || err));
          return;
        }
      }

      saveData(info.key, exists ? list.map(x => x.id === final.id ? final : x) : [...list, final]);

      // Asociación OCP ↔ OP: se administra aparte de la ruta genérica de abajo por
      // dos razones. Cubre la REasociación al editar (la compra de urgencia se
      // puede colgar de la OP después de creada, o moverse de OP), y NO bloquea
      // la OP: una OP genera varias OCP y debe seguir editable — el mismo
      // criterio de la conversión múltiple.
      if (tipo === "OCP" && !final._fromCosto) {
        const prevOrigenId = (exists && exists._origen && exists._origen.tipo === "OP") ? exists._origen.id : null;
        const newOrigenId = (final._origen && final._origen.tipo === "OP") ? final._origen.id : null;
        if (prevOrigenId !== newOrigenId) {
          saveData("pedidos", (state.data.pedidos || []).map(p => {
            if (p.id === prevOrigenId) {
              return { ...p, _convertedTo: getConvertedToList(p).filter(l => !(l.tipo === "OCP" && l.id === final.id)) };
            }
            if (p.id === newOrigenId) {
              const links = getConvertedToList(p).filter(l => !(l.tipo === "OCP" && l.id === final.id));
              return { ...p, _convertedTo: [...links, { tipo: "OCP", id: final.id, numero: final.numero, fecha: new Date().toISOString() }] };
            }
            return p;
          }));
        }
      }

      // Si este documento proviene de una conversión, registrar el enlace en el origen
      // (esto SOLO ocurre si el documento se guardó exitosamente, no si se canceló)
      if (f._origen && !exists && tipo !== "OCP") {
        const origInfo = DOC_INFO[f._origen.tipo];
        if (origInfo) {
          const origList = state.data[origInfo.key] || [];
          saveData(origInfo.key, origList.map(o => {
            if (o.id !== f._origen.id) return o;
            const prevLinks = getConvertedToList(o);
            const updated = {
              ...o,
              _convertedTo: [...prevLinks, { tipo, id: final.id, numero: final.numero, fecha: new Date().toISOString() }],
              _locked: true   // bloqueado: este doc generó un hijo
            };
            // Solo CT→OP es 1:1: se bloquea la CT origen. OP puede generar varias OCP y RS.
            if (f._origen.tipo === "CT") {
              updated.estado = "convertida";
              updated._locked = true;
            }
            return updated;
          }));
        }
      }

      state.modal = null;
      state.editingDoc = null;
      state.isConversion = false;
      render();
      // Si la OP trae costos sin destino confirmado, preguntar AHORA (con la
      // sugerencia aprendida preseleccionada): nada se convierte a ciegas.
      if (tipo === "OP") pedirDestinoCostos(final);
      return;
    }},
  "destino-costos-confirmar": async (d, el, e) => {{
      const dc = state._destinoCostos;
      if (!dc) return;
      const op = (state.data.pedidos || []).find(p => p.id === dc.opId);
      if (!op) { state._destinoCostos = null; state.modal = null; render(); return; }
      let aOcp = 0, aCxp = 0;
      (op._conceptosCosto || []).forEach(c => {
        if (!dc.ccids.includes(c._ccid)) return;
        const via = dc.sel[c._ccid] || "ocp";
        c._via = via;
        // La segunda respuesta solo tiene sentido en una orden de compra: es la
        // única vía que causa IVA. Si el destino cambió a otra cosa, se borra
        // para que no quede una respuesta colgando de una pregunta que ya no está.
        if (via === "cxp") c._ocpAdemas = (dc.selOcp || {})[c._ccid] || "";
        else delete c._ocpAdemas;
        if (via !== "nada") { aprenderVia(c.concepto, via); if (via === "ocp") aOcp++; else aCxp++; }
      });
      await sincronizarOcpDeCostos(op);
      await sincronizarCxpDirectasOP(op);
      saveData("pedidos", state.data.pedidos.map(p => p.id === op.id ? op : p));
      state._destinoCostos = null;
      state.modal = null;
      render();
      const partes = [];
      if (aOcp) partes.push(`${aOcp} orden${aOcp === 1 ? "" : "es"} de compra`);
      if (aCxp) partes.push(`${aCxp} cuenta${aCxp === 1 ? "" : "s"} por pagar directa${aCxp === 1 ? "" : "s"} (Db 6140 costo / Cr 2365 retención / Cr 2315 el neto por pagar)`);
      alert(partes.length
        ? "✅ Destinos aplicados: " + partes.join(" y ") + ".\n\nEl sistema recordará estas decisiones para sugerirlas la próxima vez."
        : "Listo — ningún costo genera documento.");
      return;
    }},
  "destino-costos-despues": (d, el, e) => {{
      // Sin decisión no se genera nada; al volver a guardar la OP se pregunta de nuevo.
      state._destinoCostos = null;
      state.modal = null;
      render();
      return;
    }},
  "remove-producto-imagen": (d, el, e) => {{
      if (state.editingMaestro) delete state.editingMaestro.imagen;
      renderMaestroFormModal();
      return;
    }},
  "toggle-doc-checkbox": (d, el, e) => {{
      const tipo = d.tipo;
      const docId = d.id;
      if (!state.selectedDocs[tipo]) state.selectedDocs[tipo] = {};
      if (state.selectedDocs[tipo][docId]) {
        delete state.selectedDocs[tipo][docId];
      } else {
        state.selectedDocs[tipo][docId] = true;
      }
      render();
      return;
    }},
  "toggle-all-checkboxes": (d, el, e) => {{
      const tipo = d.tipo;
      const info = DOC_INFO[tipo];
      const allDocs = state.data[info.key] || [];
      if (!state.selectedDocs[tipo]) state.selectedDocs[tipo] = {};
      const checkbox = e.target.closest("input[type='checkbox']") || e.target;
      const isChecked = checkbox.checked !== undefined ? checkbox.checked : Object.keys(state.selectedDocs[tipo] || {}).length < allDocs.length;
      if (isChecked) {
        allDocs.forEach(doc => { state.selectedDocs[tipo][doc.id] = true; });
      } else {
        state.selectedDocs[tipo] = {};
      }
      render();
      return;
    }},
  "deselect-all": (d, el, e) => {{
      const tipo = d.tipo;
      state.selectedDocs[tipo] = {};
      render();
      return;
    }},
  "bulk-delete-doc": (d, el, e) => {{
      const tipo = d.tipo;
      if (state.usuarioRol && state.usuarioRol !== "admin") { alert("⚠️ Solo un administrador puede eliminar documentos en lote."); return; }
      const selected = Object.keys(state.selectedDocs[tipo] || {});
      if (selected.length === 0) { alert("Selecciona al menos un documento"); return; }
      const info = DOC_INFO[tipo];
      const allDocs = state.data[info.key] || [];
      const docsSel = allDocs.filter(x => selected.includes(x.id));
      if (docsSel.length === 0) { alert("Los documentos seleccionados ya no existen."); state.selectedDocs[tipo] = {}; render(); return; }
      const listado = docsSel.slice(0, 8).map(x => escapeHTML(x.numero || x.id)).join(", ")
        + (docsSel.length > 8 ? ` y ${docsSel.length - 8} más` : "");
      showConfirmDelete(
        `⚠️ ELIMINAR ${docsSel.length} DOCUMENTO${docsSel.length !== 1 ? "S" : ""}`,
        `<div style="color:${C.red};font-weight:700;margin-bottom:6px;">⚠️ Esta acción es irreversible</div>
         <div style="margin:10px 0;padding:10px;background:${C.red}15;border-left:3px solid ${C.red};border-radius:4px;">
           <div style="font-size:12px;font-weight:700;color:${C.text};margin-bottom:4px;">${listado}</div>
           <div style="font-size:10.5px;color:${C.red};margin-top:6px;">Se eliminarán permanentemente de la base de datos.</div>
         </div>`,
        () => {
          // Uno por uno: cada documento reversa lo que movió, y el que no se
          // puede borrar se queda con su motivo a la vista.
          const rechazados = [];
          const borrables = docsSel.filter(x => {
            const motivo = prepararBorradoDoc(tipo, x);
            if (motivo) { rechazados.push(motivo); return false; }
            return true;
          });
          const idsSel = new Set(borrables.map(x => x.id));
          if (idsSel.size) saveData(info.key, allDocs.filter(x => !idsSel.has(x.id)));
          state.selectedDocs[tipo] = {};
          state.modal = null;
          if (rechazados.length) alert("⚠️ No se eliminaron:\n\n" + rechazados.join("\n\n"));
          if (idsSel.size) alert(`✅ ${idsSel.size} documento${idsSel.size !== 1 ? "s" : ""} eliminado${idsSel.size !== 1 ? "s" : ""} permanentemente`);
          render();
        }
      );
      return;
    }},
  "bulk-change-state": (d, el, e) => {{
      const tipo = d.tipo;
      const selected = Object.keys(state.selectedDocs[tipo] || {});
      if (selected.length === 0) { alert("Selecciona al menos un documento"); return; }
      const estadosDisponibles = ESTADOS[tipo] || {};
      const opcionesHTML = Object.entries(estadosDisponibles)
        .map(([key, label]) => `<option value="${key}">${label}</option>`)
        .join("");
      state.modal = `
        <div data-action="close-modal-bg" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;z-index:1000;padding:11px;">
          <div data-action="prevent-close" style="background:white;border-radius:14px;width:450px;max-width:100%;box-shadow:0 20px 60px rgba(0,0,0,.2);">
            <div style="padding:11px;border-bottom:1px solid #e5e7eb;background:linear-gradient(135deg,#12264D,#2B4A82);">
              <h3 style="margin:0;font-size:16px;color:white;font-weight:700;">📋 Cambiar estado a ${selected.length} documento${selected.length !== 1 ? 's' : ''}</h3>
            </div>
            <div style="padding:14px;">
              <div style="margin-bottom:10px;">
                <label style="font-size:11.5px;font-weight:700;color:#374151;display:block;margin-bottom:8px;">Selecciona nuevo estado:</label>
                <select id="bulk-new-state" style="width:100%;padding:6px 10px;border:1px solid #d1d5db;border-radius:6px;font-size:14px;font-weight:500;">
                  <option value="">— Elige un estado —</option>
                  ${opcionesHTML}
                </select>
              </div>
              <div style="display:flex;gap:10px;justify-content:flex-end;">
                <button data-action="close-modal" style="background:#f3f4f6;border:none;color:#1f2937;padding:10px 24px;border-radius:6px;font-weight:600;cursor:pointer;font-size:14px;transition:background 0.2s;">Cancelar</button>
                <button data-action="confirm-bulk-state" data-tipo="${tipo}" style="background:#2B4A82;border:none;color:white;padding:10px 24px;border-radius:6px;font-weight:600;cursor:pointer;font-size:14px;transition:background 0.2s;">🔄 Cambiar estado</button>
              </div>
            </div>
          </div>
        </div>
      `;
      render();
      return;
    }},
  "confirm-bulk-state": async (d, el, e) => {{
      const tipo = d.tipo;
      const newState = document.getElementById("bulk-new-state").value;
      if (!newState) { alert("⚠️ Selecciona un nuevo estado"); return; }
      const selected = Object.keys(state.selectedDocs[tipo] || {});
      const info = DOC_INFO[tipo];
      const allDocs = state.data[info.key] || [];
      const rechazados = [];
      let cambiados = 0;
      for (const docId of selected) {
        const doc = allDocs.find(x => x.id === docId);
        if (!doc) continue;
        const estadoAnterior = doc.estado;
        doc.estado = newState;
        try {
          await aplicarCambioEstadoDoc(tipo, doc, newState);
          cambiados++;
        } catch (err) {
          // El que se rechaza vuelve a su estado y se nombra: en lote es peor
          // no decirlo, porque nadie revisa uno por uno lo que quedó igual.
          doc.estado = estadoAnterior;
          rechazados.push(`${doc.numero}: ${err.message || err}`);
        }
      }
      saveData(info.key, allDocs);
      state.selectedDocs[tipo] = {};
      state.modal = null;
      if (rechazados.length) alert("⚠️ No se cambiaron:\n\n" + rechazados.join("\n\n"));
      if (cambiados) alert(`✅ Estado actualizado para ${cambiados} documento${cambiados !== 1 ? 's' : ''}`);
      render();
      return;
    }},
  "sort-docs": (d, el, e) => {{
      if (!state.docSort) state.docSort = {};
      const tipo = d.tipo, field = d.field;
      const cur = state.docSort[tipo] || { field:"fecha", dir:"desc" };
      state.docSort[tipo] = (cur.field === field)
        ? { field, dir: cur.dir === "asc" ? "desc" : "asc" }
        : { field, dir: "desc" };
      render();
      return;
    }},
  "quick-change-state": (d, el, e) => {{
      const tipo = d.tipo;
      const docId = d.id;
      const estadosDisponibles = ESTADOS[tipo] || {};
      const opcionesHTML = Object.entries(estadosDisponibles)
        .map(([key, label]) => `<option value="${key}">${label}</option>`)
        .join("");
      state.modal = `
        <div data-action="close-modal-bg" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;z-index:1000;padding:11px;">
          <div data-action="prevent-close" style="background:white;border-radius:14px;width:450px;max-width:100%;box-shadow:0 20px 60px rgba(0,0,0,.2);">
            <div style="padding:11px;border-bottom:1px solid #e5e7eb;background:linear-gradient(135deg,#12264D,#2B4A82);">
              <h3 style="margin:0;font-size:16px;color:white;font-weight:700;">🎯 Cambiar estado del documento</h3>
            </div>
            <div style="padding:14px;">
              <div style="margin-bottom:10px;">
                <label style="font-size:11.5px;font-weight:700;color:#374151;display:block;margin-bottom:8px;">Nuevo estado:</label>
                <select id="quick-new-state" style="width:100%;padding:6px 10px;border:1px solid #d1d5db;border-radius:6px;font-size:14px;font-weight:500;">
                  <option value="">— Elige un estado —</option>
                  ${opcionesHTML}
                </select>
              </div>
              <div style="display:flex;gap:10px;justify-content:flex-end;">
                <button data-action="close-modal" style="background:#f3f4f6;border:none;color:#1f2937;padding:10px 24px;border-radius:6px;font-weight:600;cursor:pointer;font-size:14px;">Cancelar</button>
                <button data-action="confirm-quick-state" data-tipo="${tipo}" data-id="${docId}" style="background:#10b981;border:none;color:white;padding:10px 24px;border-radius:6px;font-weight:600;cursor:pointer;font-size:14px;">✅ Cambiar</button>
              </div>
            </div>
          </div>
        </div>
      `;
      render();
      return;
    }},
  "confirm-quick-state": async (d, el, e) => {{
      const tipo = d.tipo;
      const docId = d.id;
      const newState = document.getElementById("quick-new-state").value;
      if (!newState) { alert("⚠️ Selecciona un nuevo estado"); return; }
      const info = DOC_INFO[tipo];
      const allDocs = state.data[info.key] || [];
      const doc = allDocs.find(x => x.id === docId);
      if (doc) {
        // El estado se pone ANTES de aplicar sus efectos (los asientos y el
        // kardex lo leen del documento), así que si algo se rechaza hay que
        // devolverlo: si no, el documento queda mutado en memoria con un estado
        // que nunca se guardó, y sin que nadie diga qué pasó.
        const estadoAnterior = doc.estado;
        doc.estado = newState;
        try {
          await aplicarCambioEstadoDoc(tipo, doc, newState);
        } catch (err) {
          doc.estado = estadoAnterior;
          state.modal = null;
          render();
          alert("⚠️ " + (err.message || err));
          return;
        }
        saveData(info.key, allDocs);
        state.modal = null;
        render();
      }
      return;
    }},
});
